<template>
  <div
    id="institutionCustomer"
    :class="$style.container"
    v-loading.fullscreen.lock.body="loading"
    element-loading-text="拼命加载中"
    element-loading-spinner="el-icon-loading"
    element-loading-background="rgba(0, 0, 0, 0.8)"
  >
    <div style="background-color: #fff; height: auto">
      <header style="position: relative; padding-bottom: 10px">
        <el-row style="position: absolute; left: 0; width: 200px">
          <el-col :span="12">
            <div style="padding-top: 8px; font-size: 20px">客户管理</div>
          </el-col>
        </el-row>
        <div style="width: 389px; margin: 0 auto">
          <el-button-group>
            <el-button
              style="
                color: #409eff;
                border-color: #c6e2ff;
                background-color: #ecf5ff;
              "
              >地图模式</el-button
            >
            <el-button @click="dianji">医疗机构</el-button>
            <el-button @click="dianji1">零售终端</el-button>
            <el-button @click="dianji2">分销客户</el-button>
          </el-button-group>
        </div>
      </header>
    </div>

    <div style="height: calc(100% - 40px); width: 100%; display: flex">
      <el-container
        :style="{
          width: is_shrinkage ? '0' : '25%',
          height: '100%',
          padding: '0',
          position: 'relative',
          flexShrink: '0',
          flexGrow: '0',
        }"
      >
        <div
          class="shrinkage"
          :title="is_shrinkage ? '展开' : '收起'"
          @click="is_shrinkage = !is_shrinkage"
        >
          <i v-if="is_shrinkage" class="el-icon-d-arrow-right"></i>
          <i v-else class="el-icon-d-arrow-left"></i>
        </div>

        <div style="width: 100%">
          <!--                    <div style="font-size: 18px;color: #000;" >-->

          <!--                        <el-row style="margin-top: 10px">-->
          <!--                            <el-col :span="12">-->
          <!--                                <el-button type="primary" size="small" icon="el-icon-download" style="" @click="showModalAction">导入导出</el-button>-->
          <!--                            </el-col>-->

          <!--                            <el-col :span="12">-->
          <!--                                <el-button type="success" size="small" icon="el-icon-plus" style="float: right;" @click="xinzeng">新增机构</el-button>-->
          <!--                            </el-col>-->
          <!--                        </el-row>-->
          <!--                    </div>-->

          <div
            ref="scrollbar"
            style="
              border: 1px solid #dedede;
              width: 100%;
              height: calc(100% - 10px);
            "
            @click.stop=""
          >
            <el-row
              style="
                border-bottom: 1px solid #dedede;
                overflow: hidden;
                height: 100%;
              "
            >
              <el-autocomplete
                v-model="filterText"
                placeholder="请输入名称进行快速搜索"
                :fetch-suggestions="search"
                @select="handleSelect"
                class="Myinput"
                style="display: flex; justify-content: center"
              >
                <div
                  slot-scope="{ item }"
                  style="height: 50px; border-bottom: 1px solid #ededed"
                >
                  <div style="font-size: 14px; color: #555555; height: 22px">
                    {{ item.name }}
                  </div>
                  <div
                    style="
                      font-size: 11px;
                      color: #ccc;
                      float: left;
                      height: 18px;
                    "
                  >
                    {{ item.address }}
                  </div>
                </div>
              </el-autocomplete>

              <el-row
                class="treeClass"
                style="
                  width: 158px;
                  float: left;
                  border-right: 1px solid #ededed;
                  overflow-y: auto;
                  overflow-x: hidden;
                  height: calc(100% - 41px);
                "
              >
                <div style="">
                  <el-tree
                    :data="data"
                    :props="defaultProps"
                    @node-click="handleNodeClick"
                    node-key="id"
                    :default-expanded-keys="[province_id, city_id]"
                    :current-node-key="node_key"
                    class="SizeClass"
                    :highlight-current="true"
                    ref="tree"
                  >
                    <span style="font-size: 14px" slot-scope="{ node, data }">
                      <img
                        src="../../assets/images/tu1.png"
                        alt=""
                        v-if="node.level === 1"
                        style="height: 16.23px; position: relative; top: 3px"
                      />
                      <img
                        src="../../assets/images/tu2.png"
                        alt=""
                        v-if="node.level === 2"
                        style="height: 16.23px"
                      />
                      <span :class="$style.font">{{ node.label }}</span>
                    </span>
                  </el-tree>
                </div>
              </el-row>

              <div
                class="constrution-tree2"
                ref="_treeBox"
                @scroll="throttle(loadTreeItem($event), 100, 500)"
                style="
                  overflow-y: auto;
                  overflow-x: hidden;
                  height: calc(100% - 41px);
                "
              >
                <div style="">
                  <el-tree
                    node-key="id"
                    :default-expanded-keys="[institution_id]"
                    :current-node-key="institution_id"
                    :data="data2"
                    :props="defaultProps"
                    @node-click="handleNodeClick2"
                    class="SizeClass2"
                    :highlight-current="true"
                    ref="tree2"
                  >
                    <span style="" slot-scope="{ node, data }">
                      <span style="font-size: 14px; margin-left: -10px">{{
                        node.label
                      }}</span>
                    </span>
                  </el-tree>
                </div>
              </div>
              <div class="clear" style="clear: both"></div>
            </el-row>
          </div>
        </div>
      </el-container>

      <div
        style="
          overflow: auto;
          height: calc(100% - 10px);
          border: 1px solid #dedede;
          position: relative;
          flex-grow: 1;
        "
      >
        <el-amap
          vid="staffAmap"
          ref="staffAmap"
          :plugin="plugin"
          class="amap-demo"
          :events="events"
          style="width: 100%; margin-top: 0; height: 100%"
          :center="center"
          :zoom="zoom"
          :amapManager="amapManager"
        >
          <!--          <el-amap-marker-->
          <!--              :position="marker.position" :template="marker.template" v-for="marker in centers" :events="marker.events"-->
          <!--              :visible="marker.visible">-->
          <!--          </el-amap-marker>-->
        </el-amap>
        <div v-if="detailsBox">
          <div
            v-if="InstituionList[0].category == 'INSTITUTION'"
            style="
              width: 400px;
              background: #fff;
              margin-right: 20px;
              position: absolute;
              top: 55%;
              left: 50%;
            "
          >
            <el-row>
              <el-row :span="24">
                <el-col
                  :span="20"
                  style="
                    overflow: hidden;
                    text-overflow: ellipsis;
                    white-space: nowrap;
                    height: 35px;
                  "
                >
                  <span
                    :style="{
                      color: '#4D586D',
                      fontSsize: '15px',
                      paddingLeft: '20px',
                      position: 'relative',
                      top: '12px',
                    }"
                  >
                    {{ InstituionList[0].institution_name }}
                  </span>
                </el-col>
                <el-col
                  :span="4"
                  style="
                    font-size: 12px;
                    color: #ff9901;
                    position: relative;
                    top: 15px;
                    cursor: pointer;
                    z-index: 99;
                  "
                  @click.native="details(InstituionList[0])"
                >
                  查看详情
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="22">
                  <span
                    style="
                      padding-left: 19px;
                      font-size: 13px;
                      color: #b0b5b9;
                      overflow: hidden;
                      text-overflow: ellipsis;
                      white-space: nowrap;
                      display: inline-block;
                      width: 80%;
                    "
                  >
                    {{ InstituionList[0].address }}
                  </span>
                </el-col>
                <el-col :span="1" style="padding-right: 16px; color: #b0b5b9">
                  <img src="../../assets/images/tu4.png" alt="" />
                </el-col>
              </el-row>
              <el-row style="margin-top: 10px; margin-bottom: 10px">
                <el-col :span="15">
                  <span
                    style="color: #7ed321; font-size: 13px; padding-left: 19px"
                    v-if="InstituionList[0].institution_grade != ''"
                  >
                    {{ InstituionList[0].institution_grade }} ｜
                    医务人员总数：{{ InstituionList[0].target_num }}人
                  </span>
                  <span
                    style="color: #7ed321; font-size: 13px; padding-left: 19px"
                    v-else-if="InstituionList[0].institution_grade == ''"
                  >
                    医务人员总数：{{ InstituionList[0].target_num }}人
                  </span>
                </el-col>
              </el-row>
            </el-row>
          </div>
          <div
            v-if="InstituionList[0].category == 'RETAILSTORE'"
            style="
              width: 400px;
              background: #fff;
              margin-right: 20px;
              position: absolute;
              top: 55%;
              left: 50%;
            "
          >
            <el-row>
              <el-row :span="24">
                <el-col :span="20">
                  <span
                    :style="{
                      color: '#4D586D',
                      fontSsize: '15px',
                      position: 'relative',
                      top: '12px',
                      left: '21px',
                    }"
                    style="
                      overflow: hidden;
                      text-overflow: ellipsis;
                      white-space: nowrap;
                      display: inline-block;
                      width: 270px;
                    "
                  >
                    {{ InstituionList[0].store_name }}
                  </span>
                </el-col>
                <el-col
                  :span="4"
                  style="
                    font-size: 12px;
                    color: #ff9901;
                    position: relative;
                    top: 15px;
                    cursor: pointer;
                    z-index: 99;
                  "
                  @click.native="details(InstituionList[0])"
                >
                  查看详情
                </el-col>
              </el-row>
              <el-row style="margin-top: 20px">
                <el-col :span="20">
                  <span
                    style="
                      position: relative;
                      left: 19px;
                      font-size: 13px;
                      color: #b0b5b9;
                      overflow: hidden;
                      text-overflow: ellipsis;
                      white-space: nowrap;
                      display: inline-block;
                      width: 80%;
                    "
                  >
                    {{ InstituionList[0].address }}
                  </span>
                </el-col>
                <el-col
                  :span="4"
                  style="padding-right: 16px; color: #b0b5b9; float: right"
                >
                  <img
                    src="../../assets/images/tu4.png"
                    alt=""
                    style="float: right; margin-top: 4px"
                  />
                </el-col>
              </el-row>
              <el-row style="margin-top: 10px; margin-bottom: 10px">
                <el-col :span="15">
                  <span
                    style="color: #7ed321; font-size: 13px; padding-left: 19px"
                    v-if="InstituionList[0].retailstore_grade_name != ''"
                  >
                    {{ InstituionList[0].retailstore_grade_name }} ｜
                    店员总数：{{ InstituionList[0].clerk_num }}人
                  </span>
                  <span
                    style="color: #7ed321; font-size: 13px; padding-left: 19px"
                    v-else-if="InstituionList[0].retailstore_grade_name == ''"
                  >
                    店员总数：{{ InstituionList[0].clerk_num }}人
                  </span>
                </el-col>
              </el-row>
            </el-row>
          </div>
          <div
            v-if="InstituionList[0].category == 'DISTRIBUTOR'"
            style="
              width: 400px;
              background: #fff;
              margin-right: 20px;
              position: absolute;
              top: 55%;
              left: 50%;
            "
          >
            <el-row :span="24">
              <el-col
                :span="20"
                :style="{
                  color: '#4D586D',
                  fontSsize: '15px',
                  paddingLeft: '20px',
                }"
              >
                <el-col :span="22" style="padding-top: 10px">
                  <p style="margin: 0; display: inline-block">
                    {{ InstituionList[0].distributor_name }}
                  </p>
                </el-col>
              </el-col>
              <el-col
                :span="4"
                style="
                  font-size: 12px;
                  color: #ff9901;
                  position: relative;
                  top: 15px;
                  cursor: pointer;
                  z-index: 99;
                "
                @click.native="details(InstituionList[0])"
              >
                查看详情
              </el-col>
            </el-row>
            <el-row style="margin-top: 10px; margin-bottom: 10px">
              <el-col :span="23">
                <span
                  style="
                    padding-left: 19px;
                    font-size: 13px;
                    color: #b0b5b9;
                    overflow: hidden;
                    text-overflow: ellipsis;
                    white-space: nowrap;
                    display: inline-block;
                    width: 80%;
                  "
                >
                  {{ InstituionList[0].address }}
                </span>
              </el-col>
              <el-col :span="1" style="padding-right: 16px; color: #b0b5b9">
                <img src="../../assets/images/tu4.png" alt="" />
              </el-col>
            </el-row>
            <el-row style="margin-top: 10px; margin-bottom: 10px">
              <el-col :span="15">
                <span
                  style="color: #7ed321; font-size: 13px; padding-left: 19px"
                  v-if="InstituionList[0].distributor_grade_name != ''"
                >
                  {{ InstituionList[0].distributor_grade_name }} ｜
                  联系人总数：{{ InstituionList[0].contact_count }}人
                </span>
                <span
                  style="color: #7ed321; font-size: 13px; padding-left: 19px"
                  v-else-if="InstituionList[0].distributor_grade_name == ''"
                >
                  联系人总数：{{ InstituionList[0].contact_count }}人
                </span>
              </el-col>
            </el-row>
          </div>
        </div>

        <div
          v-if="detailsOff"
          style="
            width: 440px;
            height: calc(100% - 60px);
            background: #fff;
            border: 1px solid #ededed;
            position: absolute;
            top: 30px;
            left: 40px;
          "
        >
          <div
            v-if="category == 'INSTITUTION'"
            style="
              height: 100%;
              width: 100%;
              position: relative;
              display: flex;
              flex-direction: column;
            "
          >
            <div style="width: 100%; flex-shrink: 0">
              <div
                style="
                  width: calc(100% - 40px);
                  height: 50px;
                  border-bottom: 2px dotted #e7eaec;
                  margin: 0 20px;
                  display: flex;
                  align-items: center;
                "
              >
                <p
                  :title="insList.institution_name"
                  style="
                    color: #2b92fa;
                    font-weight: 500;
                    overflow: hidden;
                    flex-grow: 1;
                    text-overflow: ellipsis;
                    white-space: nowrap;
                  "
                >
                  {{ insList.institution_name }}
                </p>

                <el-button
                  type="danger"
                  size="small"
                  @click="detailsOffClick"
                  style="flex-shrink: 0; background: #ed3b3f"
                >
                  关闭
                </el-button>
              </div>
              <el-row style="padding: 15px 20px 5px 20px">
                <el-col :span="8" style="font-weight: 500"> 名称 </el-col>
                <el-col :span="16" style="color: #2b92fa; font-weight: 500">
                  {{ insList.institution_name }}
                </el-col>
              </el-row>
              <el-row style="padding: 15px 20px 5px 20px">
                <el-col :span="8" style="font-weight: 500"> 类别 </el-col>
                <el-col :span="16" style="color: #888">
                  {{ insList.institution_type_name }}
                </el-col>
              </el-row>
              <el-row style="padding: 15px 20px 5px 20px">
                <el-col :span="8" style="font-weight: 500"> 级别 </el-col>
                <el-col :span="16" style="color: #888">
                  {{ insList.institution_grade_name }}
                </el-col>
              </el-row>
              <el-row style="padding: 15px 20px 5px 20px">
                <el-col :span="8" style="font-weight: 500"> 地址 </el-col>
                <el-col :span="16" style="color: #888">
                  {{ insList.address }}
                </el-col>
              </el-row>
              <el-row style="padding: 15px 20px 5px 20px">
                <el-col :span="8" style="font-weight: 500"> 联系电话 </el-col>
                <el-col :span="16" style="color: #888">
                  {{ insList.telephone }}
                </el-col>
                <el-col
                  :span="24"
                  style="
                    color: #ff9901;
                    padding-top: 10px;
                    font-size: 13px;
                    text-align: right;
                    cursor: pointer;
                    z-index: 999;
                  "
                  @click.native="insInfoClick"
                >
                  查看所有属性
                </el-col>
              </el-row>
            </div>

            <div
              style="
                width: 100%;
                flex-grow: 1;
                overflow: hidden;
                padding-bottom: 10px;
                box-sizing: border-box;
              "
            >
              <el-row
                style="width: calc(100% - 40px); height: 50px; margin: 0 20px"
              >
                <el-col
                  :span="20"
                  style="color: #2b92fa; line-height: 48px; font-weight: 500"
                >
                  HCP列表
                </el-col>
              </el-row>
              <el-row
                class="tableClass"
                style="padding: 0 20px; height: calc(100% - 52px)"
              >
                <el-col :span="24" style="height: 100%">
                  <el-tabs
                    v-model="activeName"
                    @tab-click="handleClick"
                    style="height: 100%"
                  >
                    <el-tab-pane
                      :label="item.dept_name + '(' + item.hcpArray.length + ')'"
                      :name="item.standard_dept"
                      v-for="(item, index) in DeptList"
                      :key="index"
                      style="height: 100%"
                    >
                      <div
                        style="
                          display: flex;
                          flex-wrap: wrap;
                          background-color: #fff;
                          align-content: flex-start;
                          overflow-y: auto;
                          height: 100%;
                          padding: 0 3px;
                        "
                      >
                        <div
                          style="
                            border: 1px solid #ededed;
                            width: 100%;
                            margin-top: 15px;
                            height: 100px;
                            display: flex;
                          "
                          v-for="item2 in item.hcpArray"
                        >
                          <div
                            style="
                              flex-shrink: 0;
                              padding: 0 15px;
                              height: 100%;
                              width: 58px;
                              display: flex;
                              align-content: center;
                              flex-wrap: wrap;
                              justify-content: center;
                            "
                          >
                            <img
                              src="../../assets/images/chat_header_image.png"
                              alt=""
                              style="width: 58px; height: 58px"
                            />
                            <div
                              style="padding: 4px 0 4px 0"
                              v-if="item2.account_status == 'ACTIVE'"
                            >
                              <!--                              v-if="item2.account_status=='ACTIVE'"-->
                              <span
                                style="
                                  color: #ff6f61;
                                  font-size: 10px;
                                  border-bottom: #ff6f61 3px double;
                                "
                              >
                                目标客户
                              </span>
                            </div>
                          </div>
                          <div
                            style="
                              width: calc(100% - 80px);
                              height: 100%;
                              float: right;
                              position: relative;
                            "
                          >
                            <p
                              style="
                                margin: 10px 0 0 0;
                                display: flex;
                                align-items: center;
                              "
                            >
                              <!--                                                            <span v-if="item2.segment_name==''"> </span>-->
                              <!--                                                            <span style="color: #fff;border: #3998f7 1px solid;background-color: #3998f7;padding: 0px 5px"-->
                              <!--                                                                  v-else>{{item2.segment_name}}</span>-->
                              <span style="color: #4d586d; font-size: 15px">{{
                                item2.hcp_name
                              }}</span>
                              <!--                           v-if="item2.pro_title_name!==''"-->
                              <span
                                v-if="item2.pro_title_name !== ''"
                                style="
                                  color: #fff;
                                  background-color: #ff9901;
                                  border: 1px solid #ff9901;
                                  border-radius: 5px;
                                  font-size: 11px;
                                  padding: 4px 6px;
                                  margin-left: 8px;
                                "
                                >{{ item2.pro_title_name }}</span
                              >

                              <span
                                style="
                                  color: #ff9901;
                                  position: absolute;
                                  right: 0;
                                  margin-right: 5px;
                                  font-size: 13px;
                                  cursor: pointer;
                                "
                                @click="hcpClickInfo(item2)"
                                >编辑</span
                              >
                            </p>
                            <p style="margin: 4px 0">
                              <span style="font-size: 13px; color: #b0b5b9"
                                >{{ item2.job_title_name || "" }}
                                {{
                                  item2.job_title_name && item2.dept_name
                                    ? "|"
                                    : ""
                                }}
                                {{ item2.dept_name || "" }}</span
                              >
                            </p>
                            <p
                              style="
                                margin: 6px 0 0 0;
                                display: flex;
                                align-items: center;
                              "
                            >
                              <img src="../../assets/images/tu5.png" alt="" />
                              <span
                                :style="{
                                  color: item2.mobile ? '#B0B5B9' : '#ED3B3F',
                                  fontSize: '13px',
                                  marginLeft: '6px',
                                }"
                                >{{ item2.mobile || "暂无手机号" }}</span
                              >
                            </p>
                            <p style="margin: 0; text-align: right">
                              <!--<span style="color:#7ED321;font-size: 13px">-->
                              <!--倡导者-->
                              <!--</span>-->
                              <span
                                style="
                                  color: #4a90e2;
                                  font-size: 13px;
                                  margin-right: 40px;
                                  margin-top: 8px;
                                "
                                v-if="
                                  item2.call_count > 0 &&
                                  item2.campaign_count > 0
                                "
                              >
                                本月已覆盖（{{ item2.call_count }}、{{
                                  item2.campaign_count
                                }})
                              </span>
                              <span
                                style="
                                  color: #4a90e2;
                                  font-size: 13px;
                                  margin-right: 40px;
                                  margin-top: 8px;
                                "
                                v-else-if="item2.call_count > 0"
                              >
                                本月已覆盖（{{ item2.call_count }})
                              </span>
                              <span
                                style="
                                  color: #4a90e2;
                                  font-size: 13px;
                                  margin-right: 40px;
                                  margin-top: 8px;
                                "
                                v-else-if="item2.campaign_count > 0"
                              >
                                本月已覆盖（{{ item2.campaign_count }})
                              </span>
                              <span
                                style="
                                  color: #ed3b3f;
                                  font-size: 13px;
                                  margin-right: 40px;
                                "
                                v-else
                              >
                                本月尚未覆盖
                              </span>
                            </p>
                          </div>
                        </div>
                      </div>
                    </el-tab-pane>
                  </el-tabs>
                </el-col>
              </el-row>
            </div>
          </div>
          <div
            v-if="category == 'RETAILSTORE'"
            style="
              height: 100%;
              width: 100%;
              position: relative;
              display: flex;
              flex-direction: column;
            "
          >
            <div style="width: 100%; flex-shrink: 0">
              <div
                style="
                  width: calc(100% - 40px);
                  height: 50px;
                  border-bottom: 2px dotted #e7eaec;
                  margin: 0 20px;
                  display: flex;
                  align-items: center;
                "
              >
                <p
                  :title="storelist.store_name"
                  style="
                    color: #2b92fa;
                    font-weight: 500;
                    overflow: hidden;
                    flex-grow: 1;
                    text-overflow: ellipsis;
                    white-space: nowrap;
                  "
                >
                  {{ storelist.store_name }}
                </p>

                <el-button
                  type="danger"
                  size="small"
                  @click="detailsOffClick"
                  style="flex-shrink: 0; background: #ed3b3f"
                >
                  关闭
                </el-button>
              </div>
              <el-row style="padding: 15px 20px 5px 20px">
                <el-col :span="8" style="font-weight: 500"> 名称 </el-col>
                <el-col :span="16" style="color: #2b92fa; font-weight: 500">
                  {{ storelist.store_name }}
                </el-col>
              </el-row>
              <el-row style="padding: 15px 20px 5px 20px">
                <el-col :span="8" style="font-weight: 500"> 类别 </el-col>
                <el-col :span="16" style="color: #888">
                  {{ storelist.store_type_name }}
                </el-col>
              </el-row>
              <el-row style="padding: 15px 20px 5px 20px">
                <el-col :span="8" style="font-weight: 500"> 级别 </el-col>
                <el-col :span="16" style="color: #888">
                  {{ storelist.retailstore_grade_name }}
                </el-col>
              </el-row>
              <el-row style="padding: 15px 20px 5px 20px">
                <el-col :span="8" style="font-weight: 500"> 地址 </el-col>
                <el-col :span="16" style="color: #888">
                  {{ storelist.address }}
                </el-col>
              </el-row>
              <el-row style="padding: 15px 20px 5px 20px">
                <el-col :span="8" style="font-weight: 500"> 联系电话 </el-col>
                <el-col :span="16" style="color: #888">
                  {{ storelist.telephone }}
                </el-col>
                <el-col
                  :span="24"
                  style="
                    color: #ff9901;
                    padding-top: 10px;
                    font-size: 13px;
                    text-align: right;
                    cursor: pointer;
                    z-index: 999;
                  "
                  @click.native="storeInfoClick"
                >
                  查看所有属性
                </el-col>
              </el-row>
            </div>
            <div
              style="
                width: 100%;
                flex-grow: 1;
                overflow: hidden;
                padding-bottom: 10px;
                box-sizing: border-box;
              "
            >
              <el-row
                style="
                  width: calc(100% - 40px);
                  height: 50px;
                  border-bottom: 2px dotted #e7eaec;
                  margin: 0 20px;
                "
              >
                <el-col
                  :span="20"
                  style="color: #2b92fa; line-height: 48px; font-weight: 500"
                >
                  店员列表
                </el-col>
              </el-row>
              <el-row
                class="tableClass"
                style="padding: 0 20px; height: calc(100% - 50px)"
              >
                <div
                  style="
                    display: flex;
                    flex-wrap: wrap;
                    background-color: #fff;
                    align-content: flex-start;
                    overflow-y: auto;
                    height: 100%;
                    padding: 0 3px;
                  "
                >
                  <div
                    style="
                      border: 1px solid #ededed;
                      width: 100%;
                      margin-top: 15px;
                      height: 100px;
                      display: flex;
                    "
                    v-for="(item, index) in ClerkList"
                  >
                    <div
                      style="
                        flex-shrink: 0;
                        padding: 0 15px;
                        height: 100%;
                        width: 58px;
                        display: flex;
                        align-content: center;
                        flex-wrap: wrap;
                        justify-content: center;
                      "
                    >
                      <img
                        src="../../assets/images/chat_header_image.png"
                        alt=""
                        style="width: 58px; height: 58px"
                      />
                    </div>
                    <div
                      style="
                        width: calc(100% - 80px);
                        height: 100%;
                        float: right;
                        position: relative;
                      "
                    >
                      <p
                        style="
                          margin: 10px 0 0 0;
                          display: flex;
                          align-items: center;
                        "
                      >
                        <span style="color: #4d586d; font-size: 15px">{{
                          item.clerk_name
                        }}</span>
                        <span
                          style="
                            background-color: #ff9901;
                            color: #ffffff;
                            font-size: 11px;
                            border-radius: 3px;
                            padding: 2px 7px;
                            position: relative;
                            top: -2px;
                          "
                          v-if="item.manager_name == '店长'"
                          >{{ item.manager_name }}</span
                        >
                        <span
                          style="
                            color: #ff9901;
                            position: absolute;
                            right: 0;
                            margin-right: 5px;
                            font-size: 13px;
                            cursor: pointer;
                          "
                          @click="assistantPeople(item)"
                          >编辑</span
                        >
                      </p>
                      <p
                        style="
                          margin: 6px 0 0 0;
                          display: flex;
                          align-items: center;
                        "
                      >
                        <img src="../../assets/images/tu5.png" alt="" />
                        <span
                          :style="{
                            color: item.mobile ? '#B0B5B9' : '#ED3B3F',
                            fontSize: '13px',
                            marginLeft: '6px',
                          }"
                          >{{ item.mobile || "暂无手机号" }}</span
                        >
                      </p>
                    </div>
                  </div>
                </div>
              </el-row>
            </div>
          </div>
          <div
            v-if="category == 'DISTRIBUTOR'"
            style="
              height: 100%;
              width: 100%;
              position: relative;
              display: flex;
              flex-direction: column;
            "
          >
            <div style="width: 100%; flex-shrink: 0">
              <div
                style="
                  width: calc(100% - 40px);
                  height: 50px;
                  border-bottom: 2px dotted #e7eaec;
                  margin: 0 20px;
                  display: flex;
                  align-items: center;
                "
              >
                <p
                  :title="distributorlist.distributor_name"
                  style="
                    color: #2b92fa;
                    font-weight: 500;
                    overflow: hidden;
                    flex-grow: 1;
                    text-overflow: ellipsis;
                    white-space: nowrap;
                  "
                >
                  {{ distributorlist.distributor_name }}
                </p>

                <el-button
                  type="danger"
                  size="small"
                  @click="detailsOffClick"
                  style="flex-shrink: 0; background: #ed3b3f"
                >
                  关闭
                </el-button>
              </div>
              <el-row style="padding: 15px 20px 5px 20px">
                <el-col :span="8" style="font-weight: 500"> 名称 </el-col>
                <el-col :span="16" style="color: #2b92fa; font-weight: 500">
                  {{ distributorlist.distributor_name }}
                </el-col>
              </el-row>
              <el-row style="padding: 15px 20px 5px 20px">
                <el-col :span="8" style="font-weight: 500"> 类别 </el-col>
                <el-col :span="16" style="color: #888">
                  {{ distributorlist.distributor_type_name }}
                </el-col>
              </el-row>
              <el-row style="padding: 15px 20px 5px 20px">
                <el-col :span="8" style="font-weight: 500"> 级别 </el-col>
                <el-col :span="16" style="color: #888">
                  {{ distributorlist.distributor_grade_name }}
                </el-col>
              </el-row>
              <el-row style="padding: 15px 20px 5px 20px">
                <el-col :span="8" style="font-weight: 500"> 地址 </el-col>
                <el-col :span="16" style="color: #888">
                  {{ distributorlist.address }}
                </el-col>
              </el-row>
              <el-row style="padding: 15px 20px 5px 20px">
                <el-col :span="8" style="font-weight: 500"> 联系电话 </el-col>
                <el-col :span="16" style="color: #888">
                  {{ distributorlist.telephone }}
                </el-col>
                <el-col
                  :span="24"
                  style="
                    color: #ff9901;
                    padding-top: 10px;
                    font-size: 13px;
                    text-align: right;
                    cursor: pointer;
                    z-index: 999;
                  "
                  @click.native="disInfoClick"
                >
                  查看所有属性
                </el-col>
              </el-row>
            </div>
            <div
              style="
                width: 100%;
                flex-grow: 1;
                overflow: hidden;
                padding-bottom: 10px;
                box-sizing: border-box;
              "
            >
              <el-row
                style="
                  width: calc(100% - 40px);
                  height: 50px;
                  border-bottom: 2px dotted #e7eaec;
                  margin: 0 20px;
                "
              >
                <el-col
                  :span="20"
                  style="color: #2b92fa; line-height: 48px; font-weight: 500"
                >
                  联系人列表
                </el-col>
              </el-row>
              <el-row
                class="tableClass"
                style="padding: 0 20px; height: calc(100% - 50px)"
              >
                <div
                  style="
                    display: flex;
                    flex-wrap: wrap;
                    background-color: #fff;
                    align-content: flex-start;
                    overflow-y: auto;
                    height: 100%;
                    padding: 0 3px;
                  "
                >
                  <div
                    style="
                      border: 1px solid #ededed;
                      width: 100%;
                      margin-top: 15px;
                      height: 100px;
                      display: flex;
                    "
                    v-for="(item, index) in Contact"
                  >
                    <div
                      style="
                        flex-shrink: 0;
                        padding: 0 15px;
                        height: 100%;
                        width: 58px;
                        display: flex;
                        align-content: center;
                        flex-wrap: wrap;
                        justify-content: center;
                      "
                    >
                      <img
                        src="../../assets/images/chat_header_image.png"
                        alt=""
                        style="width: 58px; height: 58px"
                      />
                    </div>
                    <div
                      style="
                        width: calc(100% - 80px);
                        height: 100%;
                        float: right;
                        position: relative;
                      "
                    >
                      <p
                        style="
                          margin: 10px 0 0 0;
                          display: flex;
                          align-items: center;
                        "
                      >
                        <span style="color: #4d586d; font-size: 15px">{{
                          item.contact_name
                        }}</span>
                        <span
                          style="
                            color: #ff9901;
                            position: absolute;
                            right: 0;
                            margin-right: 5px;
                            font-size: 13px;
                            cursor: pointer;
                          "
                          @click="contactDetails(item)"
                          >编辑</span
                        >
                      </p>
                      <p style="margin: 4px 0">
                        <span style="font-size: 13px; color: #b0b5b9"
                          >{{ item.job_title || "" }}
                          {{ item.job_title && item.department ? "|" : "" }}
                          {{ item.department || "" }}</span
                        >
                      </p>
                      <p
                        style="
                          margin: 6px 0 0 0;
                          display: flex;
                          align-items: center;
                        "
                      >
                        <img src="../../assets/images/tu5.png" alt="" />
                        <span
                          :style="{
                            color: item.mobile ? '#B0B5B9' : '#ED3B3F',
                            fontSize: '13px',
                            marginLeft: '6px',
                          }"
                          >{{ item.mobile || "暂无手机号" }}</span
                        >
                      </p>
                    </div>
                  </div>
                </div>
              </el-row>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!--坐标信息报错 -->
    <el-dialog
      id="travelSavePlanPs"
      :visible.sync="dialogLoaction"
      :show-close="false"
      width="900px"
      style="vertical-align: center"
    >
      <div style="">
        <el-row style="margin-top: -30px">
          <el-col :span="12">
            <div style="color: #3998f7; padding-top: 8px; font-size: 20px">
              错误提示
            </div>
          </el-col>

          <el-col :span="12">
            <div align="right">
              <el-button
                type="primary"
                size="small"
                @click="handleExportData6()"
              >
                下载错误信息
              </el-button>
              <el-button
                type="danger"
                size="small"
                @click="dialogLoaction = false"
              >
                关闭
              </el-button>
            </div>
          </el-col>
        </el-row>
      </div>
      <div style="margin-top: 20px">
        <el-table border :data="locationDate">
          <el-table-column
            fixed
            type="index"
            :index="1"
            label="序号"
            width="65px"
          ></el-table-column>
          <el-table-column
            sortable
            property="code"
            label="机构编码"
            width="150"
          ></el-table-column>
          <el-table-column
            sortable
            property="institutions_name"
            label="机构名称"
            width="200"
          ></el-table-column>
          <el-table-column
            sortable
            property="address"
            label="地址"
          ></el-table-column>
          <el-table-column
            sortable
            property="longitude"
            label="经度"
          ></el-table-column>
          <el-table-column
            sortable
            property="latitude"
            label="纬度"
          ></el-table-column>
          <el-table-column
            fixed="right"
            width="250"
            sortable
            property="message"
            label="报错信息"
          >
            <template slot-scope="scope">
              <span style="color: red">
                {{ scope.row.message }}
              </span>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </el-dialog>
    <!--导入导出 -->
    <el-dialog
      :visible.sync="dialogVisible"
      width="700px"
      :show-close="false"
      style="vertical-align: center; :#FFF9F3 "
      :before-close="closeModal2"
    >
      <div style="margin-top: -40px">
        <el-row style="border-bottom: 2px dotted #e7eaec; padding-bottom: 10px">
          <el-col :span="12">
            <div style="color: #3998f7; padding-top: 8px; font-size: 20px">
              数据导入与导出
            </div>
          </el-col>

          <el-col :span="12">
            <div align="right">
              <el-button type="danger" size="small" @click="closeModal2">
                关闭
              </el-button>
            </div>
          </el-col>
        </el-row>
        <div class="subjectList" style="margin-top: 20px">
          <el-form
            ref="form"
            label-width="160px"
            :model="form"
            style="font-size: 14px"
          >
            <el-row style="margin-left: 10px">
              <el-col>
                <el-form-item label="下载机构数据">
                  <el-select
                    v-model="form.name"
                    placeholder="请选择省份"
                    style="float: left"
                  >
                    <el-option
                      v-for="item in dataList"
                      :key="item.id"
                      :label="item.label"
                      :value="item.id"
                      :change="changeInstitution()"
                    >
                    </el-option>
                  </el-select>

                  <el-button
                    type="primary"
                    size="small"
                    style="margin-left: 21px"
                    @click="xiazai"
                    >下载</el-button
                  >

                  <span
                    style="font-size: 14px; color: #585757; margin-left: 11px"
                  >
                    <i class="el-icon-document"></i
                    >{{ institutionData_name + ".xls" }}
                  </span>
                </el-form-item>
              </el-col>
            </el-row>

            <el-row style="margin-left: 10px">
              <el-col>
                <el-form-item label="下载签到位置">
                  <el-select
                    v-model="form.position"
                    placeholder="请选择省份"
                    style="float: left"
                    clearable
                  >
                    <el-option
                      v-for="item in dataList"
                      :key="item.id"
                      :label="item.label"
                      :value="item.id"
                      :change="changeInstitution1()"
                    >
                    </el-option>
                  </el-select>

                  <el-button
                    type="primary"
                    size="small"
                    style="margin-left: 21px"
                    @click="xiazai3"
                    >下载</el-button
                  >

                  <span
                    style="font-size: 14px; color: #585757; margin-left: 11px"
                  >
                    <i class="el-icon-document"></i
                    >{{ institutionData_location + ".xls" }}
                  </span>
                </el-form-item>
              </el-col>
            </el-row>

            <el-row style="margin-left: 10px">
              <el-col>
                <el-form-item label="下载HCP数据">
                  <el-select
                    v-model="form.title"
                    placeholder="请选择省份"
                    style="float: left"
                    clearable
                  >
                    <el-option
                      v-for="item in dataList"
                      :key="item.id"
                      :label="item.label"
                      :value="item.id"
                      :change="changeInstitution2()"
                    >
                    </el-option>
                  </el-select>

                  <el-button
                    type="primary"
                    size="small"
                    style="margin-left: 21px"
                    @click="xiazai2"
                    >下载</el-button
                  >

                  <span
                    style="font-size: 14px; color: #585757; margin-left: 11px"
                  >
                    <i class="el-icon-document"></i
                    >{{ institutionData_hcp + ".xls" }}
                  </span>
                </el-form-item>
              </el-col>
            </el-row>

            <el-row style="margin-left: 10px; margin-top: 30px">
              <el-col>
                <el-form-item label="机构数据模板">
                  <el-button type="primary" size="small">
                    <a
                      style="text-decoration: none; color: #ffff"
                      href="../../../static/医疗机构-机构导入.xlsx"
                      download="医疗机构-机构导入.xlsx"
                      >下载</a
                    >
                  </el-button>

                  <span
                    style="font-size: 14px; color: #585757; margin-left: 11px"
                  >
                    <i class="el-icon-document"></i>机构数据导入模板.xls
                  </span>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row style="margin-left: 10px">
              <el-col :span="4">
                <el-form-item label="上传机构数据"> </el-form-item>
              </el-col>
              <el-col :span="10" style="margin-left: 53px; margin-top: 3px">
                <div style="border: 1px solid #ededed; height: 30px">
                  <span style="position: relative; top: 8px; left: 5px">{{
                    file
                  }}</span>
                </div>
              </el-col>
              <el-col :span="8" style="margin-top: 3px; padding-left: 24px">
                <el-upload
                  class="upload-demo"
                  ref="upload"
                  action="/wapi/v1/uploads"
                  :file-list="fileList"
                  :show-file-list="false"
                  :on-change="handleChange"
                  :on-success="handleSuccess"
                  :limit="1"
                  :auto-upload="false"
                >
                  <el-button
                    slot="trigger"
                    size="small"
                    style="
                      background-color: #7ed321;
                      border: 1px solid #7ed321;
                      color: white;
                    "
                    >选择文件
                  </el-button>
                  <el-button
                    style="margin-left: 10px"
                    size="small"
                    type="warning"
                    @click="imortDataClick"
                    >导入数据
                  </el-button>
                </el-upload>
              </el-col>
            </el-row>

            <el-row style="margin-left: 10px; margin-top: 30px">
              <el-col>
                <el-form-item label="签到位置模板">
                  <el-button type="primary" size="small">
                    <a
                      style="text-decoration: none; color: #ffff"
                      href="../../../static/机构坐标导入.xlsx"
                      download="机构坐标导入.xlsx"
                      >下载</a
                    >
                  </el-button>

                  <span
                    style="font-size: 14px; color: #585757; margin-left: 11px"
                  >
                    <i class="el-icon-document"></i>签到位置导入模板.xls
                  </span>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row style="margin-left: 10px">
              <el-col :span="4">
                <el-form-item label="上传签到位置"> </el-form-item>
              </el-col>
              <el-col :span="10" style="margin-left: 53px; margin-top: 3px">
                <div style="border: 1px solid #ededed; height: 30px">
                  <span style="position: relative; top: 8px; left: 5px">{{
                    file2
                  }}</span>
                </div>
              </el-col>
              <el-col :span="8" style="margin-top: 3px; padding-left: 24px">
                <el-upload
                  class="upload-demo"
                  ref="upload4"
                  action="/wapi/v1/uploads"
                  :file-list="fileList4"
                  :show-file-list="false"
                  :on-change="handleChange4"
                  :on-success="handleSuccess4"
                  :limit="1"
                  :auto-upload="false"
                >
                  <el-button
                    slot="trigger"
                    size="small"
                    style="
                      background-color: #7ed321;
                      border: 1px solid #7ed321;
                      color: white;
                    "
                    >选择文件
                  </el-button>
                  <el-button
                    style="margin-left: 10px"
                    size="small"
                    type="warning"
                    @click="imortDataClick4"
                    >导入数据
                  </el-button>
                </el-upload>
              </el-col>
            </el-row>

            <el-row style="margin-left: 10px; margin-top: 30px">
              <el-col>
                <el-form-item label="HCP数据模板">
                  <el-button type="primary" size="small">
                    <a
                      style="text-decoration: none; color: #ffff"
                      href="../../../static/医疗机构-HCP导入.xlsx"
                      download="医疗机构-HCP导入.xlsx"
                      >下载</a
                    >
                  </el-button>

                  <span
                    style="font-size: 14px; color: #585757; margin-left: 11px"
                  >
                    <i class="el-icon-document"></i>HCP数据导入模板.xls
                  </span>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row style="margin-left: 10px">
              <el-col :span="4">
                <el-form-item label="上传HCP数据"> </el-form-item>
              </el-col>
              <el-col :span="10" style="margin-left: 53px; margin-top: 3px">
                <div style="border: 1px solid #ededed; height: 30px">
                  <span style="position: relative; top: 8px; left: 5px">{{
                    file3
                  }}</span>
                </div>
              </el-col>
              <el-col :span="8" style="margin-top: 3px; padding-left: 24px">
                <el-upload
                  class="upload-demo"
                  ref="upload2"
                  action="/wapi/v1/uploads"
                  :file-list="fileList2"
                  :show-file-list="false"
                  :on-change="handleChange2"
                  :on-success="handleSuccess2"
                  :limit="1"
                  :auto-upload="false"
                >
                  <el-button
                    slot="trigger"
                    size="small"
                    style="
                      background-color: #7ed321;
                      border: 1px solid #7ed321;
                      color: white;
                    "
                    >选择文件
                  </el-button>
                  <el-button
                    style="margin-left: 10px"
                    size="small"
                    type="warning"
                    @click="imortDataClick2"
                    >导入数据
                  </el-button>
                </el-upload>
              </el-col>
            </el-row>
          </el-form>
        </div>
      </div>
    </el-dialog>

    <!--新增机构-->
    <el-dialog
      :visible.sync="dialogVisible5"
      width="900px"
      :show-close="false"
      style="vertical-align: center; :#FFF9F3 "
    >
      <div style="margin-top: -40px">
        <el-row style="border-bottom: 2px dotted #e7eaec; padding-bottom: 10px">
          <el-col :span="12">
            <div style="color: #3998f7; padding-top: 8px; font-size: 20px">
              新增机构
            </div>
          </el-col>

          <el-col :span="12">
            <div align="right">
              <el-button type="primary" size="small" @click="baocun2">
                保存
              </el-button>
              <el-button type="danger" size="small" @click="quxiao">
                关闭
              </el-button>
            </div>
          </el-col>
        </el-row>
        <div class="subjectList" style="margin-top: 20px">
          <el-form
            ref="pushlist"
            :model="pushlist"
            label-width="120px"
            :rules="rules"
            hide-required-asterisk
          >
            <el-row>
              <el-col :span="12">
                <el-form-item
                  label="名称"
                  prop="institution_name"
                  class="institution_star"
                >
                  <el-input
                    v-model="pushlist.institution_name"
                    placeholder="请输入名称"
                  ></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item
                  label="编码"
                  prop="institution_code"
                  class="institution_star"
                >
                  <el-input
                    v-model="pushlist.institution_code"
                    placeholder="请输入编码"
                  ></el-input>
                </el-form-item>
              </el-col>
            </el-row>

            <el-row>
              <el-col :span="12">
                <el-form-item
                  label="类别"
                  prop="institution_type"
                  class="institution_star"
                >
                  <el-select
                    v-model="pushlist.institution_type"
                    filterable
                    placeholder="请选择类别"
                    style="width: 100%"
                    @change="fangfa2"
                    clearable
                  >
                    <el-option
                      v-for="item in TypeList"
                      :key="item.key"
                      :label="item.value1"
                      :value="item.key"
                    >
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="级别">
                  <el-select
                    v-model="pushlist.institution_grade"
                    filterable
                    placeholder="请选择级别"
                    style="width: 100%"
                    clearable
                  >
                    <el-option
                      v-for="item in GardeList"
                      :key="item.key"
                      :label="item.value1"
                      :value="item.key"
                    >
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>

            <el-row>
              <el-col :span="12">
                <el-form-item
                  label="省份"
                  prop="province_id"
                  class="institution_star"
                >
                  <el-select
                    v-model="pushlist.province_id"
                    filterable
                    placeholder="请选择省份"
                    @change="fangfa"
                    style="width: 100%"
                    clearable
                  >
                    <el-option
                      v-for="item in data"
                      :key="item.id"
                      :label="item.label"
                      :value="item.id"
                    >
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item
                  label="城市"
                  prop="city_id"
                  class="institution_star"
                >
                  <el-select
                    v-model="pushlist.city_id"
                    filterable
                    placeholder="请选择城市"
                    style="width: 100%"
                    clearable
                  >
                    <el-option
                      v-for="item in CityList"
                      :key="item.city_id"
                      :label="item.city_name"
                      :value="item.city_id"
                    >
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>

            <el-form-item label="地址">
              <el-input
                v-model="pushlist.address"
                placeholder="请输入地址"
              ></el-input>
            </el-form-item>

            <el-row>
              <el-col :span="12">
                <el-form-item label="联系电话">
                  <el-input
                    v-model="pushlist.telephone"
                    placeholder="请输入联系电话"
                  ></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="邮政编码">
                  <el-input
                    v-model="pushlist.postcode"
                    placeholder="请输入邮政编码"
                  ></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <!--                        <el-row>-->
            <!--                            <el-col :span="12">-->
            <!--                                <el-form-item label="开发进度">-->

            <!--                                    <el-select v-model="pushlist.agreement_stage" filterable placeholder="请选择" style="width: 100%">-->
            <!--                                        <el-option-->
            <!--                                                v-for="item in AGREEMENT_STAGE"-->
            <!--                                                :key="item.key"-->
            <!--                                                :label="item.value1"-->
            <!--                                                :value="item.key">-->
            <!--                                        </el-option>-->
            <!--                                    </el-select>-->

            <!--                                </el-form-item>-->
            <!--                            </el-col>-->
            <!--                            <el-col :span="12">-->
            <!--                                <el-form-item label="已进药">-->
            <!--                                    <el-switch-->
            <!--                                            v-model="pushlist.agreement_signed"-->
            <!--                                            active-color="#13ce66"-->
            <!--                                    >-->
            <!--                                    </el-switch>-->
            <!--                                </el-form-item>-->
            <!--                            </el-col>-->
            <!--                        </el-row>-->
            <el-row>
              <el-col :span="12">
                <el-form-item label="官方网址">
                  <el-input
                    v-model="pushlist.website"
                    placeholder="请输入官方网址"
                  ></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="所属经销商">
                  <el-select
                    v-model="pushlist.distributor_id"
                    filterable
                    placeholder="请选择经销商"
                    style="width: 100%"
                    clearable
                  >
                    <el-option
                      v-for="item in distributorList"
                      :key="item.distributor_id"
                      :label="item.distributor_name"
                      :value="item.distributor_id"
                    >
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>

            <el-form-item label="备注">
              <el-input
                :rows="3"
                v-model="pushlist.comments"
                placeholder="请输入备注信息"
                type="textarea"
              ></el-input>
            </el-form-item>

            <el-form-item label="有效">
              <el-switch v-model="pushlist.status" active-color="#13ce66">
              </el-switch>
            </el-form-item>
          </el-form>
        </div>
      </div>
    </el-dialog>

    <!--机构编辑-->
    <el-dialog
      :visible.sync="insdialogVisible"
      width="900px"
      :show-close="false"
      style="vertical-align: center; :#FFF9F3 ; margin-top: -100px"
    >
      <div style="margin-top: -40px">
        <el-row style="padding-bottom: 10px">
          <el-col :span="12">
            <div style="color: #3998f7; padding-top: 8px; font-size: 20px">
              机构详情
            </div>
          </el-col>

          <el-col :span="12">
            <div align="right">
              <el-button
                type="primary"
                size="small"
                @click="baocun1_1"
                v-if="activeName2 !== 'third' && activeName2 !== 'four'"
              >
                保存
              </el-button>
              <el-button type="danger" size="small" @click="guanbi1_1">
                关闭
              </el-button>
            </div>
          </el-col>
        </el-row>
        <el-tabs v-model="activeName2" @tab-click="handleClickTabs">
          <el-tab-pane label="基本信息" name="first">
            <div class="subjectList" style="margin-top: 20px">
              <el-form
                ref="insList"
                :model="insList"
                label-width="120px"
                hide-required-asterisk
              >
                <el-row>
                  <el-col :span="12">
                    <el-form-item
                      label="名称"
                      prop="institution_name"
                      class="institution_star"
                      :rules="[{ required: true, message: '名称不能为空' }]"
                    >
                      <el-input v-model="insList.institution_name"></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :span="12">
                    <el-form-item
                      label="编码"
                      prop="institution_code"
                      class="institution_star"
                      :rules="[{ required: true, message: '编码不能为空' }]"
                    >
                      <el-input v-model="insList.institution_code"></el-input>
                    </el-form-item>
                  </el-col>
                </el-row>

                <el-row>
                  <el-col :span="12">
                    <el-form-item
                      label="类别"
                      prop="institution_type"
                      class="institution_star"
                      :rules="[{ required: true, message: '类别不能为空' }]"
                    >
                      <el-select
                        v-model="insList.institution_type"
                        filterable
                        placeholder="请选择类别"
                        style="width: 100%"
                        @change="fangfa1_1"
                        clearable
                      >
                        <el-option
                          v-for="item in TypeList"
                          :key="item.key"
                          :label="item.value1"
                          :value="item.key"
                        >
                        </el-option>
                      </el-select>
                    </el-form-item>
                  </el-col>
                  <el-col :span="12">
                    <el-form-item label="级别">
                      <el-select
                        v-model="insList.institution_grade_name"
                        filterable
                        placeholder="请选择级别"
                        style="width: 100%"
                        clearable
                      >
                        <el-option
                          v-for="item in GardeList"
                          :key="item.key"
                          :label="item.value1"
                          :value="item.key"
                        >
                        </el-option>
                      </el-select>
                    </el-form-item>
                  </el-col>
                </el-row>

                <el-row>
                  <el-col :span="12">
                    <el-form-item
                      label="省份"
                      prop="province_id"
                      class="institution_star"
                      :rules="[{ required: true, message: '省份不能为空' }]"
                    >
                      <el-select
                        v-model="insList.province_id"
                        filterable
                        placeholder="请选择省份"
                        @change="fangfa"
                        style="width: 100%"
                        clearable
                      >
                        <el-option
                          v-for="item in data"
                          :key="item.id"
                          :label="item.label"
                          :value="item.id"
                        >
                        </el-option>
                      </el-select>
                    </el-form-item>
                  </el-col>
                  <el-col :span="12">
                    <el-form-item
                      label="城市"
                      prop="city_id"
                      class="institution_star"
                      :rules="[{ required: true, message: '城市不能为空' }]"
                    >
                      <el-select
                        v-model="insList.city_id"
                        filterable
                        placeholder="请选择城市"
                        style="width: 100%"
                        clearable
                      >
                        <el-option
                          v-for="item in CityList"
                          :key="item.city_id"
                          :label="item.city_name"
                          :value="item.city_id"
                        >
                        </el-option>
                      </el-select>
                    </el-form-item>
                  </el-col>
                </el-row>

                <el-form-item label="地址">
                  <el-input v-model="insList.address"></el-input>
                </el-form-item>

                <el-row>
                  <el-col :span="12">
                    <el-form-item label="联系电话">
                      <el-input v-model="insList.telephone"></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :span="12">
                    <el-form-item label="邮政编码">
                      <el-input v-model="insList.postcode"></el-input>
                    </el-form-item>
                  </el-col>
                </el-row>

                <el-row>
                  <el-col :span="12">
                    <el-form-item label="官方网址">
                      <el-input v-model="insList.website"></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :span="12">
                    <el-form-item label="所属经销商">
                      <el-select
                        v-model="insList.distributor_id"
                        filterable
                        placeholder="请选择经销商"
                        style="width: 100%"
                        clearable
                      >
                        <el-option
                          v-for="item in distributorList"
                          :key="item.distributor_id"
                          :label="item.distributor_name"
                          :value="item.distributor_id"
                        >
                        </el-option>
                      </el-select>
                    </el-form-item>
                  </el-col>
                </el-row>

                <el-form-item label="备注">
                  <el-input
                    type="textarea"
                    :rows="3"
                    v-model="insList.comments"
                    placeholder="请输入备注信息"
                  ></el-input>
                </el-form-item>
                <el-form-item label="有效">
                  <el-switch v-model="insList.status" active-color="#13ce66">
                  </el-switch>
                </el-form-item>
              </el-form>
            </div>
          </el-tab-pane>
          <el-tab-pane
            :label="items.group_name"
            :name="items.name"
            v-for="(items, j) in extendedInfo"
          >
            <div class="subjectList" style="margin-top: 20px">
              <el-form
                hide-required-asterisk
                :ref="'inslist' + j"
                label-width="15%"
                v-for="(item, j) in items.fieldArray"
                :model="item"
                :key="item.field_id"
              >
                <el-col span="24" v-if="item.input_type == 'TEXT'">
                  <el-form-item
                    :label="item.label"
                    :class="{ institution_star: item.mandatory == 'T' }"
                    prop="field_value"
                    :rules="
                      item.mandatory == 'T'
                        ? [{ required: true, message: item.label + '不能为空' }]
                        : []
                    "
                  >
                    <el-input
                      v-model="item.field_value"
                      placeholder="请输入文本"
                    ></el-input>
                  </el-form-item>
                </el-col>
                <el-col span="24" v-else-if="item.input_type == 'NUMBER'">
                  <el-form-item
                    :label="item.label"
                    :class="{ institution_star: item.mandatory == 'T' }"
                    prop="field_value"
                    :rules="
                      item.mandatory == 'T'
                        ? [{ required: true, message: item.label + '不能为空' }]
                        : []
                    "
                  >
                    <el-input
                      v-model="item.field_value"
                      placeholder="请输入数字"
                      type="number"
                    ></el-input>
                  </el-form-item>
                </el-col>
                <el-col span="24" v-else-if="item.input_type == 'DATE'">
                  <el-form-item
                    :label="item.label"
                    :class="{ institution_star: item.mandatory == 'T' }"
                    prop="field_value"
                    :rules="
                      item.mandatory == 'T'
                        ? [{ required: true, message: item.label + '不能为空' }]
                        : []
                    "
                  >
                    <el-date-picker
                      v-model="item.field_value"
                      type="date"
                      placeholder="选择日期时间"
                      style="width: 100%"
                      format="yyyy-MM-dd"
                      value-format="yyyy-MM-dd"
                    >
                    </el-date-picker>
                  </el-form-item>
                </el-col>
                <el-col span="24" v-else-if="item.input_type == 'TRUE-FALSE'">
                  <el-form-item :label="item.label">
                    <el-switch
                      v-model="item.field_value"
                      active-color="#13ce66"
                      active-value="T"
                      inactive-value="F"
                    >
                    </el-switch>
                  </el-form-item>
                </el-col>
                <el-col span="24" v-else-if="item.input_type == 'LIST'">
                  <el-form-item
                    :label="item.label"
                    :class="{ institution_star: item.mandatory == 'T' }"
                    prop="field_value"
                    :rules="
                      item.mandatory == 'T'
                        ? [{ required: true, message: item.label + '不能为空' }]
                        : []
                    "
                  >
                    <!--                                            <el-select v-model="item.field_value" :multiple="item.multiple == 'T'" placeholder="请选择" style="width: 100%"  clearable>-->
                    <!--                                                <el-option-->
                    <!--                                                        v-for="item in item.listArray"-->
                    <!--                                                        :key="item.value"-->
                    <!--                                                        :label="item.label"-->
                    <!--                                                        :value="item.value">-->
                    <!--                                                </el-option>-->
                    <!--                                            </el-select>-->
                    <el-cascader
                      v-model="item.field_value"
                      :options="item.listArray"
                      style="width: 100%"
                      filterable
                      :show-all-levels="false"
                      :props="{
                        multiple: item.multiple == 'T' ? true : false,
                        checkStrictly: true,
                      }"
                      clearable
                    ></el-cascader>
                  </el-form-item>
                </el-col>

                <el-col span="24" v-else-if="item.input_type == 'TABLE'">
                  <el-form-item
                    :label="item.label"
                    :class="{ institution_star: item.mandatory == 'T' }"
                    prop="field_value"
                    :rules="
                      item.mandatory == 'T'
                        ? [{ required: true, message: item.label + '不能为空' }]
                        : []
                    "
                  >
                    <el-table
                      :data="item.field_value"
                      border
                      style="width: 100%"
                    >
                      <el-table-column type="index" label="序号" width="50">
                      </el-table-column>
                      <el-table-column
                        prop="dept_name"
                        label="标准科室"
                        v-if="item.array_dept !== 'NONE'"
                      >
                      </el-table-column>
                      <el-table-column
                        prop="product_name"
                        label="产品"
                        v-if="item.array_product !== 'NONE'"
                      >
                      </el-table-column>
                      <el-table-column
                        prop="sku_name"
                        label="SKU"
                        v-if="
                          item.array_product == 'SKU' &&
                          item.array_product !== 'NONE'
                        "
                      >
                      </el-table-column>
                      <el-table-column
                        prop="date_name"
                        label="日期"
                        v-if="item.array_date !== 'NONE'"
                      >
                      </el-table-column>
                      <el-table-column prop="field_value" label="数值">
                      </el-table-column>
                      <el-table-column fixed="right" label="操作" width="80">
                        <template slot-scope="scope">
                          <el-button
                            @click="
                              handleTableClick(scope.$index, scope.row, item)
                            "
                            style="
                              background-color: rgb(255, 153, 1);
                              border: 1px solid rgb(255, 153, 1);
                              color: #fff;
                            "
                            size="small"
                            >详情
                          </el-button>
                        </template>
                      </el-table-column>
                    </el-table>
                  </el-form-item>
                  <el-col :span="24" style="margin-bottom: 10px">
                    <el-button
                      size="small"
                      icon="el-icon-plus"
                      style="
                        float: left;
                        margin-left: 15%;
                        background-color: #6cc584;
                        border: 1px solid #6cc584;
                        color: #fff;
                      "
                      @click="addNewTable(item)"
                      >添加新数据
                    </el-button>
                  </el-col>
                  <el-col
                    :span="24"
                    v-if="item.isAddTable"
                    id="addTable"
                    style="
                      margin-left: 15%;
                      width: 85%;
                      background: #edf3fb;
                      border: 1px solid #ecdfe6;
                      margin-bottom: 10px;
                      border-radius: 10px;
                    "
                  >
                    <el-col :span="14">
                      <el-form
                        ref="addTable1"
                        :model="item.addTableList"
                        style="margin-top: 20px"
                        hide-required-asterisk
                      >
                        <el-form-item
                          label="标准科室"
                          class="institution_star"
                          v-if="item.array_dept !== 'NONE'"
                          prop="dept_id"
                          :rules="{
                            required: true,
                            message: '标准科室不能为空',
                          }"
                        >
                          <el-select
                            v-model="item.addTableList.dept_id"
                            placeholder="请选择标准科室"
                            style="width: 70%; float: right"
                            clearable
                          >
                            <el-option
                              v-for="item in administrativeList"
                              :key="item.key"
                              :label="item.value1"
                              :value="item.key"
                            >
                            </el-option>
                          </el-select>
                        </el-form-item>
                        <el-form-item
                          label="产品"
                          class="institution_star"
                          v-if="item.array_product !== 'NONE'"
                          prop="product_id"
                          :rules="{ required: true, message: '产品不能为空' }"
                        >
                          <el-select
                            v-model="item.addTableList.product_id"
                            placeholder="请选择产品"
                            style="width: 70%; float: right"
                            @change="getSkuList(item)"
                            clearable
                          >
                            <el-option
                              v-for="item in productList"
                              :key="item.key"
                              :label="item.value1"
                              :value="item.key"
                            >
                            </el-option>
                          </el-select>
                        </el-form-item>
                        <el-form-item
                          label="SKU"
                          class="institution_star"
                          v-if="
                            item.array_product == 'SKU' &&
                            item.array_product !== 'NONE'
                          "
                          prop="sku_id"
                          :rules="{ required: true, message: 'SKU不能为空' }"
                        >
                          <el-select
                            v-model="item.addTableList.sku_id"
                            placeholder="请选择SKU"
                            style="width: 70%; float: right"
                            clearable
                          >
                            <el-option
                              v-for="item in SkuList"
                              :key="item.key"
                              :label="item.value1"
                              :value="item.key"
                            >
                            </el-option>
                          </el-select>
                        </el-form-item>
                        <el-form-item
                          label="日期"
                          class="institution_star"
                          v-if="
                            item.array_date !== 'NONE' && item.array_date !== ''
                          "
                          prop="date_name"
                          :rules="{ required: true, message: '日期不能为空' }"
                        >
                          <el-date-picker
                            v-model="item.addTableList.info_date"
                            type="year"
                            style="width: 70%; float: right"
                            format="yyyy年"
                            value-format="yyyy年"
                            placeholder="选择年"
                            v-if="item.array_date == 'YEAR'"
                          >
                          </el-date-picker>
                          <quarter
                            v-if="item.array_date == 'QUARTER'"
                            @child-event="parentEvent"
                            :defaultValue="item.addTableList.info_date"
                            :getValue="getQuarterValue"
                            style="width: 70%; float: right"
                          ></quarter>
                          <el-date-picker
                            v-model="item.addTableList.info_date"
                            type="month"
                            style="width: 70%; float: right"
                            format="yyyy年MM月"
                            value-format="yyyy年MM月"
                            placeholder="选择月"
                            v-if="item.array_date == 'MONTH'"
                          >
                          </el-date-picker>
                          <monthComponent
                            v-if="item.array_date == 'WEEK'"
                            @week-event="parentWeekEvent"
                            :defaultValue="item.addTableList.info_date"
                            :getValue="getWeekValue"
                            style="width: 70%; float: right"
                          ></monthComponent>
                          <el-date-picker
                            v-model="item.addTableList.info_date"
                            type="date"
                            placeholder="选择日期"
                            style="width: 70%; float: right"
                            format="yyyy年MM月dd日"
                            value-format="yyyy年MM月dd日"
                            v-if="item.array_date == 'DAY'"
                          >
                          </el-date-picker>
                        </el-form-item>
                        <el-form-item
                          label="数值"
                          prop="field_value"
                          class="institution_star"
                          :rules="{ required: true, message: '数值不能为空' }"
                        >
                          <el-input
                            v-model="item.addTableList.field_value"
                            placeholder="请输入数值"
                            style="width: 70%; float: right"
                          ></el-input>
                        </el-form-item>
                      </el-form>
                    </el-col>
                    <el-col :span="10">
                      <el-col style="margin-top: 20px">
                        <el-button
                          size="small"
                          style="
                            float: left;
                            margin-left: 40px;
                            background-color: #588ede;
                            border: 1px solid #588ede;
                            color: #fff;
                          "
                          @click="addTableData(item)"
                          >保存
                        </el-button>
                        <el-button
                          style="
                            float: left;
                            margin-left: 20px;
                            background-color: #e87570;
                            border: 1px solid #e87570;
                            color: #fff;
                          "
                          @click="delateTableData(item)"
                          v-if="delateFalse"
                          size="small"
                          >删除
                        </el-button>
                        <el-button
                          size="small"
                          style="
                            float: left;
                            margin-left: 20px;
                            background-color: #e87570;
                            border: 1px solid #e87570;
                            color: #fff;
                          "
                          @click="cancelTableData(item)"
                          >取消
                        </el-button>
                      </el-col>
                    </el-col>
                  </el-col>
                </el-col>

                <el-col span="24" v-else>
                  <el-form-item
                    :label="item.label"
                    :class="{ institution_star: item.mandatory == 'T' }"
                    prop="field_value"
                    :rules="
                      item.mandatory == 'T'
                        ? [{ required: true, message: item.label + '不能为空' }]
                        : []
                    "
                  >
                    <el-input
                      :rows="3"
                      v-model="item.field_value"
                      placeholder="请输入备注信息"
                      type="textarea"
                    ></el-input>
                  </el-form-item>
                </el-col>
              </el-form>
            </div>
          </el-tab-pane>
          <el-tab-pane label="照片图库" name="third">
            <div class="photoList" style="display: flex; flex-wrap: wrap">
              <div class="upload" style="float: left" @click.stop="openDetail">
                <div class="d1"></div>
                <div class="d2"></div>
              </div>
              <div
                class="imgInfo"
                style="align-items: flex-start"
                v-for="item in imgArray"
                @click.stop="editPhoto(item)"
              >
                <img
                  :src="item.url"
                  style="
                    width: 120px;
                    height: 120px;
                    border-radius: 5px;
                    display: block;
                  "
                />
                <div style="min-height: 18px; width: 120px">
                  <el-tag
                    v-for="bq in item.tag"
                    :key="bq.text"
                    :disable-transitions="false"
                    style="
                      background-color: #ba9ee6;
                      color: white;
                      font-weight: bold;
                    "
                  >
                    {{ bq.text }}
                  </el-tag>
                </div>
              </div>
            </div>
            <div class="photoDetail" v-if="isDetail">
              <el-row>
                <el-col :span="24" style="padding: 20px 20px">
                  <div
                    style="
                      color: #2b92fa;
                      font-size: 18px;
                      display: inline-block;
                      float: left;
                    "
                  >
                    照片详情
                  </div>
                  <div style="display: inline-block; float: right">
                    <el-button
                      type="primary"
                      class="button"
                      @click="submitPhoto"
                    >
                      保存
                    </el-button>
                    <el-button
                      type="danger"
                      class="button"
                      @click="closeDetail"
                    >
                      关闭
                    </el-button>
                  </div>
                </el-col>
              </el-row>
              <el-row style="margin: 10px 20px">
                <el-col span="12">
                  <el-col span="4" style="margin-top: 20px; margin-right: 20px">
                    <span
                      style="
                        display: block;
                        margin-bottom: 20px;
                        margin-left: 4px;
                        font-weight: bold;
                      "
                      >照片上传</span
                    >
                    <el-button
                      type="danger"
                      style="
                        width: 70px;
                        height: 30px;
                        padding: 5px;
                        font-size: 10px;
                        background-color: #d9443d;
                        border-color: #d9443d;
                      "
                      @click.stop="deletePhoto"
                      >删除照片
                    </el-button>
                  </el-col>
                  <el-col span="16">
                    <el-upload
                      ref="photoUpload"
                      class="upload-demo"
                      drag
                      accept=".jpg,.png,.jpeg"
                      action="/photos/uploadphoto"
                      :auto-upload="false"
                      :before-upload="getUuidAgenda"
                      :on-success="getPhotoIdAgenda"
                      :on-change="beforeUpload"
                      :data="categoryAgenda"
                    >
                      <i class="el-icon-upload"></i>
                      <div class="el-upload__text">
                        将文件拖到此处，或<em>点击上传</em>
                      </div>
                    </el-upload>
                  </el-col>
                </el-col>
                <el-col span="12">
                  <el-col style="margin-left: 20px; margin-top: 10px">
                    <span style="font-weight: bold">设置标签</span>
                    <el-input
                      placeholder="请输入照片的说明"
                      style="
                        display: inline-block;
                        margin-left: 10px;
                        width: 300px;
                      "
                      v-model="tagText"
                      @keyup.enter.native="addTag"
                      @input.native="change($event)"
                    ></el-input>
                  </el-col>
                  <el-col style="width: 300px; margin-left: 85px">
                    <el-tag
                      closable
                      v-for="tag in tags"
                      :key="tag.text"
                      :disable-transitions="false"
                      @close="tagClose(tag)"
                      style="
                        background-color: #ba9ee6;
                        color: white;
                        font-weight: bold;
                      "
                    >
                      {{ tag.text }}
                    </el-tag>
                  </el-col>
                </el-col>
              </el-row>
            </div>
          </el-tab-pane>
          <el-tab-pane label="附加文件" name="four">
            <div class="">
              <el-col style="color: #2b92fa; margin-bottom: 10px">
                文件总数：{{ fileTable.length }}个（视频：{{
                  statistics.mp4Num ? statistics.mp4Num : 0
                }}个，幻灯片：
                {{ statistics.slideNum ? statistics.slideNum : 0 }}个，图片：{{
                  statistics.imgNum ? statistics.imgNum : 0
                }}个，文档：{{
                  statistics.docNum ? statistics.docNum : 0
                }}个，其他：{{
                  statistics.restsNum ? statistics.restsNum : 0
                }}个）
              </el-col>
              <el-table :data="fileTable" border>
                <el-table-column sortable label="文件名称">
                  <template slot-scope="scope">
                    {{ scope.row.file_name }}
                    <el-tag
                      v-for="bq in scope.row.tag"
                      :key="bq.text"
                      :disable-transitions="false"
                      style="
                        background-color: #ba9ee6;
                        color: white;
                        font-weight: bold;
                      "
                    >
                      {{ bq.text }}
                    </el-tag>
                  </template>
                </el-table-column>
                <el-table-column sortable prop="category" label="文件类型">
                  <template slot-scope="scope">
                    {{ isFileType(scope.row.category) }}
                  </template>
                </el-table-column>
                <el-table-column sortable prop="file_size" label="文件大小">
                  <template slot-scope="scope">
                    <span>{{ getFileSize(scope.row.file_size) }}</span>
                  </template>
                </el-table-column>
                <el-table-column sortable prop="status" label="状态">
                  <template slot-scope="scope">
                    {{ scope.row.status == "ACTIVE" ? "有效" : "无效" }}
                  </template>
                </el-table-column>
                <el-table-column label="操作">
                  <template slot-scope="scope">
                    <el-button
                      @click="editFile(scope.$index, scope.row)"
                      type="warning"
                      size="mini"
                      >详情
                    </el-button>
                    <el-button
                      @click="downloadFile(scope.row)"
                      type="primary"
                      size="mini"
                      >下载
                    </el-button>
                  </template>
                </el-table-column>
              </el-table>
              <el-button
                type="success"
                size="small"
                icon="el-icon-plus"
                style="margin-top: 10px"
                @click.stop="openFileDetail"
                >添加文件
              </el-button>
            </div>
            <div class="photoDetail" v-if="fileDetail">
              <el-row>
                <el-col :span="24" style="padding: 20px 20px">
                  <div
                    style="
                      color: #2b92fa;
                      font-size: 18px;
                      display: inline-block;
                      float: left;
                    "
                  >
                    文件详情
                  </div>
                  <div style="display: inline-block; float: right">
                    <el-button
                      type="primary"
                      class="button"
                      @click.stop="submitFiles"
                    >
                      保存
                    </el-button>
                    <el-button
                      type="danger"
                      class="button"
                      @click.stop="closeFileDetail"
                    >
                      关闭
                    </el-button>
                  </div>
                </el-col>
              </el-row>
              <el-row style="margin: 10px 20px">
                <el-col span="12">
                  <el-col span="4" style="margin-top: 20px; margin-right: 20px">
                    <span
                      style="
                        display: block;
                        margin-bottom: 20px;
                        margin-left: 4px;
                        font-weight: bold;
                      "
                      >文件上传</span
                    >
                    <el-button
                      type="danger"
                      style="
                        width: 70px;
                        height: 30px;
                        padding: 5px;
                        font-size: 10px;
                        background-color: #d9443d;
                        border-color: #d9443d;
                      "
                      @click.stop="deleteFile"
                      >删除文件
                    </el-button>
                  </el-col>
                  <el-col span="16">
                    <el-upload
                      ref="uploadFile"
                      drag
                      :action="getUrl()"
                      :before-upload="beforeFileUpload"
                      :on-success="fileSuccess"
                      :auto-upload="false"
                    >
                      <i class="el-icon-upload"></i>
                      <div class="el-upload__text">
                        将文件拖到此处，或<em>点击上传</em>
                      </div>
                    </el-upload>
                  </el-col>
                </el-col>
                <el-col span="12">
                  <el-col style="margin-left: 20px; margin-top: 10px">
                    <span style="font-weight: bold">设置标签</span>
                    <el-input
                      placeholder="请输入文件的说明"
                      style="
                        display: inline-block;
                        margin-left: 10px;
                        width: 300px;
                      "
                      v-model="fileTag"
                      @keyup.enter.native="addFileTag"
                    ></el-input>
                  </el-col>
                  <el-col style="width: 300px; margin-left: 85px">
                    <el-tag
                      closable
                      v-for="tag in fileTags"
                      :key="tag.text"
                      :disable-transitions="false"
                      @close="fileTagClose(tag)"
                      style="
                        background-color: #ba9ee6;
                        color: white;
                        font-weight: bold;
                      "
                    >
                      {{ tag.text }}
                    </el-tag>
                  </el-col>
                </el-col>
              </el-row>
            </div>
          </el-tab-pane>
        </el-tabs>
      </div>
    </el-dialog>
    <!--HCP详情-->
    <el-dialog
      :visible.sync="insdialogVisible2"
      width="900px"
      :show-close="false"
      style="vertical-align: center; :#FFF9F3 ; margin-top: -70px"
    >
      <div style="margin-top: -40px">
        <el-row style="padding-bottom: 10px">
          <el-col :span="12">
            <div style="color: #3998f7; padding-top: 8px; font-size: 20px">
              HCP详情
            </div>
          </el-col>

          <el-col :span="12">
            <div align="right">
              <el-button
                type="primary"
                size="small"
                @click="baocun1_2"
                v-if="activeName1 !== 'third' && activeName1 !== 'four'"
              >
                保存
              </el-button>
              <el-button type="danger" size="small" @click="guanbi1_2">
                关闭
              </el-button>
            </div>
          </el-col>
        </el-row>
        <el-tabs v-model="activeName1" @tab-click="handleClickTabs">
          <el-tab-pane label="基本信息" name="first">
            <div class="HcpClass1" style="margin-top: 20px">
              <el-form
                ref="Hcplist"
                :model="Hcplist"
                label-width="150px"
                hide-required-asterisk
              >
                <el-row>
                  <el-col :span="12">
                    <el-form-item label="所属科室/部门" prop="standard_dept">
                      <el-select
                        v-model="Hcplist.standard_dept"
                        placeholder="  "
                        filterable
                        style="width: 100%"
                        disabled
                      >
                        <el-option
                          v-for="item in administrative"
                          :key="item.key"
                          :label="item.value1"
                          :value="item.key"
                        >
                        </el-option>
                      </el-select>
                    </el-form-item>
                  </el-col>
                  <el-col :span="12">
                    <el-form-item label="科室挂牌名称" prop="department">
                      <el-input
                        v-model="Hcplist.department"
                        placeholder=" "
                        disabled
                      ></el-input>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row>
                  <el-col :span="12">
                    <el-form-item label="姓名">
                      <el-input v-model="Hcplist.name" disabled></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :span="12">
                    <el-form-item label="性别">
                      <el-select
                        v-model="Hcplist.sex"
                        style="width: 100%"
                        disabled
                      >
                        <el-option label="男" value="M"></el-option>
                        <el-option label="女" value="F"></el-option>
                      </el-select>
                    </el-form-item>
                  </el-col>
                </el-row>

                <el-row>
                  <el-col :span="12">
                    <el-form-item label="职务">
                      <el-select
                        v-model="Hcplist.zhiwu"
                        filterable
                        style="width: 100%"
                        disabled
                        placeholder="  "
                      >
                        <el-option
                          v-for="item in jobtList"
                          :key="item.key"
                          :label="item.value1"
                          :value="item.key"
                        >
                        </el-option>
                      </el-select>
                    </el-form-item>
                  </el-col>
                  <el-col :span="12">
                    <el-form-item label="职称">
                      <el-select
                        v-model="Hcplist.zhicheng"
                        filterable
                        style="width: 100%"
                        disabled
                        placeholder="  "
                      >
                        <el-option
                          v-for="item in prolist"
                          :key="item.key"
                          :label="item.value1"
                          :value="item.key"
                        >
                        </el-option>
                      </el-select>
                    </el-form-item>
                  </el-col>
                </el-row>

                <el-row>
                  <el-col :span="12">
                    <el-form-item label="联系电话">
                      <el-input v-model="Hcplist.phone" disabled></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :span="12">
                    <el-form-item label="电子邮件">
                      <el-input v-model="Hcplist.mali" disabled></el-input>
                    </el-form-item>
                  </el-col>
                </el-row>

                <el-row>
                  <el-col :span="12">
                    <el-form-item label="生日">
                      <el-date-picker
                        v-model="Hcplist.value1"
                        type="date"
                        value-format="yyyy-MM-dd"
                        placeholder="  "
                        style="width: 100%"
                        disabled
                      >
                      </el-date-picker>
                    </el-form-item>
                  </el-col>
                  <el-col :span="12">
                    <el-form-item label="爱好">
                      <el-input
                        v-model="Hcplist.hobby"
                        placeholder=""
                        disabled
                      ></el-input>
                    </el-form-item>
                  </el-col>
                </el-row>

                <el-row>
                  <el-col :span="12">
                    <el-form-item label="主治病症">
                      <el-input
                        v-model="Hcplist.specialties"
                        placeholder=""
                        disabled
                      ></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :span="12">
                    <el-form-item label="门诊时间">
                      <el-input
                        v-model="Hcplist.consulting_hours"
                        placeholder=""
                        disabled
                      ></el-input>
                    </el-form-item>
                  </el-col>
                </el-row>

                <el-row>
                  <el-col :span="12">
                    <el-form-item label="毕业院校">
                      <el-input
                        v-model="Hcplist.education"
                        placeholder=""
                        disabled
                      ></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :span="12">
                    <el-form-item label="担任协会职务">
                      <el-input
                        v-model="Hcplist.fellowships"
                        placeholder=""
                        disabled
                      ></el-input>
                    </el-form-item>
                  </el-col>
                </el-row>

                <el-row>
                  <el-col :span="12">
                    <el-form-item label="专家讲者">
                      <el-switch
                        v-model="Hcplist.speaker"
                        active-color="#13ce66"
                        disabled
                      >
                      </el-switch>
                    </el-form-item>
                  </el-col>
                  <el-col :span="12">
                    <el-form-item label="讲者级别">
                      <el-select
                        v-model="Hcplist.speaker_level"
                        placeholder="  "
                        style="width: 100%"
                        disabled
                      >
                        <el-option
                          v-for="item in prolist"
                          :key="item.key"
                          :label="item.value1"
                          :value="item.key"
                        >
                        </el-option>
                      </el-select>
                    </el-form-item>
                  </el-col>
                </el-row>

                <el-row>
                  <el-col :span="12">
                    <el-form-item label="KOL">
                      <el-switch
                        v-model="Hcplist.kol"
                        active-color="#13ce66"
                        disabled
                      >
                      </el-switch>
                    </el-form-item>
                  </el-col>
                  <el-col :span="12">
                    <el-form-item label="KOL级别">
                      <el-select
                        v-model="Hcplist.kol_level"
                        placeholder="  "
                        style="width: 100%"
                        disabled
                      >
                        <el-option
                          v-for="item in prolist"
                          :key="item.key"
                          :label="item.value1"
                          :value="item.key"
                        >
                        </el-option>
                      </el-select>
                    </el-form-item>
                  </el-col>
                </el-row>

                <el-row>
                  <el-col :span="12">
                    <el-form-item label="在职">
                      <el-switch
                        v-model="Hcplist.status"
                        active-color="#13ce66"
                        disabled
                      >
                      </el-switch>
                    </el-form-item>
                  </el-col>
                  <el-col :span="12">
                    <el-form-item label="HCP编码">
                      <el-input
                        v-model="Hcplist.hcp_code"
                        placeholder=""
                        disabled
                      ></el-input>
                    </el-form-item>
                  </el-col>
                </el-row>
              </el-form>
            </div>
          </el-tab-pane>
          <el-tab-pane
            :label="items.group_name"
            :name="items.name"
            v-for="(items, j) in extendedInfo1"
          >
            <div class="subjectList" style="margin-top: 20px">
              <el-form
                hide-required-asterisk
                :ref="'hcplist' + j"
                label-width="30%"
                v-for="(item, j) in items.fieldArray"
                :model="item"
                :key="item.field_id"
              >
                <el-col span="24" v-if="item.input_type == 'TEXT'">
                  <el-form-item
                    :label="item.label"
                    :class="{ institution_star: item.mandatory == 'T' }"
                    prop="field_value"
                    :rules="
                      item.mandatory == 'T'
                        ? [{ required: true, message: item.label + '不能为空' }]
                        : []
                    "
                  >
                    <el-input
                      v-model="item.field_value"
                      placeholder="请输入文本"
                    ></el-input>
                  </el-form-item>
                </el-col>
                <el-col span="24" v-else-if="item.input_type == 'NUMBER'">
                  <el-form-item
                    :label="item.label"
                    :class="{ institution_star: item.mandatory == 'T' }"
                    prop="field_value"
                    :rules="
                      item.mandatory == 'T'
                        ? [{ required: true, message: item.label + '不能为空' }]
                        : []
                    "
                  >
                    <el-input
                      v-model="item.field_value"
                      placeholder="请输入数字"
                      type="number"
                    ></el-input>
                  </el-form-item>
                </el-col>
                <el-col span="24" v-else-if="item.input_type == 'DATE'">
                  <el-form-item
                    :label="item.label"
                    :class="{ institution_star: item.mandatory == 'T' }"
                    prop="field_value"
                    :rules="
                      item.mandatory == 'T'
                        ? [{ required: true, message: item.label + '不能为空' }]
                        : []
                    "
                  >
                    <el-date-picker
                      v-model="item.field_value"
                      type="date"
                      placeholder="选择日期时间"
                      style="width: 100%"
                      format="yyyy-MM-dd"
                      value-format="yyyy-MM-dd"
                    >
                    </el-date-picker>
                  </el-form-item>
                </el-col>
                <el-col span="24" v-else-if="item.input_type == 'TRUE-FALSE'">
                  <el-form-item :label="item.label">
                    <el-switch
                      v-model="item.field_value"
                      active-color="#13ce66"
                      active-value="T"
                      inactive-value="F"
                    >
                    </el-switch>
                  </el-form-item>
                </el-col>
                <el-col span="24" v-else-if="item.input_type == 'LIST'">
                  <el-form-item
                    :label="item.label"
                    :class="{ institution_star: item.mandatory == 'T' }"
                    prop="field_value"
                    :rules="
                      item.mandatory == 'T'
                        ? [{ required: true, message: item.label + '不能为空' }]
                        : []
                    "
                  >
                    <!--                                        <el-select v-model="item.field_value" :multiple="item.multiple == 'T'" placeholder="请选择" style="width: 100%"  clearable>-->
                    <!--                                            <el-option-->
                    <!--                                                    v-for="item in item.listArray"-->
                    <!--                                                    :key="item.key"-->
                    <!--                                                    :label="item.value1"-->
                    <!--                                                    :value="item.key">-->
                    <!--                                            </el-option>-->
                    <!--                                        </el-select>-->
                    <el-cascader
                      v-model="item.field_value"
                      :options="item.listArray"
                      style="width: 100%"
                      filterable
                      :show-all-levels="false"
                      :props="{
                        multiple: item.multiple == 'T' ? true : false,
                        checkStrictly: true,
                      }"
                      clearable
                    ></el-cascader>
                  </el-form-item>
                </el-col>
                <el-col span="24" v-else-if="item.input_type == 'TABLE'">
                  <el-form-item
                    :label="item.label"
                    :class="{ institution_star: item.mandatory == 'T' }"
                    prop="field_value"
                    :rules="
                      item.mandatory == 'T'
                        ? [{ required: true, message: item.label + '不能为空' }]
                        : []
                    "
                  >
                    <el-table
                      :data="item.field_value"
                      border
                      style="width: 100%"
                    >
                      <el-table-column type="index" label="序号" width="50">
                      </el-table-column>
                      <el-table-column
                        prop="dept_name"
                        label="标准科室"
                        v-if="item.array_dept !== 'NONE'"
                      >
                      </el-table-column>
                      <el-table-column
                        prop="product_name"
                        label="产品"
                        v-if="item.array_product !== 'NONE'"
                      >
                      </el-table-column>
                      <el-table-column
                        prop="sku_name"
                        label="SKU"
                        v-if="
                          item.array_product == 'SKU' &&
                          item.array_product !== 'NONE'
                        "
                      >
                      </el-table-column>
                      <el-table-column
                        prop="date_name"
                        label="日期"
                        v-if="item.array_date !== 'NONE'"
                      >
                      </el-table-column>
                      <el-table-column prop="field_value" label="数值">
                      </el-table-column>
                      <el-table-column fixed="right" label="操作" width="80">
                        <template slot-scope="scope">
                          <el-button
                            @click="
                              handleTableClick(scope.$index, scope.row, item)
                            "
                            style="
                              background-color: rgb(255, 153, 1);
                              border: 1px solid rgb(255, 153, 1);
                              color: #fff;
                            "
                            size="small"
                            >详情
                          </el-button>
                        </template>
                      </el-table-column>
                    </el-table>
                  </el-form-item>
                  <el-col :span="24" style="margin-bottom: 10px">
                    <el-button
                      size="small"
                      icon="el-icon-plus"
                      style="
                        float: left;
                        margin-left: 30%;
                        background-color: #6cc584;
                        border: 1px solid #6cc584;
                        color: #fff;
                      "
                      @click="addNewTable(item)"
                      >添加新数据
                    </el-button>
                  </el-col>
                  <el-col
                    :span="24"
                    v-if="item.isAddTable"
                    id="addTableHcp"
                    style="
                      margin-left: 30%;
                      width: 70%;
                      background: #edf3fb;
                      border: 1px solid #ecdfe6;
                      margin-bottom: 10px;
                      border-radius: 10px;
                    "
                  >
                    <el-col :span="14">
                      <el-form
                        ref="addTableHcp"
                        :model="item.addTableList"
                        style="margin-top: 20px"
                        hide-required-asterisk
                      >
                        <el-form-item
                          label="标准科室"
                          v-if="item.array_dept !== 'NONE'"
                          prop="dept_id"
                          class="institution_star"
                          :rules="{
                            required: true,
                            message: '标准科室不能为空',
                          }"
                        >
                          <el-select
                            v-model="item.addTableList.dept_id"
                            placeholder="请选择标准科室"
                            style="width: 70%; float: right"
                            clearable
                          >
                            <el-option
                              v-for="item in administrativeList"
                              :key="item.key"
                              :label="item.value1"
                              :value="item.key"
                            >
                            </el-option>
                          </el-select>
                        </el-form-item>
                        <el-form-item
                          label="产品"
                          v-if="item.array_product !== 'NONE'"
                          prop="product_id"
                          class="institution_star"
                          :rules="{ required: true, message: '产品不能为空' }"
                        >
                          <el-select
                            v-model="item.addTableList.product_id"
                            placeholder="请选择产品"
                            style="width: 70%; float: right"
                            @change="getSkuList(item)"
                            clearable
                          >
                            <el-option
                              v-for="item in productList"
                              :key="item.key"
                              :label="item.value1"
                              :value="item.key"
                            >
                            </el-option>
                          </el-select>
                        </el-form-item>
                        <el-form-item
                          label="SKU"
                          v-if="
                            item.array_product == 'SKU' &&
                            item.array_product !== 'NONE'
                          "
                          prop="sku_id"
                          class="institution_star"
                          :rules="{ required: true, message: 'SKU不能为空' }"
                        >
                          <el-select
                            v-model="item.addTableList.sku_id"
                            placeholder="请选择SKU"
                            style="width: 70%; float: right"
                            clearable
                          >
                            <el-option
                              v-for="item in SkuList"
                              :key="item.key"
                              :label="item.value1"
                              :value="item.key"
                            >
                            </el-option>
                          </el-select>
                        </el-form-item>
                        <el-form-item
                          label="日期"
                          v-if="
                            item.array_date !== 'NONE' && item.array_date !== ''
                          "
                          prop="info_date"
                          class="institution_star"
                          :rules="{ required: true, message: '日期不能为空' }"
                        >
                          <el-date-picker
                            v-model="item.addTableList.info_date"
                            type="year"
                            style="width: 70%; float: right"
                            format="yyyy年"
                            value-format="yyyy年"
                            placeholder="选择年"
                            v-if="item.array_date == 'YEAR'"
                          >
                          </el-date-picker>
                          <quarter
                            v-if="item.array_date == 'QUARTER'"
                            @child-event="parentEvent"
                            :defaultValue="item.addTableList.info_date"
                            :getValue="getQuarterValue"
                            style="width: 70%; float: right"
                          ></quarter>
                          <el-date-picker
                            v-model="item.addTableList.info_date"
                            type="month"
                            style="width: 70%; float: right"
                            format="yyyy年MM月"
                            value-format="yyyy年MM月"
                            placeholder="选择月"
                            v-if="item.array_date == 'MONTH'"
                          >
                          </el-date-picker>
                          <monthComponent
                            v-if="item.array_date == 'WEEK'"
                            @week-event="parentWeekEvent"
                            :defaultValue="item.addTableList.info_date"
                            :getValue="getWeekValue"
                            style="width: 70%; float: right"
                          ></monthComponent>
                          <el-date-picker
                            v-model="item.addTableList.info_date"
                            type="date"
                            placeholder="选择日期"
                            style="width: 70%; float: right"
                            format="yyyy年MM月dd日"
                            value-format="yyyy年MM月dd日"
                            v-if="item.array_date == 'DAY'"
                          >
                          </el-date-picker>
                        </el-form-item>
                        <el-form-item
                          label="数值"
                          prop="field_value"
                          class="institution_star"
                          :rules="{ required: true, message: '数值不能为空' }"
                        >
                          <el-input
                            v-model="item.addTableList.field_value"
                            placeholder="请输入数值"
                            style="width: 70%; float: right"
                            type="number"
                          ></el-input>
                        </el-form-item>
                      </el-form>
                    </el-col>
                    <el-col :span="10">
                      <el-col style="margin-top: 20px">
                        <el-button
                          size="small"
                          style="
                            float: left;
                            margin-left: 40px;
                            background-color: #588ede;
                            border: 1px solid #588ede;
                            color: #fff;
                          "
                          @click="addTableDataHcp(item)"
                          >保存
                        </el-button>
                        <el-button
                          style="
                            float: left;
                            margin-left: 20px;
                            background-color: #e87570;
                            border: 1px solid #e87570;
                            color: #fff;
                          "
                          @click="delateTableData(item)"
                          v-if="delateFalse"
                          size="small"
                          >删除
                        </el-button>
                        <el-button
                          size="small"
                          style="
                            float: left;
                            margin-left: 20px;
                            background-color: #e87570;
                            border: 1px solid #e87570;
                            color: #fff;
                          "
                          @click="cancelTableData(item)"
                          >取消
                        </el-button>
                      </el-col>
                    </el-col>
                  </el-col>
                </el-col>
                <el-col span="24" v-else>
                  <el-form-item
                    :label="item.label"
                    :class="{ institution_star: item.mandatory == 'T' }"
                    prop="field_value"
                    :rules="
                      item.mandatory == 'T'
                        ? [{ required: true, message: item.label + '不能为空' }]
                        : []
                    "
                  >
                    <el-input
                      :rows="3"
                      v-model="item.field_value"
                      placeholder="请输入备注信息"
                      type="textarea"
                    ></el-input>
                  </el-form-item>
                </el-col>
              </el-form>
            </div>
          </el-tab-pane>
          <el-tab-pane label="照片图库" name="third">
            <div class="photoList" style="display: flex; flex-wrap: wrap">
              <div class="upload" style="float: left" @click.stop="openDetail1">
                <div class="d1"></div>
                <div class="d2"></div>
              </div>
              <div
                class="imgInfo"
                style="align-items: flex-start"
                v-for="item in imgArray1"
                @click.stop="editPhoto1(item)"
              >
                <img
                  :src="item.url"
                  style="
                    width: 120px;
                    height: 120px;
                    border-radius: 5px;
                    display: block;
                  "
                />
                <div style="min-height: 18px; width: 120px">
                  <el-tag
                    v-for="bq in item.tag"
                    :key="bq.text"
                    :disable-transitions="false"
                    style="
                      background-color: #ba9ee6;
                      color: white;
                      font-weight: bold;
                    "
                  >
                    {{ bq.text }}
                  </el-tag>
                </div>
              </div>
            </div>
            <div class="photoDetail" v-if="isDetail1">
              <el-row>
                <el-col :span="24" style="padding: 20px 20px">
                  <div
                    style="
                      color: #2b92fa;
                      font-size: 18px;
                      display: inline-block;
                      float: left;
                    "
                  >
                    照片详情
                  </div>
                  <div style="display: inline-block; float: right">
                    <el-button
                      type="primary"
                      class="button"
                      @click.stop="submitPhoto1"
                    >
                      保存
                    </el-button>
                    <el-button
                      type="danger"
                      class="button"
                      @click.stop="closeDetail1"
                    >
                      关闭
                    </el-button>
                  </div>
                </el-col>
              </el-row>
              <el-row style="margin: 10px 20px">
                <el-col span="12">
                  <el-col span="4" style="margin-top: 20px; margin-right: 20px">
                    <span
                      style="
                        display: block;
                        margin-bottom: 20px;
                        margin-left: 4px;
                        font-weight: bold;
                      "
                      >照片上传</span
                    >
                    <el-button
                      type="danger"
                      style="
                        width: 70px;
                        height: 30px;
                        padding: 5px;
                        font-size: 10px;
                        background-color: #d9443d;
                        border-color: #d9443d;
                      "
                      @click.stop="deletePhoto1"
                      >删除照片
                    </el-button>
                  </el-col>
                  <el-col span="16">
                    <el-upload
                      ref="photoUpload1"
                      class="upload-demo"
                      drag
                      accept=".jpg,.png,.jpeg"
                      action="/photos/uploadphoto"
                      :auto-upload="false"
                      :before-upload="getUuidAgenda1"
                      :on-success="getPhotoIdAgenda1"
                      :on-change="beforeUpload1"
                      :data="categoryAgenda1"
                    >
                      <i class="el-icon-upload"></i>
                      <div class="el-upload__text">
                        将文件拖到此处，或<em>点击上传</em>
                      </div>
                    </el-upload>
                  </el-col>
                </el-col>
                <el-col span="12">
                  <el-col
                    style="margin-left: 40px; margin-top: 10px"
                    class="file"
                  >
                    <span style="font-weight: bold">设置标签</span>
                    <el-input
                      v-model="tagText1"
                      placeholder="请输入照片的说明"
                      style="
                        display: inline-block;
                        margin-left: 10px;
                        width: 250px;
                      "
                      @keyup.enter.native="addTag1"
                    ></el-input>
                  </el-col>
                  <el-col style="width: 250px; margin-left: 100px">
                    <el-tag
                      closable
                      v-for="tag in tags1"
                      :key="tag.text"
                      :disable-transitions="false"
                      @close="tagClose1(tag)"
                      style="
                        background-color: #ba9ee6;
                        color: white;
                        font-weight: bold;
                      "
                    >
                      {{ tag.text }}
                    </el-tag>
                  </el-col>
                </el-col>
              </el-row>
            </div>
          </el-tab-pane>
          <el-tab-pane label="附加文件" name="four">
            <div class="">
              <el-col style="color: #2b92fa; margin-bottom: 10px">
                文件总数：{{ fileTable1.length }}个（视频：{{
                  statistics1.mp4Num ? statistics1.mp4Num : 0
                }}个，幻灯片：
                {{
                  statistics1.slideNum ? statistics1.slideNum : 0
                }}个，图片：{{
                  statistics1.imgNum ? statistics1.imgNum : 0
                }}个，文档：{{
                  statistics1.docNum ? statistics1.docNum : 0
                }}个，其他：{{
                  statistics1.restsNum ? statistics1.restsNum : 0
                }}个）
              </el-col>
              <el-table :data="fileTable1" border>
                <el-table-column sortable label="文件名称">
                  <template slot-scope="scope">
                    {{ scope.row.file_name }}
                    <el-tag
                      v-for="bq in scope.row.tag"
                      :key="bq.text"
                      :disable-transitions="false"
                      style="
                        background-color: #ba9ee6;
                        color: white;
                        font-weight: bold;
                      "
                    >
                      {{ bq.text }}
                    </el-tag>
                  </template>
                </el-table-column>
                <el-table-column sortable prop="category" label="文件类型">
                  <template slot-scope="scope">
                    {{ isFileType(scope.row.category) }}
                  </template>
                </el-table-column>
                <el-table-column sortable prop="file_size" label="文件大小">
                  <template slot-scope="scope">
                    <span>{{ getFileSize(scope.row.file_size) }}</span>
                  </template>
                </el-table-column>
                <el-table-column sortable prop="status" label="状态">
                  <template slot-scope="scope">
                    {{ scope.row.status == "ACTIVE" ? "有效" : "无效" }}
                  </template>
                </el-table-column>
                <el-table-column label="操作">
                  <template slot-scope="scope">
                    <el-button
                      @click="editFile(scope.$index, scope.row)"
                      type="warning"
                      size="mini"
                      >详情
                    </el-button>
                    <el-button
                      @click="downloadFile(scope.row)"
                      type="primary"
                      size="mini"
                      >下载
                    </el-button>
                  </template>
                </el-table-column>
              </el-table>
              <el-button
                type="success"
                size="small"
                icon="el-icon-plus"
                style="margin-top: 10px"
                @click.stop="openFileDetail"
                >添加文件
              </el-button>
            </div>
            <div class="photoDetail" v-if="fileDetail">
              <el-row>
                <el-col :span="24" style="padding: 20px 20px">
                  <div
                    style="
                      color: #2b92fa;
                      font-size: 18px;
                      display: inline-block;
                      float: left;
                    "
                  >
                    文件详情
                  </div>
                  <div style="display: inline-block; float: right">
                    <el-button
                      type="primary"
                      class="button"
                      @click.stop="submitFiles1"
                    >
                      保存
                    </el-button>
                    <el-button
                      type="danger"
                      class="button"
                      @click.stop="closeFileDetail"
                    >
                      关闭
                    </el-button>
                  </div>
                </el-col>
              </el-row>
              <el-row style="margin: 10px 20px">
                <el-col span="12">
                  <el-col span="4" style="margin-top: 20px; margin-right: 20px">
                    <span
                      style="
                        display: block;
                        margin-bottom: 20px;
                        margin-left: 4px;
                        font-weight: bold;
                      "
                      >文件上传</span
                    >
                    <el-button
                      type="danger"
                      style="
                        width: 70px;
                        height: 30px;
                        padding: 5px;
                        font-size: 10px;
                        background-color: #d9443d;
                        border-color: #d9443d;
                      "
                      @click.stop="deleteFile1"
                      >删除文件
                    </el-button>
                  </el-col>
                  <el-col span="16">
                    <el-upload
                      ref="uploadFile1"
                      class="upload-demo"
                      drag
                      :action="getUrl()"
                      :before-upload="beforeFileUpload"
                      :on-success="fileSuccess1"
                      :auto-upload="false"
                    >
                      <i class="el-icon-upload"></i>
                      <div class="el-upload__text">
                        将文件拖到此处，或<em>点击上传</em>
                      </div>
                    </el-upload>
                  </el-col>
                </el-col>
                <el-col span="12">
                  <el-col
                    style="margin-left: 40px; margin-top: 10px"
                    class="file"
                  >
                    <span style="font-weight: bold">设置标签</span>
                    <el-input
                      placeholder="请输入文件的说明"
                      style="
                        display: inline-block;
                        margin-left: 10px;
                        width: 250px;
                      "
                      v-model="fileTag"
                      @keyup.enter.native="addFileTag"
                    ></el-input>
                  </el-col>
                  <el-col style="width: 250px; margin-left: 100px">
                    <el-tag
                      closable
                      v-for="tag in fileTags"
                      :key="tag.text"
                      :disable-transitions="false"
                      @close="fileTagClose(tag)"
                      style="
                        background-color: #ba9ee6;
                        color: white;
                        font-weight: bold;
                      "
                    >
                      {{ tag.text }}
                    </el-tag>
                  </el-col>
                </el-col>
              </el-row>
            </div>
          </el-tab-pane>
        </el-tabs>
      </div>
    </el-dialog>
    <!--门店编辑-->
    <el-dialog
      :visible.sync="storedialogVisible"
      width="900px"
      :show-close="false"
      style="vertical-align: center; :#FFF9F3 "
    >
      <div style="margin-top: -40px">
        <el-row style="padding-bottom: 10px">
          <el-col :span="12">
            <div style="color: #3998f7; padding-top: 8px; font-size: 20px">
              门店详情
            </div>
          </el-col>

          <el-col :span="12">
            <div align="right">
              <el-button
                type="primary"
                size="small"
                @click="baocun2_1"
                v-if="activeName2 !== 'third' && activeName2 !== 'four'"
              >
                保存
              </el-button>
              <el-button type="danger" size="small" @click="guanbi2_1">
                关闭
              </el-button>
            </div>
          </el-col>
        </el-row>
        <el-tabs v-model="activeName2" @tab-click="handleClickTabs">
          <el-tab-pane label="基本信息" name="first">
            <div class="subjectList" style="margin-top: 20px">
              <el-form
                ref="storelist"
                :model="storelist"
                label-width="120px"
                :rules="rules"
                hide-required-asterisk
              >
                <el-row>
                  <el-col :span="12">
                    <el-form-item
                      label="名称"
                      prop="store_name"
                      class="institution_star"
                    >
                      <el-input v-model="storelist.store_name"></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :span="12">
                    <el-form-item
                      label="编码"
                      prop="store_code"
                      class="institution_star"
                    >
                      <el-input v-model="storelist.store_code"></el-input>
                    </el-form-item>
                  </el-col>
                </el-row>

                <el-row>
                  <el-col :span="12">
                    <el-form-item
                      label="类别"
                      prop="store_type"
                      class="institution_star"
                    >
                      <el-select
                        v-model="storelist.store_type"
                        placeholder="请选择"
                        style="width: 100%"
                        @change="fangfa2_1"
                        clearable
                      >
                        <el-option
                          v-for="item in TypeList"
                          :key="item.key"
                          :label="item.value1"
                          :value="item.key"
                        >
                        </el-option>
                      </el-select>
                    </el-form-item>
                  </el-col>
                  <el-col :span="12">
                    <el-form-item label="级别">
                      <el-select
                        v-model="storelist.retailstore_grade_name"
                        placeholder="请选择"
                        style="width: 100%"
                        clearable
                      >
                        <el-option
                          v-for="item in GardeList"
                          :key="item.key"
                          :label="item.value1"
                          :value="item.key"
                        >
                        </el-option>
                      </el-select>
                    </el-form-item>
                  </el-col>
                </el-row>

                <el-row>
                  <el-col :span="12">
                    <el-form-item
                      label="省份"
                      prop="province_id"
                      class="institution_star"
                    >
                      <el-select
                        v-model="storelist.province_id"
                        placeholder="请选择"
                        @change="fangfa"
                        style="width: 100%"
                        clearable
                      >
                        <el-option
                          v-for="item in data"
                          :key="item.id"
                          :label="item.label"
                          :value="item.id"
                        >
                        </el-option>
                      </el-select>
                    </el-form-item>
                  </el-col>
                  <el-col :span="12">
                    <el-form-item
                      label="城市"
                      prop="city_name"
                      class="institution_star"
                    >
                      <el-select
                        v-model="storelist.city_name"
                        placeholder="请选择"
                        style="width: 100%"
                        clearable
                      >
                        <el-option
                          v-for="item in CityList"
                          :key="item.city_id"
                          :label="item.city_name"
                          :value="item.city_id"
                        >
                        </el-option>
                      </el-select>
                    </el-form-item>
                  </el-col>
                  <el-col :span="12">
                    <el-form-item label="所属医疗机构">
                      <el-select
                        v-model="storelist.institution_id"
                        filterable
                        placeholder="请选择医疗机构"
                        style="width: 100%"
                        clearable
                      >
                        <el-option
                          v-for="item in institutionList"
                          :key="item.institution_id"
                          :label="item.institution_name"
                          :value="item.institution_id"
                        >
                        </el-option>
                      </el-select>
                    </el-form-item>
                  </el-col>
                  <!--                                    <el-col :span="12">-->
                  <!--                                        <el-form-item label="所属医疗机构" >-->
                  <!--                                            <el-select v-model="storelist.institution_id"  placeholder="请选择"  style="width: 100%">-->
                  <!--                                                <el-option-->
                  <!--                                                        v-for="item in institutionList"-->
                  <!--                                                        :key="item.institution_id"-->
                  <!--                                                        :label="item.institution_name"-->
                  <!--                                                        :value="item.institution_id">-->
                  <!--                                                </el-option>-->
                  <!--                                            </el-select>-->
                  <!--                                        </el-form-item>-->
                  <!--                                    </el-col>-->
                  <el-col :span="12">
                    <el-form-item label="地址">
                      <el-input v-model="storelist.address"></el-input>
                    </el-form-item>
                  </el-col>
                </el-row>

                <el-row>
                  <el-col :span="12">
                    <el-form-item label="联系电话">
                      <el-input v-model="storelist.telephone"></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :span="12">
                    <el-form-item label="邮政编码">
                      <el-input v-model="storelist.postcode"></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :span="12">
                    <el-form-item label="官方网址">
                      <el-input
                        v-model="storelist.website"
                        placeholder="请输入网址"
                      ></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :span="12">
                    <el-form-item label="所属经销商">
                      <el-select
                        v-model="storelist.distributor_id"
                        filterable
                        placeholder="请选择经销商"
                        style="width: 100%"
                        clearable
                      >
                        <el-option
                          v-for="item in distributorList"
                          :key="item.distributor_id"
                          :label="item.distributor_name"
                          :value="item.distributor_id"
                        >
                        </el-option>
                      </el-select>
                    </el-form-item>
                  </el-col>
                </el-row>

                <el-form-item label="备注">
                  <el-input
                    :rows="3"
                    v-model="storelist.comments"
                    placeholder="请输入备注信息"
                    type="textarea"
                  ></el-input>
                </el-form-item>

                <el-form-item label="有效" prop="status">
                  <el-switch v-model="storelist.status" active-color="#13ce66">
                  </el-switch>
                </el-form-item>
              </el-form>
            </div>
          </el-tab-pane>
          <el-tab-pane
            :label="items.group_name"
            :name="items.name"
            v-for="(items, j) in extendedInfo2_1"
          >
            <div class="subjectList" style="margin-top: 20px">
              <el-form
                :ref="'storelist' + j"
                label-width="15%"
                v-for="(item, j) in items.fieldArray"
                :model="item"
                :key="item.field_id"
                hide-required-asterisk
              >
                <el-col span="24" v-if="item.input_type == 'TEXT'">
                  <el-form-item
                    :label="item.label"
                    :class="{ institution_star: item.mandatory == 'T' }"
                    prop="field_value"
                    :rules="
                      item.mandatory == 'T'
                        ? [{ required: true, message: item.label + '不能为空' }]
                        : []
                    "
                  >
                    <el-input
                      v-model="item.field_value"
                      placeholder="请输入文本"
                    ></el-input>
                  </el-form-item>
                </el-col>
                <el-col span="24" v-else-if="item.input_type == 'NUMBER'">
                  <el-form-item
                    :label="item.label"
                    :class="{ institution_star: item.mandatory == 'T' }"
                    prop="field_value"
                    :rules="
                      item.mandatory == 'T'
                        ? [{ required: true, message: item.label + '不能为空' }]
                        : []
                    "
                  >
                    <el-input
                      v-model="item.field_value"
                      placeholder="请输入数字"
                      type="number"
                    ></el-input>
                  </el-form-item>
                </el-col>
                <el-col span="24" v-else-if="item.input_type == 'DATE'">
                  <el-form-item
                    :label="item.label"
                    :class="{ institution_star: item.mandatory == 'T' }"
                    prop="field_value"
                    :rules="
                      item.mandatory == 'T'
                        ? [{ required: true, message: item.label + '不能为空' }]
                        : []
                    "
                  >
                    <el-date-picker
                      v-model="item.field_value"
                      type="date"
                      placeholder="选择日期时间"
                      style="width: 100%"
                      format="yyyy-MM-dd"
                      value-format="yyyy-MM-dd"
                    >
                    </el-date-picker>
                  </el-form-item>
                </el-col>
                <el-col span="24" v-else-if="item.input_type == 'TRUE-FALSE'">
                  <el-form-item :label="item.label">
                    <el-switch
                      v-model="item.field_value"
                      active-color="#13ce66"
                      active-value="T"
                      inactive-value="F"
                    >
                    </el-switch>
                  </el-form-item>
                </el-col>
                <el-col span="24" v-else-if="item.input_type == 'LIST'">
                  <el-form-item
                    :label="item.label"
                    :class="{ institution_star: item.mandatory == 'T' }"
                    prop="field_value"
                    :rules="
                      item.mandatory == 'T'
                        ? [{ required: true, message: item.label + '不能为空' }]
                        : []
                    "
                  >
                    <!--                                        <el-select v-model="item.field_value" :multiple="item.multiple == 'T'" placeholder="请选择" style="width: 100%" >-->
                    <!--                                            <el-option-->
                    <!--                                                    v-for="item in item.listArray"-->
                    <!--                                                    :key="item.key"-->
                    <!--                                                    :label="item.value1"-->
                    <!--                                                    :value="item.key">-->
                    <!--                                            </el-option>-->
                    <!--                                        </el-select>-->
                    <el-cascader
                      v-model="item.field_value"
                      :options="item.listArray"
                      style="width: 100%"
                      filterable
                      :show-all-levels="false"
                      :props="{
                        multiple: item.multiple == 'T' ? true : false,
                        checkStrictly: true,
                      }"
                      clearable
                    ></el-cascader>
                  </el-form-item>
                </el-col>
                <el-col span="24" v-else-if="item.input_type == 'TABLE'">
                  <el-form-item
                    :label="item.label"
                    :class="{ institution_star: item.mandatory == 'T' }"
                    prop="field_value"
                    :rules="
                      item.mandatory == 'T'
                        ? [{ required: true, message: item.label + '不能为空' }]
                        : []
                    "
                  >
                    <el-table
                      :data="item.field_value"
                      border
                      style="width: 100%"
                    >
                      <el-table-column type="index" label="序号" width="50">
                      </el-table-column>
                      <el-table-column
                        prop="dept_name"
                        label="标准科室"
                        v-if="item.array_dept !== 'NONE'"
                      >
                      </el-table-column>
                      <el-table-column
                        prop="product_name"
                        label="产品"
                        v-if="item.array_product !== 'NONE'"
                      >
                      </el-table-column>
                      <el-table-column
                        prop="sku_name"
                        label="SKU"
                        v-if="
                          item.array_product == 'SKU' &&
                          item.array_product !== 'NONE'
                        "
                      >
                      </el-table-column>
                      <el-table-column
                        prop="date_name"
                        label="日期"
                        v-if="item.array_date !== 'NONE'"
                      >
                      </el-table-column>
                      <el-table-column prop="field_value" label="数值">
                      </el-table-column>
                      <el-table-column fixed="right" label="操作" width="80">
                        <template slot-scope="scope">
                          <el-button
                            @click="
                              handleTableClick(scope.$index, scope.row, item)
                            "
                            style="
                              background-color: rgb(255, 153, 1);
                              border: 1px solid rgb(255, 153, 1);
                              color: #fff;
                            "
                            size="small"
                            >详情
                          </el-button>
                        </template>
                      </el-table-column>
                    </el-table>
                  </el-form-item>
                  <el-col :span="24" style="margin-bottom: 10px">
                    <el-button
                      size="small"
                      icon="el-icon-plus"
                      style="
                        float: left;
                        margin-left: 15%;
                        background-color: #6cc584;
                        border: 1px solid #6cc584;
                        color: #fff;
                      "
                      @click="addNewTable(item)"
                      >添加新数据
                    </el-button>
                  </el-col>
                  <el-col
                    :span="24"
                    v-if="item.isAddTable"
                    id="addTable1"
                    style="
                      margin-left: 15%;
                      width: 85%;
                      background: #edf3fb;
                      border: 1px solid #ecdfe6;
                      margin-bottom: 10px;
                      border-radius: 10px;
                    "
                  >
                    <el-col :span="14">
                      <el-form
                        ref="addTable"
                        :model="item.addTableList"
                        style="margin-top: 20px"
                        hide-required-asterisk
                      >
                        <el-form-item
                          label="标准科室"
                          v-if="item.array_dept !== 'NONE'"
                          prop="dept_id"
                          class="institution_star"
                          :rules="{
                            required: true,
                            message: '标准科室不能为空',
                          }"
                        >
                          <el-select
                            v-model="item.addTableList.dept_id"
                            placeholder="请选择标准科室"
                            style="width: 70%; float: right"
                            clearable
                          >
                            <el-option
                              v-for="item in administrativeList"
                              :key="item.key"
                              :label="item.value1"
                              :value="item.key"
                            >
                            </el-option>
                          </el-select>
                        </el-form-item>
                        <el-form-item
                          label="产品"
                          v-if="item.array_product !== 'NONE'"
                          prop="product_id"
                          class="institution_star"
                          :rules="{ required: true, message: '产品不能为空' }"
                        >
                          <el-select
                            v-model="item.addTableList.product_id"
                            placeholder="请选择产品"
                            style="width: 70%; float: right"
                            @change="getSkuList(item)"
                            clearable
                          >
                            <el-option
                              v-for="item in productList"
                              :key="item.key"
                              :label="item.value1"
                              :value="item.key"
                            >
                            </el-option>
                          </el-select>
                        </el-form-item>
                        <el-form-item
                          label="SKU"
                          v-if="
                            item.array_product == 'SKU' &&
                            item.array_product !== 'NONE'
                          "
                          prop="sku_id"
                          class="institution_star"
                          :rules="{ required: true, message: 'SKU不能为空' }"
                        >
                          <el-select
                            v-model="item.addTableList.sku_id"
                            placeholder="请选择SKU"
                            style="width: 70%; float: right"
                            clearable
                          >
                            <el-option
                              v-for="item in SkuList"
                              :key="item.key"
                              :label="item.value1"
                              :value="item.key"
                            >
                            </el-option>
                          </el-select>
                        </el-form-item>
                        <el-form-item
                          label="日期"
                          v-if="
                            item.array_date !== 'NONE' && item.array_date !== ''
                          "
                          prop="info_date"
                          class="institution_star"
                          :rules="{ required: true, message: '日期不能为空' }"
                        >
                          <el-date-picker
                            v-model="item.addTableList.info_date"
                            type="year"
                            style="width: 70%; float: right"
                            format="yyyy年"
                            value-format="yyyy年"
                            placeholder="选择年"
                            v-if="item.array_date == 'YEAR'"
                          >
                          </el-date-picker>
                          <quarter
                            v-if="item.array_date == 'QUARTER'"
                            @child-event="parentEvent"
                            :defaultValue="item.addTableList.info_date"
                            :getValue="getQuarterValue"
                            style="width: 70%; float: right"
                          ></quarter>
                          <el-date-picker
                            v-model="item.addTableList.info_date"
                            type="month"
                            style="width: 70%; float: right"
                            format="yyyy年MM月"
                            value-format="yyyy年MM月"
                            placeholder="选择月"
                            v-if="item.array_date == 'MONTH'"
                          >
                          </el-date-picker>
                          <monthComponent
                            v-if="item.array_date == 'WEEK'"
                            @week-event="parentWeekEvent"
                            :defaultValue="item.addTableList.info_date"
                            :getValue="getWeekValue"
                            style="width: 70%; float: right"
                          ></monthComponent>
                          <el-date-picker
                            v-model="item.addTableList.info_date"
                            type="date"
                            placeholder="选择日期"
                            style="width: 70%; float: right"
                            format="yyyy年MM月dd日"
                            value-format="yyyy年MM月dd日"
                            v-if="item.array_date == 'DAY'"
                          >
                          </el-date-picker>
                        </el-form-item>
                        <el-form-item
                          label="数值"
                          prop="field_value"
                          class="institution_star"
                          :rules="{ required: true, message: '数值不能为空' }"
                        >
                          <el-input
                            v-model="item.addTableList.field_value"
                            placeholder="请输入数值"
                            style="width: 70%; float: right"
                            type="number"
                          ></el-input>
                        </el-form-item>
                      </el-form>
                    </el-col>
                    <el-col :span="10">
                      <el-col style="margin-top: 20px">
                        <el-button
                          size="small"
                          style="
                            float: left;
                            margin-left: 40px;
                            background-color: #588ede;
                            border: 1px solid #588ede;
                            color: #fff;
                          "
                          @click="addTableData(item)"
                          >保存
                        </el-button>
                        <el-button
                          style="
                            float: left;
                            margin-left: 20px;
                            background-color: #e87570;
                            border: 1px solid #e87570;
                            color: #fff;
                          "
                          @click="delateTableData(item)"
                          v-if="delateFalse"
                          size="small"
                          >删除
                        </el-button>
                        <el-button
                          size="small"
                          style="
                            float: left;
                            margin-left: 20px;
                            background-color: #e87570;
                            border: 1px solid #e87570;
                            color: #fff;
                          "
                          @click="cancelTableData(item)"
                          >取消
                        </el-button>
                      </el-col>
                    </el-col>
                  </el-col>
                </el-col>
                <el-col span="24" v-else>
                  <el-form-item
                    :label="item.label"
                    :class="{ institution_star: item.mandatory == 'T' }"
                    prop="field_value"
                    :rules="
                      item.mandatory == 'T'
                        ? [{ required: true, message: item.label + '不能为空' }]
                        : []
                    "
                  >
                    <el-input
                      :rows="3"
                      v-model="item.field_value"
                      placeholder="请输入备注信息"
                      type="textarea"
                    ></el-input>
                  </el-form-item>
                </el-col>
              </el-form>
            </div>
          </el-tab-pane>
          <el-tab-pane label="照片图库" name="third">
            <div class="photoList" style="display: flex; flex-wrap: wrap">
              <div
                class="upload"
                style="float: left"
                @click.stop="openDetail2_1"
              >
                <div class="d1"></div>
                <div class="d2"></div>
              </div>
              <div
                class="imgInfo"
                style="align-items: flex-start"
                v-for="item in imgArray"
                @click.stop="editPhoto(item)"
              >
                <img
                  :src="item.url"
                  style="
                    width: 120px;
                    height: 120px;
                    border-radius: 5px;
                    display: block;
                  "
                />
                <div style="min-height: 18px; width: 120px">
                  <el-tag
                    v-for="bq in item.tag"
                    :key="bq.text"
                    :disable-transitions="false"
                    style="
                      background-color: #ba9ee6;
                      color: white;
                      font-weight: bold;
                    "
                  >
                    {{ bq.text }}
                  </el-tag>
                </div>
              </div>
            </div>
            <div class="photoDetail" v-if="isDetail">
              <el-row>
                <el-col :span="24" style="padding: 20px 20px">
                  <div
                    style="
                      color: #2b92fa;
                      font-size: 18px;
                      display: inline-block;
                      float: left;
                    "
                  >
                    照片详情
                  </div>
                  <div style="display: inline-block; float: right">
                    <el-button
                      type="primary"
                      class="button"
                      @click="submitPhoto2_1"
                    >
                      保存
                    </el-button>
                    <el-button
                      type="danger"
                      class="button"
                      @click="closeDetail"
                    >
                      关闭
                    </el-button>
                  </div>
                </el-col>
              </el-row>
              <el-row style="margin: 10px 20px">
                <el-col span="12">
                  <el-col span="4" style="margin-top: 20px; margin-right: 20px">
                    <span
                      style="
                        display: block;
                        margin-bottom: 20px;
                        margin-left: 4px;
                        font-weight: bold;
                      "
                      >照片上传</span
                    >
                    <el-button
                      type="danger"
                      style="
                        width: 70px;
                        height: 30px;
                        padding: 5px;
                        font-size: 10px;
                        background-color: #d9443d;
                        border-color: #d9443d;
                      "
                      @click.stop="deletePhoto"
                      >删除照片
                    </el-button>
                  </el-col>
                  <el-col span="16">
                    <el-upload
                      ref="photoUpload"
                      class="upload-demo"
                      drag
                      accept=".jpg,.png,.jpeg"
                      action="/photos/uploadphoto"
                      :auto-upload="false"
                      :before-upload="getUuidAgenda"
                      :on-success="getPhotoIdAgenda"
                      :on-change="beforeUpload"
                      :data="categoryAgenda"
                    >
                      <i class="el-icon-upload"></i>
                      <div class="el-upload__text">
                        将文件拖到此处，或<em>点击上传</em>
                      </div>
                    </el-upload>
                  </el-col>
                </el-col>
                <el-col span="12">
                  <el-col style="margin-left: 20px; margin-top: 10px">
                    <span style="font-weight: bold">设置标签</span>
                    <el-input
                      placeholder="请输入照片的说明"
                      style="
                        display: inline-block;
                        margin-left: 10px;
                        width: 300px;
                      "
                      v-model="tagText"
                      @keyup.enter.native="addTag"
                      @input.native="change($event)"
                    ></el-input>
                  </el-col>
                  <el-col style="width: 300px; margin-left: 85px">
                    <el-tag
                      closable
                      v-for="tag in tags"
                      :key="tag.text"
                      :disable-transitions="false"
                      @close="tagClose(tag)"
                      style="
                        background-color: #ba9ee6;
                        color: white;
                        font-weight: bold;
                      "
                    >
                      {{ tag.text }}
                    </el-tag>
                  </el-col>
                </el-col>
              </el-row>
            </div>
          </el-tab-pane>
          <el-tab-pane label="附加文件" name="four">
            <div class="">
              <el-col style="color: #2b92fa; margin-bottom: 10px">
                文件总数：{{ fileTable.length }}个（视频：{{
                  statistics.mp4Num ? statistics.mp4Num : 0
                }}个，幻灯片：
                {{ statistics.slideNum ? statistics.slideNum : 0 }}个，图片：{{
                  statistics.imgNum ? statistics.imgNum : 0
                }}个，文档：{{
                  statistics.docNum ? statistics.docNum : 0
                }}个，其他：{{
                  statistics.restsNum ? statistics.restsNum : 0
                }}个）
              </el-col>
              <el-table :data="fileTable" border>
                <el-table-column sortable label="文件名称" width="180">
                  <template slot-scope="scope">
                    {{ scope.row.file_name }}
                    <el-tag
                      v-for="bq in scope.row.tag"
                      :key="bq.text"
                      :disable-transitions="false"
                      style="
                        background-color: #ba9ee6;
                        color: white;
                        font-weight: bold;
                      "
                    >
                      {{ bq.text }}
                    </el-tag>
                  </template>
                </el-table-column>
                <el-table-column sortable prop="category" label="文件类型">
                  <template slot-scope="scope">
                    {{ isFileType(scope.row.category) }}
                  </template>
                </el-table-column>
                <el-table-column sortable prop="file_size" label="文件大小">
                  <template slot-scope="scope">
                    <span>{{ getFileSize(scope.row.file_size) }}</span>
                  </template>
                </el-table-column>
                <el-table-column sortable prop="status" label="状态">
                  <template slot-scope="scope">
                    {{ scope.row.status == "ACTIVE" ? "有效" : "无效" }}
                  </template>
                </el-table-column>
                <el-table-column label="操作">
                  <template slot-scope="scope">
                    <el-button
                      @click="editFile(scope.$index, scope.row)"
                      type="warning"
                      size="mini"
                      >详情
                    </el-button>
                    <el-button
                      @click="downloadFile(scope.row)"
                      type="primary"
                      size="mini"
                      >下载
                    </el-button>
                  </template>
                </el-table-column>
              </el-table>
              <el-button
                type="success"
                size="small"
                icon="el-icon-plus"
                style="margin-top: 10px"
                @click.stop="openFileDetail"
                >添加文件
              </el-button>
            </div>
            <div class="photoDetail" v-if="fileDetail">
              <el-row>
                <el-col :span="24" style="padding: 20px 20px">
                  <div
                    style="
                      color: #2b92fa;
                      font-size: 18px;
                      display: inline-block;
                      float: left;
                    "
                  >
                    文件详情
                  </div>
                  <div style="display: inline-block; float: right">
                    <el-button
                      type="primary"
                      class="button"
                      @click.stop="submitFiles2"
                    >
                      保存
                    </el-button>
                    <el-button
                      type="danger"
                      class="button"
                      @click.stop="closeFileDetail"
                    >
                      关闭
                    </el-button>
                  </div>
                </el-col>
              </el-row>
              <el-row style="margin: 10px 20px">
                <el-col span="12">
                  <el-col span="4" style="margin-top: 20px; margin-right: 20px">
                    <span
                      style="
                        display: block;
                        margin-bottom: 20px;
                        margin-left: 4px;
                        font-weight: bold;
                      "
                      >文件上传</span
                    >
                    <el-button
                      type="danger"
                      style="
                        width: 70px;
                        height: 30px;
                        padding: 5px;
                        font-size: 10px;
                        background-color: #d9443d;
                        border-color: #d9443d;
                      "
                      @click.stop="deleteFile"
                      >删除文件
                    </el-button>
                  </el-col>
                  <el-col span="16">
                    <el-upload
                      ref="uploadFile"
                      drag
                      :action="getUrl()"
                      :before-upload="beforeFileUpload"
                      :on-success="fileSuccess"
                      :auto-upload="false"
                    >
                      <i class="el-icon-upload"></i>
                      <div class="el-upload__text">
                        将文件拖到此处，或<em>点击上传</em>
                      </div>
                    </el-upload>
                  </el-col>
                </el-col>
                <el-col span="12">
                  <el-col style="margin-left: 20px; margin-top: 10px">
                    <span style="font-weight: bold">设置标签</span>
                    <el-input
                      placeholder="请输入文件的说明"
                      style="
                        display: inline-block;
                        margin-left: 10px;
                        width: 300px;
                      "
                      v-model="fileTag"
                      @keyup.enter.native="addFileTag"
                    ></el-input>
                  </el-col>
                  <el-col style="width: 300px; margin-left: 85px">
                    <el-tag
                      closable
                      v-for="tag in fileTags"
                      :key="tag.text"
                      :disable-transitions="false"
                      @close="fileTagClose(tag)"
                      style="
                        background-color: #ba9ee6;
                        color: white;
                        font-weight: bold;
                      "
                    >
                      {{ tag.text }}
                    </el-tag>
                  </el-col>
                </el-col>
              </el-row>
            </div>
          </el-tab-pane>
        </el-tabs>
      </div>
    </el-dialog>
    <!--店员详情-->
    <el-dialog
      :visible.sync="storedialogVisible2"
      width="900px"
      :show-close="false"
      style="vertical-align: center; :#FFF9F3 "
    >
      <div style="margin-top: -40px">
        <el-row style="padding-bottom: 10px">
          <el-col :span="12">
            <div style="color: #3998f7; padding-top: 8px; font-size: 20px">
              店员详情
            </div>
          </el-col>

          <el-col :span="12">
            <div align="right">
              <el-button type="primary" size="small" @click="baocun2_2">
                保存
              </el-button>
              <el-button type="danger" size="small" @click="guanbi2_2">
                关闭
              </el-button>
            </div>
          </el-col>
        </el-row>
        <el-tabs v-model="activeName1" @tab-click="handleClickTabs">
          <el-tab-pane label="基本信息" name="first">
            <div class="DianClass" style="margin-top: 20px">
              <el-form
                ref="clerkClass"
                :model="clerkClass"
                label-width="150px"
                hide-required-asterisk
              >
                <!--                        <el-row >-->
                <!--                            <el-col :span="12">-->
                <!--                                <el-form-item-->
                <!--                                        label="店员编码"-->
                <!--                                        prop="clerk_code"-->
                <!--                                        :rules="[-->
                <!--                                            { required: true, message: '店员编码不能为空'},-->
                <!--                                        ]"-->
                <!--                                >-->
                <!--                                    <el-input v-model="clerkClass.clerk_code" placeholder="请输入店员编码"></el-input>-->
                <!--                                </el-form-item>-->
                <!--                            </el-col>-->
                <!--                        </el-row>-->
                <el-row>
                  <el-col :span="12">
                    <el-form-item
                      class="institution_star"
                      label="姓名"
                      prop="clerk_name"
                      :rules="[{ required: true, message: '姓名不能为空' }]"
                    >
                      <el-input
                        v-model="clerkClass.clerk_name"
                        placeholder="请输入姓名"
                      ></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :span="12">
                    <el-form-item label="性别">
                      <el-select
                        v-model="clerkClass.gender"
                        style="width: 100%"
                        placeholder="请选择"
                        clearable
                      >
                        <el-option label="男" value="M"></el-option>
                        <el-option label="女" value="F"></el-option>
                      </el-select>
                    </el-form-item>
                  </el-col>
                  <el-col :span="12">
                    <el-form-item label="联系电话">
                      <el-input
                        v-model="clerkClass.mobile"
                        placeholder="请输入联系电话"
                      ></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :span="12">
                    <el-form-item label="电子邮件">
                      <el-input
                        v-model="clerkClass.email"
                        placeholder="请输入电子邮箱"
                      ></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :span="12">
                    <el-form-item label="生日">
                      <el-date-picker
                        v-model="clerkClass.birthday"
                        type="date"
                        value-format="yyyy-MM-dd"
                        placeholder="请选择出生日期"
                        style="width: 100%"
                      >
                      </el-date-picker>
                    </el-form-item>
                  </el-col>
                  <el-col :span="12">
                    <el-form-item label="爱好">
                      <el-input
                        v-model="clerkClass.hobby"
                        placeholder="请输入个人爱好"
                      ></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :span="12">
                    <el-form-item label="店长">
                      <el-switch
                        v-model="clerkClass.manager"
                        active-color="#13ce66"
                      >
                      </el-switch>
                    </el-form-item>
                  </el-col>
                  <el-col :span="12">
                    <el-form-item label="在职">
                      <el-switch
                        v-model="clerkClass.status"
                        active-color="#13ce66"
                      >
                      </el-switch>
                    </el-form-item>
                  </el-col>
                </el-row>
              </el-form>
            </div>
          </el-tab-pane>
          <el-tab-pane
            :label="items.group_name"
            :name="items.name"
            :key="j"
            v-for="(items, j) in extendedInfo2_2"
          >
            <div class="subjectList" style="margin-top: 20px">
              <el-form
                :ref="'assistantList' + j"
                label-width="15%"
                v-for="(item, j) in items.fieldArray"
                :model="item"
                :key="item.field_id"
                hide-required-asterisk
              >
                <el-col span="24" v-if="item.input_type == 'TEXT'">
                  <el-form-item
                    :label="item.label"
                    :class="{ institution_star: item.mandatory == 'T' }"
                    prop="field_value"
                    :rules="
                      item.mandatory == 'T'
                        ? [{ required: true, message: item.label + '不能为空' }]
                        : []
                    "
                  >
                    <el-input
                      v-model="item.field_value"
                      placeholder="请输入文本"
                    ></el-input>
                  </el-form-item>
                </el-col>
                <el-col span="24" v-else-if="item.input_type == 'NUMBER'">
                  <el-form-item
                    :label="item.label"
                    :class="{ institution_star: item.mandatory == 'T' }"
                    prop="field_value"
                    :rules="
                      item.mandatory == 'T'
                        ? [{ required: true, message: item.label + '不能为空' }]
                        : []
                    "
                  >
                    <el-input
                      v-model="item.field_value"
                      placeholder="请输入数字"
                      type="number"
                    ></el-input>
                  </el-form-item>
                </el-col>
                <el-col span="24" v-else-if="item.input_type == 'DATE'">
                  <el-form-item
                    :label="item.label"
                    :class="{ institution_star: item.mandatory == 'T' }"
                    prop="field_value"
                    :rules="
                      item.mandatory == 'T'
                        ? [{ required: true, message: item.label + '不能为空' }]
                        : []
                    "
                  >
                    <el-date-picker
                      v-model="item.field_value"
                      type="date"
                      placeholder="选择日期时间"
                      style="width: 100%"
                      format="yyyy-MM-dd"
                      value-format="yyyy-MM-dd"
                    >
                    </el-date-picker>
                  </el-form-item>
                </el-col>
                <el-col span="24" v-else-if="item.input_type == 'TRUE-FALSE'">
                  <el-form-item :label="item.label">
                    <el-switch
                      v-model="item.field_value"
                      active-color="#13ce66"
                      active-value="T"
                      inactive-value="F"
                    >
                    </el-switch>
                  </el-form-item>
                </el-col>
                <el-col span="24" v-else-if="item.input_type == 'LIST'">
                  <el-form-item
                    :label="item.label"
                    :class="{ institution_star: item.mandatory == 'T' }"
                    prop="field_value"
                    :rules="
                      item.mandatory == 'T'
                        ? [{ required: true, message: item.label + '不能为空' }]
                        : []
                    "
                  >
                    <!--                                        <el-select v-model="item.field_value" :multiple="item.multiple == 'T'" placeholder="请选择" style="width: 100%" >-->
                    <!--                                            <el-option-->
                    <!--                                                    v-for="item in item.listArray"-->
                    <!--                                                    :key="item.key"-->
                    <!--                                                    :label="item.value1"-->
                    <!--                                                    :value="item.key">-->
                    <!--                                            </el-option>-->
                    <!--                                        </el-select>-->
                    <el-cascader
                      v-model="item.field_value"
                      :options="item.listArray"
                      style="width: 100%"
                      filterable
                      :show-all-levels="false"
                      :props="{
                        multiple: item.multiple == 'T' ? true : false,
                        checkStrictly: true,
                      }"
                      clearable
                    ></el-cascader>
                  </el-form-item>
                </el-col>
                <el-col span="24" v-else-if="item.input_type == 'TABLE'">
                  <el-form-item
                    :label="item.label"
                    :class="{ institution_star: item.mandatory == 'T' }"
                    prop="field_value"
                    :rules="
                      item.mandatory == 'T'
                        ? [{ required: true, message: item.label + '不能为空' }]
                        : []
                    "
                  >
                    <el-table
                      :data="item.field_value"
                      border
                      style="width: 100%"
                    >
                      <el-table-column type="index" label="序号" width="50">
                      </el-table-column>
                      <el-table-column
                        prop="dept_name"
                        label="标准科室"
                        v-if="item.array_dept !== 'NONE'"
                      >
                      </el-table-column>
                      <el-table-column
                        prop="product_name"
                        label="产品"
                        v-if="item.array_product !== 'NONE'"
                      >
                      </el-table-column>
                      <el-table-column
                        prop="sku_name"
                        label="SKU"
                        v-if="
                          item.array_product == 'SKU' &&
                          item.array_product !== 'NONE'
                        "
                      >
                      </el-table-column>
                      <el-table-column
                        prop="date_name"
                        label="日期"
                        v-if="item.array_date !== 'NONE'"
                      >
                      </el-table-column>
                      <el-table-column prop="field_value" label="数值">
                      </el-table-column>
                      <el-table-column fixed="right" label="操作" width="80">
                        <template slot-scope="scope">
                          <el-button
                            @click="
                              handleTableClick(scope.$index, scope.row, item)
                            "
                            style="
                              background-color: rgb(255, 153, 1);
                              border: 1px solid rgb(255, 153, 1);
                              color: #fff;
                            "
                            size="small"
                            >详情
                          </el-button>
                        </template>
                      </el-table-column>
                    </el-table>
                  </el-form-item>
                  <el-col :span="24" style="margin-bottom: 10px">
                    <el-button
                      size="small"
                      icon="el-icon-plus"
                      style="
                        float: left;
                        margin-left: 15%;
                        background-color: #6cc584;
                        border: 1px solid #6cc584;
                        color: #fff;
                      "
                      @click="addNewTable(item)"
                      >添加新数据
                    </el-button>
                  </el-col>
                  <el-col
                    :span="24"
                    v-if="item.isAddTable"
                    id="addTableHcp1"
                    style="
                      margin-left: 15%;
                      width: 85%;
                      background: #edf3fb;
                      border: 1px solid #ecdfe6;
                      margin-bottom: 10px;
                      border-radius: 10px;
                    "
                  >
                    <el-col :span="14">
                      <el-form
                        ref="addTableHcp"
                        :model="item.addTableList"
                        style="margin-top: 20px"
                        hide-required-asterisk
                      >
                        <el-form-item
                          label="标准科室"
                          v-if="item.array_dept !== 'NONE'"
                          prop="dept_id"
                          class="institution_star"
                          :rules="{
                            required: true,
                            message: '标准科室不能为空',
                          }"
                        >
                          <el-select
                            v-model="item.addTableList.dept_id"
                            placeholder="请选择标准科室"
                            style="width: 70%; float: right"
                            clearable
                          >
                            <el-option
                              v-for="item in administrativeList"
                              :key="item.key"
                              :label="item.value1"
                              :value="item.key"
                            >
                            </el-option>
                          </el-select>
                        </el-form-item>
                        <el-form-item
                          label="产品"
                          v-if="item.array_product !== 'NONE'"
                          prop="product_id"
                          class="institution_star"
                          :rules="{ required: true, message: '产品不能为空' }"
                        >
                          <el-select
                            v-model="item.addTableList.product_id"
                            placeholder="请选择产品"
                            style="width: 70%; float: right"
                            @change="getSkuList(item)"
                            clearable
                          >
                            <el-option
                              v-for="item in productList"
                              :key="item.key"
                              :label="item.value1"
                              :value="item.key"
                            >
                            </el-option>
                          </el-select>
                        </el-form-item>
                        <el-form-item
                          label="SKU"
                          class="institution_star"
                          v-if="
                            item.array_product == 'SKU' &&
                            item.array_product !== 'NONE'
                          "
                          prop="sku_id"
                          :rules="{ required: true, message: 'SKU不能为空' }"
                        >
                          <el-select
                            v-model="item.addTableList.sku_id"
                            placeholder="请选择SKU"
                            style="width: 70%; float: right"
                            clearable
                          >
                            <el-option
                              v-for="item in SkuList"
                              :key="item.key"
                              :label="item.value1"
                              :value="item.key"
                            >
                            </el-option>
                          </el-select>
                        </el-form-item>
                        <el-form-item
                          label="日期"
                          class="institution_star"
                          v-if="
                            item.array_date !== 'NONE' && item.array_date !== ''
                          "
                          prop="date_name"
                          :rules="{ required: true, message: '日期不能为空' }"
                        >
                          <el-date-picker
                            v-model="item.addTableList.info_date"
                            type="year"
                            style="width: 70%; float: right"
                            format="yyyy年"
                            value-format="yyyy年"
                            placeholder="选择年"
                            v-if="item.array_date == 'YEAR'"
                          >
                          </el-date-picker>
                          <quarter
                            v-if="item.array_date == 'QUARTER'"
                            @child-event="parentEvent"
                            :defaultValue="item.addTableList.info_date"
                            :getValue="getQuarterValue"
                            style="width: 70%; float: right"
                          ></quarter>
                          <el-date-picker
                            v-model="item.addTableList.info_date"
                            type="month"
                            style="width: 70%; float: right"
                            format="yyyy年MM月"
                            value-format="yyyy年MM月"
                            placeholder="选择月"
                            v-if="item.array_date == 'MONTH'"
                          >
                          </el-date-picker>
                          <monthComponent
                            v-if="item.array_date == 'WEEK'"
                            @week-event="parentWeekEvent"
                            :defaultValue="item.addTableList.info_date"
                            :getValue="getWeekValue"
                            style="width: 70%; float: right"
                          ></monthComponent>
                          <el-date-picker
                            v-model="item.addTableList.info_date"
                            type="date"
                            placeholder="选择日期"
                            style="width: 70%; float: right"
                            format="yyyy年MM月dd日"
                            value-format="yyyy年MM月dd日"
                            v-if="item.array_date == 'DAY'"
                          >
                          </el-date-picker>
                        </el-form-item>
                        <el-form-item
                          label="数值"
                          prop="field_value"
                          class="institution_star"
                          :rules="{ required: true, message: '数值不能为空' }"
                        >
                          <el-input
                            v-model="item.addTableList.field_value"
                            placeholder="请输入数值"
                            style="width: 70%; float: right"
                            type="number"
                          ></el-input>
                        </el-form-item>
                      </el-form>
                    </el-col>
                    <el-col :span="10">
                      <el-col style="margin-top: 20px">
                        <el-button
                          size="small"
                          style="
                            float: left;
                            margin-left: 40px;
                            background-color: #588ede;
                            border: 1px solid #588ede;
                            color: #fff;
                          "
                          @click="addTableDataHcp(item)"
                          >保存
                        </el-button>
                        <el-button
                          style="
                            float: left;
                            margin-left: 20px;
                            background-color: #e87570;
                            border: 1px solid #e87570;
                            color: #fff;
                          "
                          @click="delateTableData(item)"
                          v-if="delateFalse"
                          size="small"
                          >删除
                        </el-button>
                        <el-button
                          size="small"
                          style="
                            float: left;
                            margin-left: 20px;
                            background-color: #e87570;
                            border: 1px solid #e87570;
                            color: #fff;
                          "
                          @click="cancelTableData(item)"
                          >取消
                        </el-button>
                      </el-col>
                    </el-col>
                  </el-col>
                </el-col>
                <el-col span="24" v-else>
                  <el-form-item
                    :label="item.label"
                    :class="{ institution_star: item.mandatory == 'T' }"
                    prop="field_value"
                    :rules="
                      item.mandatory == 'T'
                        ? [{ required: true, message: item.label + '不能为空' }]
                        : []
                    "
                  >
                    <el-input
                      :rows="3"
                      v-model="item.field_value"
                      placeholder="请输入备注信息"
                      type="textarea"
                    ></el-input>
                  </el-form-item>
                </el-col>
              </el-form>
            </div>
          </el-tab-pane>
        </el-tabs>
      </div>
    </el-dialog>
    <!--经销商编辑-->
    <el-dialog
      :visible.sync="disdialogVisible"
      width="900px"
      :show-close="false"
      style="vertical-align: center; :#FFF9F3 "
    >
      <div style="margin-top: -40px">
        <el-row style="padding-bottom: 10px">
          <el-col :span="12">
            <div style="color: #3998f7; padding-top: 8px; font-size: 20px">
              经销商详情
            </div>
          </el-col>

          <el-col :span="12">
            <div align="right">
              <el-button
                type="primary"
                size="small"
                @click="baocun3_1"
                v-if="activeName2 !== 'third' && activeName2 !== 'four'"
              >
                保存
              </el-button>
              <el-button type="danger" size="small" @click="guanbi3_1">
                关闭
              </el-button>
            </div>
          </el-col>
        </el-row>
        <el-tabs v-model="activeName2" @tab-click="handleClickTabs">
          <el-tab-pane label="基本信息" name="first">
            <div class="subjectList" style="margin-top: 20px">
              <el-form
                ref="distributorlist"
                :model="distributorlist"
                label-width="120px"
                :rules="rules"
                hide-required-asterisk
              >
                <el-row>
                  <el-col :span="12">
                    <el-form-item
                      label="名称"
                      prop="distributor_name"
                      class="institution_star"
                    >
                      <el-input
                        v-model="distributorlist.distributor_name"
                      ></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :span="12">
                    <el-form-item
                      label="编码"
                      prop="distributor_code"
                      class="institution_star"
                    >
                      <el-input
                        v-model="distributorlist.distributor_code"
                      ></el-input>
                    </el-form-item>
                  </el-col>
                </el-row>

                <el-row>
                  <el-col :span="12">
                    <el-form-item
                      label="类别"
                      prop="distributor_type"
                      class="institution_star"
                    >
                      <el-select
                        v-model="distributorlist.distributor_type"
                        placeholder="请选择"
                        style="width: 100%"
                        @change="fangfa2"
                        clearable
                      >
                        <el-option
                          v-for="item in TypeList"
                          :key="item.key"
                          :label="item.value1"
                          :value="item.key"
                        >
                        </el-option>
                      </el-select>
                    </el-form-item>
                  </el-col>
                  <el-col :span="12">
                    <el-form-item label="级别">
                      <el-select
                        v-model="distributorlist.distributor_grade_name"
                        placeholder="请选择"
                        style="width: 100%"
                        clearable
                      >
                        <el-option
                          v-for="item in GardeList"
                          :key="item.key"
                          :label="item.value1"
                          :value="item.key"
                        >
                        </el-option>
                      </el-select>
                    </el-form-item>
                  </el-col>
                </el-row>

                <el-row>
                  <el-col :span="12">
                    <el-form-item
                      label="省份"
                      prop="province_id"
                      class="institution_star"
                    >
                      <el-select
                        v-model="distributorlist.province_id"
                        placeholder="请选择"
                        @change="fangfa"
                        style="width: 100%"
                        clearable
                      >
                        <el-option
                          v-for="item in data"
                          :key="item.id"
                          :label="item.label"
                          :value="item.id"
                        >
                        </el-option>
                      </el-select>
                    </el-form-item>
                  </el-col>
                  <el-col :span="12">
                    <el-form-item
                      label="城市"
                      prop="city_id"
                      class="institution_star"
                    >
                      <el-select
                        v-model="distributorlist.city_id"
                        placeholder="请选择"
                        style="width: 100%"
                        clearable
                      >
                        <el-option
                          v-for="item in CityList"
                          :key="item.city_id"
                          :label="item.city_name"
                          :value="item.city_id"
                        >
                        </el-option>
                      </el-select>
                    </el-form-item>
                  </el-col>
                </el-row>

                <el-form-item label="地址">
                  <el-input v-model="distributorlist.address"></el-input>
                </el-form-item>

                <el-row>
                  <el-col :span="12">
                    <el-form-item label="联系电话">
                      <el-input v-model="distributorlist.telephone"></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :span="12">
                    <el-form-item label="邮政编码">
                      <el-input v-model="distributorlist.postcode"></el-input>
                    </el-form-item>
                  </el-col>
                </el-row>

                <el-form-item label="官方网址">
                  <el-input v-model="distributorlist.website"></el-input>
                </el-form-item>

                <el-form-item label="备注">
                  <el-input
                    v-model="distributorlist.comments"
                    placeholder="请输入备注信息"
                    type="textarea"
                  ></el-input>
                </el-form-item>

                <el-form-item label="有效">
                  <el-switch
                    v-model="distributorlist.status"
                    active-color="#13ce66"
                  >
                  </el-switch>
                </el-form-item>
              </el-form>
            </div>
          </el-tab-pane>
          <el-tab-pane
            :label="items.group_name"
            :name="items.name"
            v-for="(items, j) in extendedInfo3_1"
          >
            <div class="subjectList" style="margin-top: 20px">
              <el-form
                hide-required-asterisk
                :ref="'dislist' + j"
                label-width="27%"
                v-for="(item, j) in items.fieldArray"
                :model="item"
                :key="item.field_id"
              >
                <el-col span="24" v-if="item.input_type == 'TEXT'">
                  <el-form-item
                    :label="item.label"
                    :class="{ institution_star: item.mandatory == 'T' }"
                    prop="field_value"
                    :rules="
                      item.mandatory == 'T'
                        ? [{ required: true, message: item.label + '不能为空' }]
                        : []
                    "
                  >
                    <el-input
                      v-model="item.field_value"
                      placeholder="请输入文本"
                    ></el-input>
                  </el-form-item>
                </el-col>
                <el-col span="24" v-else-if="item.input_type == 'NUMBER'">
                  <el-form-item
                    :label="item.label"
                    :class="{ institution_star: item.mandatory == 'T' }"
                    prop="field_value"
                    :rules="
                      item.mandatory == 'T'
                        ? [{ required: true, message: item.label + '不能为空' }]
                        : []
                    "
                  >
                    <el-input
                      v-model="item.field_value"
                      placeholder="请输入数字"
                      type="number"
                    ></el-input>
                  </el-form-item>
                </el-col>
                <el-col span="24" v-else-if="item.input_type == 'DATE'">
                  <el-form-item
                    :label="item.label"
                    :class="{ institution_star: item.mandatory == 'T' }"
                    prop="field_value"
                    :rules="
                      item.mandatory == 'T'
                        ? [{ required: true, message: item.label + '不能为空' }]
                        : []
                    "
                  >
                    <el-date-picker
                      v-model="item.field_value"
                      type="date"
                      placeholder="选择日期时间"
                      style="width: 100%"
                      format="yyyy-MM-dd"
                      value-format="yyyy-MM-dd"
                    >
                    </el-date-picker>
                  </el-form-item>
                </el-col>
                <el-col span="24" v-else-if="item.input_type == 'TRUE-FALSE'">
                  <el-form-item :label="item.label">
                    <el-switch
                      v-model="item.field_value"
                      active-color="#13ce66"
                      active-value="T"
                      inactive-value="F"
                    >
                    </el-switch>
                  </el-form-item>
                </el-col>
                <el-col span="24" v-else-if="item.input_type == 'LIST'">
                  <el-form-item
                    :label="item.label"
                    :class="{ institution_star: item.mandatory == 'T' }"
                    prop="field_value"
                    :rules="
                      item.mandatory == 'T'
                        ? [{ required: true, message: item.label + '不能为空' }]
                        : []
                    "
                  >
                    <!--                                        <el-select v-model="item.field_value" :multiple="item.multiple == 'T'" placeholder="请选择" style="width: 100%" >-->
                    <!--                                            <el-option-->
                    <!--                                                    v-for="item in item.listArray"-->
                    <!--                                                    :key="item.key"-->
                    <!--                                                    :label="item.value1"-->
                    <!--                                                    :value="item.key">-->
                    <!--                                            </el-option>-->
                    <!--                                        </el-select>-->
                    <el-cascader
                      v-model="item.field_value"
                      :options="item.listArray"
                      style="width: 100%"
                      filterable
                      :show-all-levels="false"
                      :props="{
                        multiple: item.multiple == 'T' ? true : false,
                        checkStrictly: true,
                      }"
                      clearable
                    ></el-cascader>
                  </el-form-item>
                </el-col>
                <el-col span="24" v-else-if="item.input_type == 'TABLE'">
                  <el-form-item
                    :label="item.label"
                    :class="{ institution_star: item.mandatory == 'T' }"
                    prop="field_value"
                    :rules="
                      item.mandatory == 'T'
                        ? [{ required: true, message: item.label + '不能为空' }]
                        : []
                    "
                  >
                    <el-table
                      :data="item.field_value"
                      border
                      style="width: 100%"
                    >
                      <el-table-column type="index" label="序号" width="50">
                      </el-table-column>
                      <el-table-column
                        prop="dept_name"
                        label="标准科室"
                        v-if="item.array_dept !== 'NONE'"
                      >
                      </el-table-column>
                      <el-table-column
                        prop="product_name"
                        label="产品"
                        v-if="item.array_product !== 'NONE'"
                      >
                      </el-table-column>
                      <el-table-column
                        prop="sku_name"
                        label="SKU"
                        v-if="
                          item.array_product == 'SKU' &&
                          item.array_product !== 'NONE'
                        "
                      >
                      </el-table-column>
                      <el-table-column
                        prop="date_name"
                        label="日期"
                        v-if="item.array_date !== 'NONE'"
                      >
                      </el-table-column>
                      <el-table-column prop="field_value" label="数值">
                      </el-table-column>
                      <el-table-column fixed="right" label="操作" width="80">
                        <template slot-scope="scope">
                          <el-button
                            @click="
                              handleTableClick(scope.$index, scope.row, item)
                            "
                            style="
                              background-color: rgb(255, 153, 1);
                              border: 1px solid rgb(255, 153, 1);
                              color: #fff;
                            "
                            size="small"
                            >详情
                          </el-button>
                        </template>
                      </el-table-column>
                    </el-table>
                  </el-form-item>
                  <el-col :span="24" style="margin-bottom: 10px">
                    <el-button
                      size="small"
                      icon="el-icon-plus"
                      style="
                        float: left;
                        margin-left: 27%;
                        background-color: #6cc584;
                        border: 1px solid #6cc584;
                        color: #fff;
                      "
                      @click="addNewTable(item)"
                      >添加新数据
                    </el-button>
                  </el-col>
                  <el-col
                    :span="24"
                    v-if="item.isAddTable"
                    id="addTable2"
                    style="
                      margin-left: 30%;
                      width: 70%;
                      background: #edf3fb;
                      border: 1px solid #ecdfe6;
                      margin-bottom: 10px;
                      border-radius: 10px;
                    "
                  >
                    <el-col :span="14">
                      <el-form
                        ref="addTable"
                        :model="item.addTableList"
                        style="margin-top: 20px"
                        hide-required-asterisk
                      >
                        <el-form-item
                          label="标准科室"
                          v-if="item.array_dept !== 'NONE'"
                          prop="dept_id"
                          class="institution_star"
                          :rules="{
                            required: true,
                            message: '标准科室不能为空',
                          }"
                        >
                          <el-select
                            v-model="item.addTableList.dept_id"
                            placeholder="请选择标准科室"
                            style="width: 70%; float: right"
                            clearable
                          >
                            <el-option
                              v-for="item in administrativeList"
                              :key="item.key"
                              :label="item.value1"
                              :value="item.key"
                            >
                            </el-option>
                          </el-select>
                        </el-form-item>
                        <el-form-item
                          label="产品"
                          v-if="item.array_product !== 'NONE'"
                          prop="product_id"
                          class="institution_star"
                          :rules="{ required: true, message: '产品不能为空' }"
                        >
                          <el-select
                            v-model="item.addTableList.product_id"
                            placeholder="请选择产品"
                            style="width: 70%; float: right"
                            @change="getSkuList(item)"
                            clearable
                          >
                            <el-option
                              v-for="item in productList"
                              :key="item.key"
                              :label="item.value1"
                              :value="item.key"
                            >
                            </el-option>
                          </el-select>
                        </el-form-item>
                        <el-form-item
                          label="SKU"
                          class="institution_star"
                          v-if="
                            item.array_product == 'SKU' &&
                            item.array_product !== 'NONE'
                          "
                          prop="sku_id"
                          :rules="{ required: true, message: 'SKU不能为空' }"
                        >
                          <el-select
                            v-model="item.addTableList.sku_id"
                            placeholder="请选择SKU"
                            style="width: 70%; float: right"
                            clearable
                          >
                            <el-option
                              v-for="item in SkuList"
                              :key="item.key"
                              :label="item.value1"
                              :value="item.key"
                            >
                            </el-option>
                          </el-select>
                        </el-form-item>
                        <el-form-item
                          label="日期"
                          class="institution_star"
                          v-if="
                            item.array_date !== 'NONE' && item.array_date !== ''
                          "
                          prop="date_name"
                          :rules="{ required: true, message: '日期不能为空' }"
                        >
                          <el-date-picker
                            v-model="item.addTableList.info_date"
                            type="year"
                            style="width: 70%; float: right"
                            format="yyyy年"
                            value-format="yyyy年"
                            placeholder="选择年"
                            v-if="item.array_date == 'YEAR'"
                          >
                          </el-date-picker>
                          <quarter
                            v-if="item.array_date == 'QUARTER'"
                            @child-event="parentEvent"
                            :defaultValue="item.addTableList.info_date"
                            :getValue="getQuarterValue"
                            style="width: 70%; float: right"
                          ></quarter>
                          <el-date-picker
                            v-model="item.addTableList.info_date"
                            type="month"
                            style="width: 70%; float: right"
                            format="yyyy年MM月"
                            value-format="yyyy年MM月"
                            placeholder="选择月"
                            v-if="item.array_date == 'MONTH'"
                          >
                          </el-date-picker>
                          <monthComponent
                            v-if="item.array_date == 'WEEK'"
                            @week-event="parentWeekEvent"
                            :defaultValue="item.addTableList.info_date"
                            :getValue="getWeekValue"
                            style="width: 70%; float: right"
                          ></monthComponent>
                          <el-date-picker
                            v-model="item.addTableList.info_date"
                            type="date"
                            placeholder="选择日期"
                            style="width: 70%; float: right"
                            format="yyyy年MM月dd日"
                            value-format="yyyy年MM月dd日"
                            v-if="item.array_date == 'DAY'"
                          >
                          </el-date-picker>
                        </el-form-item>
                        <el-form-item
                          label="数值"
                          prop="field_value"
                          class="institution_star"
                          :rules="{ required: true, message: '数值不能为空' }"
                        >
                          <el-input
                            v-model="item.addTableList.field_value"
                            placeholder="请输入数值"
                            style="width: 70%; float: right"
                          ></el-input>
                        </el-form-item>
                      </el-form>
                    </el-col>
                    <el-col :span="10">
                      <el-col style="margin-top: 20px">
                        <el-button
                          size="small"
                          style="
                            float: left;
                            margin-left: 40px;
                            background-color: #588ede;
                            border: 1px solid #588ede;
                            color: #fff;
                          "
                          @click="addTableData(item)"
                          >保存
                        </el-button>
                        <el-button
                          style="
                            float: left;
                            margin-left: 20px;
                            background-color: #e87570;
                            border: 1px solid #e87570;
                            color: #fff;
                          "
                          @click="delateTableData(item)"
                          v-if="delateFalse"
                          size="small"
                          >删除
                        </el-button>
                        <el-button
                          size="small"
                          style="
                            float: left;
                            margin-left: 20px;
                            background-color: #e87570;
                            border: 1px solid #e87570;
                            color: #fff;
                          "
                          @click="cancelTableData(item)"
                          >取消
                        </el-button>
                      </el-col>
                    </el-col>
                  </el-col>
                </el-col>
                <el-col span="24" v-else>
                  <el-form-item
                    :label="item.label"
                    :class="{ institution_star: item.mandatory == 'T' }"
                    prop="field_value"
                    :rules="
                      item.mandatory == 'T'
                        ? [{ required: true, message: item.label + '不能为空' }]
                        : []
                    "
                  >
                    <el-input
                      :rows="3"
                      v-model="item.field_value"
                      placeholder="请输入备注信息"
                      type="textarea"
                    ></el-input>
                  </el-form-item>
                </el-col>
              </el-form>
            </div>
          </el-tab-pane>
          <el-tab-pane label="照片图库" name="third">
            <div class="photoList" style="display: flex; flex-wrap: wrap">
              <div
                class="upload"
                style="float: left"
                @click.stop="openDetail3_1"
              >
                <div class="d1"></div>
                <div class="d2"></div>
              </div>
              <div
                class="imgInfo"
                style="align-items: flex-start"
                v-for="item in imgArray"
                @click.stop="editPhoto(item)"
              >
                <img
                  :src="item.url"
                  style="
                    width: 120px;
                    height: 120px;
                    border-radius: 5px;
                    display: block;
                  "
                />
                <div style="min-height: 18px; width: 120px">
                  <el-tag
                    v-for="bq in item.tag"
                    :key="bq.text"
                    :disable-transitions="false"
                    style="
                      background-color: #ba9ee6;
                      color: white;
                      font-weight: bold;
                    "
                  >
                    {{ bq.text }}
                  </el-tag>
                </div>
              </div>
            </div>
            <div class="photoDetail" v-if="isDetail">
              <el-row>
                <el-col :span="24" style="padding: 20px 20px">
                  <div
                    style="
                      color: #2b92fa;
                      font-size: 18px;
                      display: inline-block;
                      float: left;
                    "
                  >
                    照片详情
                  </div>
                  <div style="display: inline-block; float: right">
                    <el-button
                      type="primary"
                      class="button"
                      @click="submitPhoto3_1"
                    >
                      保存
                    </el-button>
                    <el-button
                      type="danger"
                      class="button"
                      @click="closeDetail"
                    >
                      关闭
                    </el-button>
                  </div>
                </el-col>
              </el-row>
              <el-row style="margin: 10px 20px">
                <el-col span="12">
                  <el-col span="4" style="margin-top: 20px; margin-right: 20px">
                    <span
                      style="
                        display: block;
                        margin-bottom: 20px;
                        margin-left: 4px;
                        font-weight: bold;
                      "
                      >照片上传</span
                    >
                    <el-button
                      type="danger"
                      style="
                        width: 70px;
                        height: 30px;
                        padding: 5px;
                        font-size: 10px;
                        background-color: #d9443d;
                        border-color: #d9443d;
                      "
                      @click.stop="deletePhoto"
                      >删除照片
                    </el-button>
                  </el-col>
                  <el-col span="16">
                    <el-upload
                      ref="photoUpload"
                      class="upload-demo"
                      drag
                      accept=".jpg,.png,.jpeg"
                      action="/photos/uploadphoto"
                      :auto-upload="false"
                      :before-upload="getUuidAgenda"
                      :on-success="getPhotoIdAgenda"
                      :on-change="beforeUpload"
                      :data="categoryAgenda"
                    >
                      <i class="el-icon-upload"></i>
                      <div class="el-upload__text">
                        将文件拖到此处，或<em>点击上传</em>
                      </div>
                    </el-upload>
                  </el-col>
                </el-col>
                <el-col span="12">
                  <el-col style="margin-left: 20px; margin-top: 10px">
                    <span style="font-weight: bold">设置标签</span>
                    <el-input
                      placeholder="请输入照片的说明"
                      style="
                        display: inline-block;
                        margin-left: 10px;
                        width: 300px;
                      "
                      v-model="tagText"
                      @keyup.enter.native="addTag"
                      @input.native="change($event)"
                    ></el-input>
                  </el-col>
                  <el-col style="width: 300px; margin-left: 85px">
                    <el-tag
                      closable
                      v-for="tag in tags"
                      :key="tag.text"
                      :disable-transitions="false"
                      @close="tagClose(tag)"
                      style="
                        background-color: #ba9ee6;
                        color: white;
                        font-weight: bold;
                      "
                    >
                      {{ tag.text }}
                    </el-tag>
                  </el-col>
                </el-col>
              </el-row>
            </div>
          </el-tab-pane>
          <el-tab-pane label="附加文件" name="four">
            <div class="">
              <el-col style="color: #2b92fa; margin-bottom: 10px">
                文件总数：{{ fileTable.length }}个（视频：{{
                  statistics.mp4Num ? statistics.mp4Num : 0
                }}个，幻灯片：
                {{ statistics.slideNum ? statistics.slideNum : 0 }}个，图片：{{
                  statistics.imgNum ? statistics.imgNum : 0
                }}个，文档：{{
                  statistics.docNum ? statistics.docNum : 0
                }}个，其他：{{
                  statistics.restsNum ? statistics.restsNum : 0
                }}个）
              </el-col>
              <el-table :data="fileTable" border>
                <el-table-column sortable label="文件名称" width="180">
                  <template slot-scope="scope">
                    {{ scope.row.file_name }}
                    <el-tag
                      v-for="bq in scope.row.tag"
                      :key="bq.text"
                      :disable-transitions="false"
                      style="
                        background-color: #ba9ee6;
                        color: white;
                        font-weight: bold;
                      "
                    >
                      {{ bq.text }}
                    </el-tag>
                  </template>
                </el-table-column>
                <el-table-column sortable prop="category" label="文件类型">
                  <template slot-scope="scope">
                    {{ isFileType(scope.row.category) }}
                  </template>
                </el-table-column>
                <el-table-column sortable prop="file_size" label="文件大小">
                  <template slot-scope="scope">
                    <span>{{ getFileSize(scope.row.file_size) }}</span>
                  </template>
                </el-table-column>
                <el-table-column sortable prop="status" label="状态">
                  <template slot-scope="scope">
                    {{ scope.row.status == "ACTIVE" ? "有效" : "无效" }}
                  </template>
                </el-table-column>
                <el-table-column label="操作">
                  <template slot-scope="scope">
                    <el-button
                      @click="editFile(scope.$index, scope.row)"
                      type="warning"
                      size="mini"
                      >详情
                    </el-button>
                    <el-button
                      @click="downloadFile(scope.row)"
                      type="primary"
                      size="mini"
                      >下载
                    </el-button>
                  </template>
                </el-table-column>
              </el-table>
              <el-button
                type="success"
                size="small"
                icon="el-icon-plus"
                style="margin-top: 10px"
                @click.stop="openFileDetail"
                >添加文件
              </el-button>
            </div>
            <div class="photoDetail" v-if="fileDetail">
              <el-row>
                <el-col :span="24" style="padding: 20px 20px">
                  <div
                    style="
                      color: #2b92fa;
                      font-size: 18px;
                      display: inline-block;
                      float: left;
                    "
                  >
                    文件详情
                  </div>
                  <div style="display: inline-block; float: right">
                    <el-button
                      type="primary"
                      class="button"
                      @click.stop="submitFiles3"
                    >
                      保存
                    </el-button>
                    <el-button
                      type="danger"
                      class="button"
                      @click.stop="closeFileDetail"
                    >
                      关闭
                    </el-button>
                  </div>
                </el-col>
              </el-row>
              <el-row style="margin: 10px 20px">
                <el-col span="12">
                  <el-col span="4" style="margin-top: 20px; margin-right: 20px">
                    <span
                      style="
                        display: block;
                        margin-bottom: 20px;
                        margin-left: 4px;
                        font-weight: bold;
                      "
                      >文件上传</span
                    >
                    <el-button
                      type="danger"
                      style="
                        width: 70px;
                        height: 30px;
                        padding: 5px;
                        font-size: 10px;
                        background-color: #d9443d;
                        border-color: #d9443d;
                      "
                      @click.stop="deleteFile"
                      >删除文件
                    </el-button>
                  </el-col>
                  <el-col span="16">
                    <el-upload
                      ref="uploadFile"
                      drag
                      :action="getUrl()"
                      :before-upload="beforeFileUpload"
                      :on-success="fileSuccess"
                      :auto-upload="false"
                    >
                      <i class="el-icon-upload"></i>
                      <div class="el-upload__text">
                        将文件拖到此处，或<em>点击上传</em>
                      </div>
                    </el-upload>
                  </el-col>
                </el-col>
                <el-col span="12">
                  <el-col style="margin-left: 20px; margin-top: 10px">
                    <span style="font-weight: bold">设置标签</span>
                    <el-input
                      placeholder="请输入文件的说明"
                      style="
                        display: inline-block;
                        margin-left: 10px;
                        width: 300px;
                      "
                      v-model="fileTag"
                      @keyup.enter.native="addFileTag"
                    ></el-input>
                  </el-col>
                  <el-col style="width: 300px; margin-left: 85px">
                    <el-tag
                      closable
                      v-for="tag in fileTags"
                      :key="tag.text"
                      :disable-transitions="false"
                      @close="fileTagClose(tag)"
                      style="
                        background-color: #ba9ee6;
                        color: white;
                        font-weight: bold;
                      "
                    >
                      {{ tag.text }}
                    </el-tag>
                  </el-col>
                </el-col>
              </el-row>
            </div>
          </el-tab-pane>
        </el-tabs>
      </div>
    </el-dialog>
    <!--联系人详情-->
    <el-dialog
      :visible.sync="disdialogVisible2"
      width="900px"
      :show-close="false"
      id="contact"
      style="vertical-align: center; margin-top: -70px"
    >
      <div style="margin-top: -40px">
        <el-row style="padding-bottom: 10px">
          <el-col :span="12">
            <div style="color: #3998f7; padding-top: 8px; font-size: 20px">
              联系人详情
            </div>
          </el-col>

          <el-col :span="12">
            <div align="right">
              <el-button type="primary" size="small" @click="baocun3_2">
                保存
              </el-button>
              <el-button type="danger" size="small" @click="guanbi3_2">
                关闭
              </el-button>
            </div>
          </el-col>
        </el-row>

        <el-tabs v-model="activeName1" @tab-click="handleClickTabs">
          <el-tab-pane label="基本信息" name="first">
            <div class="DianClass" style="margin-top: 20px">
              <el-form
                ref="contactClass"
                :model="contactClass"
                label-width="150px"
                hide-required-asterisk
              >
                <!--                        <el-row >-->
                <!--                            <el-col :span="22">-->
                <!--                                <el-form-item-->
                <!--                                        label="联系人编码"-->
                <!--                                        prop="contact_code"-->
                <!--                                        :rules="[-->
                <!--                                            { required: true, message: '联系人编码不能为空'},-->
                <!--                                        ]"-->
                <!--                                >-->
                <!--                                    <el-input v-model="clerkClass.contact_code" placeholder="请输入联系人详情" ></el-input>-->
                <!--                                </el-form-item>-->
                <!--                            </el-col>-->
                <!--                        </el-row>-->
                <el-row>
                  <el-col :span="12">
                    <el-form-item label="所属部门">
                      <el-input
                        v-model="contactClass.department"
                        placeholder="请输入所属部门"
                      ></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :span="12">
                    <el-form-item label="职务">
                      <el-input
                        v-model="contactClass.job_title"
                        placeholder="请输入职务"
                      ></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :span="12">
                    <el-form-item
                      label="姓名"
                      class="institution_star"
                      prop="contact_name"
                      :rules="[{ required: true, message: '姓名不能为空' }]"
                    >
                      <el-input
                        v-model="contactClass.contact_name"
                        placeholder="请输入姓名"
                      ></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :span="12">
                    <el-form-item label="性别">
                      <el-select
                        v-model="contactClass.gender"
                        style="width: 100%"
                        placeholder="请选择"
                        clearable
                      >
                        <el-option label="男" value="M"></el-option>
                        <el-option label="女" value="F"></el-option>
                      </el-select>
                    </el-form-item>
                  </el-col>
                  <el-col :span="12">
                    <el-form-item label="联系电话">
                      <el-input
                        v-model="contactClass.mobile"
                        placeholder="请输入联系电话"
                      ></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :span="12">
                    <el-form-item label="电子邮件">
                      <el-input
                        v-model="contactClass.email"
                        placeholder="请输入电子邮箱"
                      ></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :span="12">
                    <el-form-item label="生日">
                      <el-date-picker
                        v-model="contactClass.birthday"
                        type="date"
                        value-format="yyyy-MM-dd"
                        placeholder="请选择出生日期"
                        style="width: 100%"
                      >
                      </el-date-picker>
                    </el-form-item>
                  </el-col>
                  <el-col :span="12">
                    <el-form-item label="爱好">
                      <el-input
                        v-model="contactClass.hobby"
                        placeholder="请输入个人爱好"
                      ></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :span="12">
                    <el-form-item label="在职">
                      <el-switch
                        v-model="contactClass.status"
                        active-color="#13ce66"
                      >
                      </el-switch>
                    </el-form-item>
                  </el-col>
                </el-row>
              </el-form>
            </div>
          </el-tab-pane>
          <el-tab-pane
            :label="items.group_name"
            :name="items.name"
            v-for="(items, j) in extendedInfo3_2"
          >
            <div class="subjectList" style="margin-top: 20px">
              <el-form
                hide-required-asterisk
                :ref="'contactList' + j"
                label-width="15%"
                v-for="(item, j) in items.fieldArray"
                :model="item"
                :key="item.field_id"
              >
                <el-col span="24" v-if="item.input_type == 'TEXT'">
                  <el-form-item
                    :label="item.label"
                    :class="{ institution_star: item.mandatory == 'T' }"
                    prop="field_value"
                    :rules="
                      item.mandatory == 'T'
                        ? [{ required: true, message: item.label + '不能为空' }]
                        : []
                    "
                  >
                    <el-input
                      v-model="item.field_value"
                      placeholder="请输入文本"
                    ></el-input>
                  </el-form-item>
                </el-col>
                <el-col span="24" v-else-if="item.input_type == 'NUMBER'">
                  <el-form-item
                    :label="item.label"
                    :class="{ institution_star: item.mandatory == 'T' }"
                    prop="field_value"
                    :rules="
                      item.mandatory == 'T'
                        ? [{ required: true, message: item.label + '不能为空' }]
                        : []
                    "
                  >
                    <el-input
                      v-model="item.field_value"
                      placeholder="请输入数字"
                      type="number"
                    ></el-input>
                  </el-form-item>
                </el-col>
                <el-col span="24" v-else-if="item.input_type == 'DATE'">
                  <el-form-item
                    :label="item.label"
                    :class="{ institution_star: item.mandatory == 'T' }"
                    prop="field_value"
                    :rules="
                      item.mandatory == 'T'
                        ? [{ required: true, message: item.label + '不能为空' }]
                        : []
                    "
                  >
                    <el-date-picker
                      v-model="item.field_value"
                      type="date"
                      placeholder="选择日期时间"
                      style="width: 100%"
                      format="yyyy-MM-dd"
                      value-format="yyyy-MM-dd"
                    >
                    </el-date-picker>
                  </el-form-item>
                </el-col>
                <el-col span="24" v-else-if="item.input_type == 'TRUE-FALSE'">
                  <el-form-item :label="item.label">
                    <el-switch
                      v-model="item.field_value"
                      active-color="#13ce66"
                      active-value="T"
                      inactive-value="F"
                    >
                    </el-switch>
                  </el-form-item>
                </el-col>
                <el-col span="24" v-else-if="item.input_type == 'LIST'">
                  <el-form-item
                    :label="item.label"
                    :class="{ institution_star: item.mandatory == 'T' }"
                    prop="field_value"
                    :rules="
                      item.mandatory == 'T'
                        ? [{ required: true, message: item.label + '不能为空' }]
                        : []
                    "
                  >
                    <!--                                        <el-select v-model="item.field_value" :multiple="item.multiple == 'T'" placeholder="请选择" style="width: 100%"  clearable>-->
                    <!--                                            <el-option-->
                    <!--                                                    v-for="item in item.listArray"-->
                    <!--                                                    :key="item.key"-->
                    <!--                                                    :label="item.value1"-->
                    <!--                                                    :value="item.key">-->
                    <!--                                            </el-option>-->
                    <!--                                        </el-select>-->
                    <el-cascader
                      v-model="item.field_value"
                      :options="item.listArray"
                      style="width: 100%"
                      filterable
                      :show-all-levels="false"
                      :props="{
                        multiple: item.multiple == 'T' ? true : false,
                        checkStrictly: true,
                      }"
                      clearable
                    ></el-cascader>
                  </el-form-item>
                </el-col>
                <el-col span="24" v-else-if="item.input_type == 'TABLE'">
                  <el-form-item
                    :label="item.label"
                    :class="{ institution_star: item.mandatory == 'T' }"
                    prop="field_value"
                    :rules="
                      item.mandatory == 'T'
                        ? [{ required: true, message: item.label + '不能为空' }]
                        : []
                    "
                  >
                    <el-table
                      :data="item.field_value"
                      border
                      style="width: 100%"
                    >
                      <el-table-column type="index" label="序号" width="50">
                      </el-table-column>
                      <el-table-column
                        prop="dept_name"
                        label="标准科室"
                        v-if="item.array_dept !== 'NONE'"
                      >
                      </el-table-column>
                      <el-table-column
                        prop="product_name"
                        label="产品"
                        v-if="item.array_product !== 'NONE'"
                      >
                      </el-table-column>
                      <el-table-column
                        prop="sku_name"
                        label="SKU"
                        v-if="
                          item.array_product == 'SKU' &&
                          item.array_product !== 'NONE'
                        "
                      >
                      </el-table-column>
                      <el-table-column
                        prop="date_name"
                        label="日期"
                        v-if="item.array_date !== 'NONE'"
                      >
                      </el-table-column>
                      <el-table-column prop="field_value" label="数值">
                      </el-table-column>
                      <el-table-column fixed="right" label="操作" width="80">
                        <template slot-scope="scope">
                          <el-button
                            @click="
                              handleTableClick(scope.$index, scope.row, item)
                            "
                            style="
                              background-color: rgb(255, 153, 1);
                              border: 1px solid rgb(255, 153, 1);
                              color: #fff;
                            "
                            size="small"
                            >详情
                          </el-button>
                        </template>
                      </el-table-column>
                    </el-table>
                  </el-form-item>
                  <el-col :span="24" style="margin-bottom: 10px">
                    <el-button
                      size="small"
                      icon="el-icon-plus"
                      style="
                        float: left;
                        margin-left: 15%;
                        background-color: #6cc584;
                        border: 1px solid #6cc584;
                        color: #fff;
                      "
                      @click="addNewTable(item)"
                      >添加新数据
                    </el-button>
                  </el-col>
                  <el-col
                    :span="24"
                    v-if="item.isAddTable"
                    id="addTableHcp2"
                    style="
                      margin-left: 15%;
                      width: 85%;
                      background: #edf3fb;
                      border: 1px solid #ecdfe6;
                      margin-bottom: 10px;
                      border-radius: 10px;
                    "
                  >
                    <el-col :span="14">
                      <el-form
                        ref="addTableHcp"
                        :model="item.addTableList"
                        style="margin-top: 20px"
                        hide-required-asterisk
                      >
                        <el-form-item
                          label="标准科室"
                          v-if="item.array_dept !== 'NONE'"
                          prop="dept_id"
                          :rules="{
                            required: true,
                            message: '标准科室不能为空',
                          }"
                          class="institution_star"
                        >
                          <el-select
                            v-model="item.addTableList.dept_id"
                            placeholder="请选择标准科室"
                            style="width: 70%; float: right"
                            clearable
                          >
                            <el-option
                              v-for="item in administrativeList"
                              :key="item.key"
                              :label="item.value1"
                              :value="item.key"
                            >
                            </el-option>
                          </el-select>
                        </el-form-item>
                        <el-form-item
                          label="产品"
                          v-if="item.array_product !== 'NONE'"
                          prop="product_id"
                          class="institution_star"
                          :rules="{ required: true, message: '产品不能为空' }"
                        >
                          <el-select
                            v-model="item.addTableList.product_id"
                            placeholder="请选择产品"
                            style="width: 70%; float: right"
                            @change="getSkuList(item)"
                            clearable
                          >
                            <el-option
                              v-for="item in productList"
                              :key="item.key"
                              :label="item.value1"
                              :value="item.key"
                            >
                            </el-option>
                          </el-select>
                        </el-form-item>
                        <el-form-item
                          label="SKU"
                          class="institution_star"
                          v-if="
                            item.array_product == 'SKU' &&
                            item.array_product !== 'NONE'
                          "
                          prop="sku_id"
                          :rules="{ required: true, message: 'SKU不能为空' }"
                        >
                          <el-select
                            v-model="item.addTableList.sku_id"
                            placeholder="请选择SKU"
                            style="width: 70%; float: right"
                            clearable
                          >
                            <el-option
                              v-for="item in SkuList"
                              :key="item.key"
                              :label="item.value1"
                              :value="item.key"
                            >
                            </el-option>
                          </el-select>
                        </el-form-item>

                        <el-form-item
                          label="日期"
                          class="institution_star"
                          v-if="
                            item.array_date !== 'NONE' && item.array_date !== ''
                          "
                          prop="date_name"
                          :rules="{ required: true, message: '日期不能为空' }"
                        >
                          <el-date-picker
                            v-model="item.addTableList.info_date"
                            type="year"
                            style="width: 70%; float: right"
                            format="yyyy年"
                            value-format="yyyy年"
                            placeholder="选择年"
                            v-if="item.array_date == 'YEAR'"
                          >
                          </el-date-picker>
                          <quarter
                            v-if="item.array_date == 'QUARTER'"
                            @child-event="parentEvent"
                            :defaultValue="item.addTableList.info_date"
                            :getValue="getQuarterValue"
                            style="width: 70%; float: right"
                          ></quarter>
                          <el-date-picker
                            v-model="item.addTableList.info_date"
                            type="month"
                            style="width: 70%; float: right"
                            format="yyyy年MM月"
                            value-format="yyyy年MM月"
                            placeholder="选择月"
                            v-if="item.array_date == 'MONTH'"
                          >
                          </el-date-picker>
                          <monthComponent
                            v-if="item.array_date == 'WEEK'"
                            @week-event="parentWeekEvent"
                            :defaultValue="item.addTableList.info_date"
                            :getValue="getWeekValue"
                            style="width: 70%; float: right"
                          ></monthComponent>
                          <el-date-picker
                            v-model="item.addTableList.info_date"
                            type="date"
                            placeholder="选择日期"
                            style="width: 70%; float: right"
                            format="yyyy年MM月dd日"
                            value-format="yyyy年MM月dd日"
                            v-if="item.array_date == 'DAY'"
                          >
                          </el-date-picker>
                        </el-form-item>
                        <el-form-item
                          label="数值"
                          prop="field_value"
                          :rules="{ required: true, message: '数值不能为空' }"
                        >
                          <el-input
                            v-model="item.addTableList.field_value"
                            placeholder="请输入数值"
                            style="width: 70%; float: right"
                            type="number"
                          ></el-input>
                        </el-form-item>
                      </el-form>
                    </el-col>
                    <el-col :span="10">
                      <el-col style="margin-top: 20px">
                        <el-button
                          size="small"
                          style="
                            float: left;
                            margin-left: 40px;
                            background-color: #588ede;
                            border: 1px solid #588ede;
                            color: #fff;
                          "
                          @click="addTableDataHcp(item)"
                          >保存
                        </el-button>
                        <el-button
                          style="
                            float: left;
                            margin-left: 20px;
                            background-color: #e87570;
                            border: 1px solid #e87570;
                            color: #fff;
                          "
                          @click="delateTableData(item)"
                          v-if="delateFalse"
                          size="small"
                          >删除
                        </el-button>
                        <el-button
                          size="small"
                          style="
                            float: left;
                            margin-left: 20px;
                            background-color: #e87570;
                            border: 1px solid #e87570;
                            color: #fff;
                          "
                          @click="cancelTableData(item)"
                          >取消
                        </el-button>
                      </el-col>
                    </el-col>
                  </el-col>
                </el-col>
                <el-col span="24" v-else>
                  <el-form-item
                    :label="item.label"
                    :class="{ institution_star: item.mandatory == 'T' }"
                    prop="field_value"
                    :rules="
                      item.mandatory == 'T'
                        ? [{ required: true, message: item.label + '不能为空' }]
                        : []
                    "
                  >
                    <el-input
                      :rows="3"
                      v-model="item.field_value"
                      placeholder="请输入备注信息"
                      type="textarea"
                    ></el-input>
                  </el-form-item>
                </el-col>
              </el-form>
            </div>
          </el-tab-pane>
        </el-tabs>
      </div>
    </el-dialog>

    <!--机构报错信息-->
    <el-dialog
      :visible.sync="showModal2"
      :show-close="false"
      width="900px"
      style="margin-top: -20px"
    >
      <div slot="title">
        <div
          slot="title"
          class="dialog-footer"
          style="display: flex; justify-content: space-between"
        >
          <span style="color: #3998f7; font-size: 22px">错误提示</span>
          <span>
            <el-button type="primary" size="small" @click="handleExportData"
              >下载错误信息</el-button
            >
            <el-button type="danger" size="small" @click="showModal2 = false"
              >关闭</el-button
            >
          </span>
        </div>
      </div>
      <el-table
        border
        :data="Mechanism"
        stripe
        height="450px"
        style="width: 100%; margin-top: -20px"
        header-cell-class-name="headerStyle"
        :default-sort="{ prop: 'date', order: 'descending' }"
      >
        <el-table-column
          type="index"
          :index="1"
          label="序号"
          style="font-size: 20px; color: #585757"
          width="75"
        ></el-table-column>
        <el-table-column
          prop="institution_code"
          label="机构编码"
          min-width="120px"
          sortable
        >
        </el-table-column>
        <el-table-column
          prop="institution_name"
          label="机构名称"
          min-width="150"
          sortable
        >
        </el-table-column>
        <el-table-column
          prop="institution_type"
          label="类别"
          min-width="100%"
          sortable
        >
        </el-table-column>
        <el-table-column
          prop="institution_grade"
          label="级别"
          min-width="100%"
          sortable
        >
        </el-table-column>
        <el-table-column
          prop="province_id"
          label="省份"
          min-width="150%"
          sortable
        >
        </el-table-column>
        <el-table-column prop="city_id" label="城市" min-width="120px" sortable>
        </el-table-column>
        <el-table-column prop="address" label="地址" min-width="100%" sortable>
        </el-table-column>
        <el-table-column
          prop="telephone"
          label="联系电话"
          min-width="120"
          sortable
        >
        </el-table-column>
        <el-table-column
          prop="postcode"
          label="邮政编码"
          min-width="120"
          sortable
        >
        </el-table-column>
        <el-table-column
          prop="website"
          label="官方网址"
          min-width="120"
          sortable
        >
        </el-table-column>
        <el-table-column prop="comments" label="备注" min-width="120" sortable>
        </el-table-column>

        <el-table-column fixed="right" label="报错信息" width="240px">
          <template slot-scope="scope">
            <div v-for="item in scope.row.message">
              <span style="font-size: 10px; color: red">{{ item }}</span>
            </div>
          </template>
        </el-table-column>
      </el-table>
    </el-dialog>

    <!--hcp报错信息-->
    <el-dialog
      :visible.sync="showModal3"
      :show-close="false"
      width="900px"
      style="margin-top: -20px"
    >
      <div slot="title">
        <div
          slot="title"
          class="dialog-footer"
          style="display: flex; justify-content: space-between"
        >
          <span style="color: #3998f7; font-size: 22px">错误提示</span>
          <span>
            <el-button type="primary" size="small" @click="handleExportData2"
              >下载错误信息</el-button
            >
            <el-button type="danger" size="small" @click="showModal3 = false"
              >关闭</el-button
            >
          </span>
        </div>
      </div>
      <el-table
        border
        :data="Mechanism2"
        stripe
        height="450px"
        style="width: 100%; margin-top: -20px"
        header-cell-class-name="headerStyle"
        :default-sort="{ prop: 'date', order: 'descending' }"
      >
        <el-table-column
          type="index"
          :index="1"
          label="序号"
          style="font-size: 20px; color: #585757"
          width="75"
        ></el-table-column>
        <el-table-column
          prop="institution_code"
          label="机构编码"
          min-width="120px"
          sortable
        >
        </el-table-column>
        <el-table-column
          prop="institution_name"
          label="机构名称"
          min-width="150"
          sortable
        >
        </el-table-column>
        <el-table-column
          prop="hcp_code"
          label="客户编码"
          min-width="100%"
          sortable
        >
        </el-table-column>
        <el-table-column
          prop="hcp_name"
          label="客户姓名"
          min-width="100%"
          sortable
        >
        </el-table-column>
        <el-table-column
          prop="standard_code"
          label="标准科室编码"
          min-width="150%"
          sortable
        >
        </el-table-column>
        <el-table-column
          prop="standard_dept"
          label="标准科室名称"
          min-width="120px"
          sortable
        >
        </el-table-column>
        <el-table-column
          prop="dept_name"
          label="所属科室/部门"
          min-width="120px"
          sortable
        >
        </el-table-column>
        <el-table-column prop="gender" label="性别" min-width="120px" sortable>
        </el-table-column>
        <el-table-column
          prop="jop_title"
          label="职务"
          min-width="100%"
          sortable
        >
        </el-table-column>
        <el-table-column prop="pro_title" label="职称" min-width="120" sortable>
        </el-table-column>
        <el-table-column prop="phone" label="联系电话" min-width="120" sortable>
        </el-table-column>
        <el-table-column prop="email" label="电子邮件" min-width="120" sortable>
        </el-table-column>
        <el-table-column prop="birthday" label="生日" min-width="120" sortable>
        </el-table-column>
        <el-table-column prop="hobby" label="爱好" min-width="120" sortable>
        </el-table-column>
        <el-table-column
          prop="specialties"
          label="主治病症"
          min-width="120"
          sortable
        >
        </el-table-column>
        <el-table-column
          prop="consulting_hours"
          label="门诊时间"
          min-width="120"
          sortable
        >
        </el-table-column>
        <el-table-column
          prop="education"
          label="毕业院校"
          min-width="120"
          sortable
        >
        </el-table-column>
        <el-table-column
          prop="fellowships"
          label="担任协会职务"
          min-width="120"
          sortable
        >
        </el-table-column>
        <el-table-column
          prop="speaker"
          label="是否专家讲者"
          min-width="120"
          sortable
        >
        </el-table-column>
        <el-table-column
          prop="speaker_level"
          label="讲者级别"
          min-width="120"
          sortable
        >
        </el-table-column>
        <el-table-column prop="kol" label="是否KOL" min-width="120" sortable>
        </el-table-column>
        <el-table-column
          prop="kol_level"
          label="KOL级别"
          min-width="120"
          sortable
        >
        </el-table-column>

        <el-table-column fixed="right" label="报错信息" width="240px">
          <template slot-scope="scope">
            <div v-for="item in scope.row.message">
              <span style="font-size: 10px; color: red">{{ item }}</span>
            </div>
          </template>
        </el-table-column>
      </el-table>
    </el-dialog>

    <!--科室数据-->
    <el-dialog
      :visible.sync="showModal4"
      :show-close="false"
      width="900px"
      style="margin-top: -20px"
    >
      <div slot="title">
        <div
          slot="title"
          class="dialog-footer"
          style="display: flex; justify-content: space-between"
        >
          <span style="color: #3998f7; font-size: 22px">错误提示</span>
          <span>
            <el-button type="primary" size="small" @click="handleExportData3"
              >下载错误信息</el-button
            >
            <el-button type="danger" size="small" @click="showModal4 = false"
              >关闭</el-button
            >
          </span>
        </div>
      </div>
      <el-table
        border
        :data="Mechanism3"
        stripe
        height="450px"
        style="width: 100%; margin-top: -20px"
        header-cell-class-name="headerStyle"
        :default-sort="{ prop: 'date', order: 'descending' }"
      >
        <el-table-column
          type="index"
          :index="1"
          label="序号"
          style="font-size: 20px; color: #585757"
          width="75"
        ></el-table-column>
        <el-table-column
          prop="institution_code"
          label="机构编码"
          min-width="120px"
          sortable
        >
        </el-table-column>
        <el-table-column
          prop="institution_name"
          label="机构名称"
          min-width="150"
          sortable
        >
        </el-table-column>
        <el-table-column
          prop="standard_dept"
          label="标准科室编码"
          min-width="100%"
          sortable
        >
        </el-table-column>
        <el-table-column
          prop="standard_dept_name"
          label="标准科室名称"
          min-width="100%"
          sortable
        >
        </el-table-column>
        <el-table-column
          prop="dept_name"
          label="所属科室/部门"
          min-width="150%"
          sortable
        >
        </el-table-column>
        <el-table-column fixed="right" label="报错信息" width="240px">
          <template slot-scope="scope">
            <div v-for="item in scope.row.message">
              <span style="font-size: 10px; color: red">{{ item }}</span>
            </div>
          </template>
        </el-table-column>
      </el-table>
    </el-dialog>

    <el-dialog
      :visible.sync="dialogVisible4"
      width="500px"
      :show-close="false"
      style="vertical-align: center; :#FFF9F3 "
    >
      <div style="margin-top: -40px">
        <el-row style="border-bottom: 2px dotted #e7eaec; padding-bottom: 10px">
          <el-col :span="12">
            <div style="color: #3998f7; padding-top: 8px; font-size: 20px">
              添加科室/部门
            </div>
          </el-col>

          <el-col :span="12">
            <div align="right">
              <el-button type="primary" size="small" @click="addinsList">
                保存
              </el-button>
              <el-button
                type="danger"
                size="small"
                @click="dialogVisible4 = false"
              >
                关闭
              </el-button>
            </div>
          </el-col>
        </el-row>
        <div class="HcpClass" style="margin-top: 20px">
          <el-form
            ref="addDeptList"
            :model="addDeptList"
            label-width="95px"
            hide-required-asterisk
          >
            <div style="margin-top: 10px">
              <el-row>
                <el-col :span="24" style="padding-top: 23px">
                  <el-form-item label="科室名称">
                    <el-input
                      v-model="addDeptList.dept_name"
                      placeholder="请输入科室名称"
                    ></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="24" style="padding-top: -10px">
                  <el-form-item label="标准科室">
                    <el-select
                      v-model="addDeptList.standard_dept"
                      placeholder="请选择对应的标准科室"
                      filterable
                      style="width: 100%"
                      clearable
                    >
                      <el-option
                        v-for="item in administrative"
                        :key="item.key"
                        :label="item.value1"
                        :value="item.key"
                      >
                      </el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="24" style="padding-top: -10px">
                  <el-form-item
                    label="科室编码"
                    class="institution_star"
                    prop="dept_code"
                    :rules="[{ required: true, message: '科室编码不能为空' }]"
                  >
                    <el-input
                      v-model="addDeptList.dept_code"
                      placeholder="请输入科室编码"
                    ></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
            </div>
          </el-form>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
// import TreeNode from './components/treeNode'
import http from "../../APIService/http";
import quarter from "../../components/quarter";
import monthComponent from "../../components/monthComponent";
import http2 from "../../APIService/http2";
import { bus } from "../../router/index.js";
import tu1 from "../../assets/images/tu1.png";
import tu2 from "../../assets/images/tu2.png";
import { Message } from "element-ui";
import { AMapManager } from "vue-amap";
import { mapMutations, mapGetters } from "vuex";
import imgUrl from "../../assets/images/mark_0.png";
import Swiper from "swiper";
import "swiper/css/swiper.min.css";
import "swiper/js/swiper.min.js";

let amapManager = new AMapManager();
let infoWindow;
export default {
  data() {
    let self = this;
    return {
      mySwiper: {},
      contact_id: "",
      clerk_id: "",
      extendedInfo2_1: [],
      extendedInfo2_2: [],
      extendedInfo3_1: [],
      extendedInfo3_2: [],
      insdialogVisible: false,
      insdialogVisible2: false,
      storedialogVisible: false,
      storedialogVisible2: false,
      disdialogVisible: false,
      disdialogVisible2: false,
      distributorlist: {
        distributor_code: "",
        account_id: "",
        account_status: "",
        segment_name: "",
        segment_id: "",
        tenant_id: "",
        distributor_id: "",
        distributor_name: "",
        distributor_type_name: "",
        distributor_type: "",
        distributor_grade_name: "",
        distributor_grade: "",
        province_id: "",
        status: "",
        province_name: "",
        city_id: "",
        city_name: "",
        address: "",
        telephone: "",
        postcode: "",
        website: "",
        location_id: "",
        lat: 103.122221,
        lng: 32.312213,
        alias: "",
        AccountArray: [],
        canAdd: "T",
        rank: "",
        time: "C",
        value1: true,

        rank2: "",
        time2: "",
        value2: "",

        rank3: "",
        time3: "",
        value3: "",
        comments: "",
        comments2: "",
        comments3: "",
        agreement_stage: "",
        agreement_signed: true,
      },
      contactClass: {
        department: "",
        contact_code: "",
        tenant_id: "",
        distributor_id: "",
        contact_id: "",
        contact_name: "",
        gender_name: "",
        gender: "",
        mobile: "",
        email: "",
        birthday: "",
        hobby: "",
        job_title_name: "",
        job_title: "",
        pro_title_name: "",
        pro_title_id: "",
        status: "",
        status_name: "",
      },
      storelist: {
        account_id: "",
        account_status: "",
        segment_name: "",
        segment_id: "",
        tenant_id: "",
        store_id: "",
        store_name: "",
        store_code: "",
        store_type_name: "",
        store_type: "",
        retailstore_grade_name: "",
        retailstore_grade: "",
        province_id: "",
        province_name: "",
        city_id: "",
        status: "",
        city_name: "",
        address: "",
        telephone: "",
        postcode: "",
        website: "",
        location_id: "",
        lat: 0,
        lng: 0,
        alias: "",
        AccountArray: [],
        canAdd: "T",
        value: true,
        time: "C",
        rank: "",
        rank2: "",
        time2: "",
        value2: true,
        rank3: "",
        time3: "",
        value3: "",
        comments: "",
        comments2: "",
        comments3: "",
      },
      clerkClass: {
        birthday: "",
        clerk_id: "",
        clerk_name: "",
        email: "",
        gender: "",
        gender_name: "",
        hobby: "",
        manager: "",
        manager_name: "",
        mobile: "",
        retailstore_id: "",
        status: "",
        status_name: "",
        tenant_id: "",
        clerk_code: "",
      },
      insList: {
        institution_code: "",
        distributor_id: "",
        institution_id: "",
        institution_name: "",
        institution_type: "",
        institution_type_name: "",
        institution_grade: "",
        institution_grade_name: "",
        province_id: "",
        province_name: "",
        city_id: "",
        city_name: "",
        address: "",
        telephone: "",
        website: "",
        comments: "",
        status: "",
        postcode: "",
        location_id: "",
        lat: 31.266771,
        lng: 121.431321,
        alias: "",
        agreement_stage: "",
        agreement_signed: true,
      },
      category: "",
      detailsOff: false,
      addTableList: {},
      delateFalse: false,
      tabIndex: 1,
      isAddTable: false,
      tableData: [],
      dataList: [],
      institutionData_hcp: "",
      institutionData_name: "",
      institutionData_location: "",
      optionList: [],
      extendedInfo: [],
      extendedInfo1: [],
      isfalse: false,
      hcp_id: "",
      activeName2: "first",
      activeName1: "first",
      distributorList: [],
      coordinatesList: [],
      showModal2: false,
      showModal3: false,
      showModal4: false,
      showModal5: false,
      searchStr: "",
      mydiv: 0,
      marginValue: "",
      widthLocation: "",
      fileList: [],
      fileList2: [],
      fileList3: [],
      fileList4: [],
      markers2: [],
      centers: [],
      detailsBox: false,
      cluster: null,
      searchOption: {
        city: "上海",
        citylimit: false,
      },
      mapCenter: [121.59996, 31.197646],

      formamap: {
        address: "",
      },
      formapLocation: {
        location_name: "",
        address: "",
        location_id: "",
        status: "INACTIVE",
      },
      locationInfo: [],
      institutionList: [],
      map: null,
      hospitalInstitution_id: "",
      institutionStatus: true,
      institution_id: "",
      store_id: "",
      distributor_id: "",
      node_key: "",
      scope: "single",
      province_id: "110000",
      city_id: "110100",
      city_lng: 0,
      city_lat: 0,
      filterText: "",
      icon: [tu1, tu2],
      // isDisabled:false,

      showAmapDialog: false,
      amapManager,
      zoom: 10,
      center: [116.46, 39.92],
      mapOff: true,
      events: {
        init(o) {
          setTimeout(() => {
            // self._amapInit(o)
          }, 1000);
        },
        complete() {
          let o = amapManager.getMap();
          self._amapInit(o);
        },
      },
      markers: [
        {
          position: [116.46, 39.92],
          events: {
            click: () => {
              if (this.texts[0].name) {
                this.texts[0].name = "";
              } else {
                let name = "名称：" + self.storeInfoObj.store_name;
                let address = "地址：" + self.storeInfoObj.address;

                this.texts[0].name =
                  "<span style='font-size: 14px;margin: 5px'>" +
                  name +
                  "</span>" +
                  "<br/>" +
                  "<span style='font-size: 14px;margin: 5px'>" +
                  address +
                  "</span>" +
                  "<br/>";

                let userObj = this.$store.getters.getUser;
                if (userObj.role === "admin") {
                  this.texts[0].name =
                    this.texts[0].name +
                    "<span style='color: #FF9901;font-size: 14px;margin: 5px;float: right;cursor:pointer'>编辑坐标</span>";
                }
              }
            },
          },
          visible: true,

          template: "1",
        },
      ],
      edit_markers: {
        position: [],
        events: {
          dragend: (e) => {
            //拖拽结束

            this.getpois([e.lnglat.lng, e.lnglat.lat]);
            let geocoder;
            AMap.plugin("AMap.Geocoder", function () {
              // 这里通过高德 SDK 完成。
              geocoder = new AMap.Geocoder({
                radius: 1000,
                extensions: "all",
              });
            });

            geocoder.getAddress(
              [e.lnglat.lng, e.lnglat.lat],
              function (status, result) {
                if (status === "complete" && result.info === "OK") {
                  if (result && result.regeocode) {
                    self.formapLocation.address =
                      result.regeocode.formattedAddress; //获取到位置
                    self.formamap.address = result.regeocode.formattedAddress; //获取到位置
                    self.formapLocation.location_name =
                      result.regeocode.pois[0].name; //获取到位置
                  }
                }
              }
            );
          },
        },
        visible: true,
      },
      texts: [
        {
          position: [116.46, 39.92],
          name: "",
          offset: [0, -65],
          events: {
            click: () => {
              let userObj = this.$store.getters.getUser;

              if (this.texts[0].name && userObj.role === "admin") {
                self.showAmapDialog = true;
              }
            },
          },
        },
      ],
      plugin: [
        {
          pName: "ToolBar",
          position: "RT",
          locate: false,

          events: {
            init(instance) {},
          },
        },
      ],

      Hcplist: {
        title: "",
        name: "",
        sex: "",
        zhiwu: "",
        zhicheng: "",
        phone: "",
        mali: "",
        value1: "",
        hobby: "",
        hcp_id: "",
        gender: "",
        institutionStatus: true,
        specialties: "", //主治病症
        consulting_hours: "", //门诊时间
        education: "", //毕业院校
        fellowships: "", //担任协会职务
        speaker_level: "", //讲者级别
        kol_level: "", //KOL级别
        kol: true, //KOL
        speaker: true, //专家讲者
        hcp_code: "",
        department: "",
        standard_dept: "",
        status: true,
      },
      HcpAdd: {
        title: "",
        name: "",
        sex: "",
        zhiwu: "",
        zhicheng: "",
        phone: "",
        mali: "",
        value1: "",
        hobby: "",
        status: true,
        specialties: "", //主治病症
        consulting_hours: "", //门诊时间
        education: "", //毕业院校
        fellowships: "", //担任协会职务
        speaker: false,
        kol: false,
        speaker_level: "", //讲者级别
        kol_level: "", //KOL级别
        hcp_code: "",
        department: "",
        standard_dept: "",
      },
      kol: false, //KOL
      speaker: false, //专家讲者
      options: [],
      LngLat: null,
      institutionObj: {
        address: "",
        city_id: "",
        city_name: "",
        comments: "",
        institution_code: "",
        institution_grade: "",
        institution_grade_name: "",
        institution_id: "",
        institution_name: "",
        institution_type: "",
        institution_type_name: "",
        lat: 0,
        lng: 0,
        postcode: "",
        province_id: "",
        province_name: "",
        status: "",
        telephone: "",
        website: "",
      },
      Status: {},
      is_shrinkage: false,
      loading: false,
      deptList: [],
      hcpArray: [],
      prolist: [],
      jobtList: [],
      administrative: [],
      departments: [],
      TypeList: [],
      GardeList: [],
      CityList: [],
      pushlist: {
        address: "",
        city_id: "",
        city_name: "",
        comments: "",
        institution_code: "",
        institution_grade: "",
        institution_grade_name: "",
        institution_id: "",
        institution_name: "",
        institution_type: "",
        institution_type_name: "",
        lat: 0,
        lng: 0,
        location_id: "",
        postcode: "",
        province_id: "",
        province_name: "",
        status: true,
        agreement_signed: true,
        telephone: "",
        website: "",
        agreement_stage: "",
      },
      rules: {
        institution_name: [{ required: true, message: "请输入名称" }],
        institution_type: [{ required: true, message: "请选择类别" }],
        institution_code: [{ required: true, message: "请填写机构编码" }],
        province_id: [{ required: true, message: "请选择省份" }],
        city_id: [{ required: true, message: "请选择城市" }],
        status: [{ required: true, message: "" }],
        dept_code: [{ required: true, message: "科室编码不能为空" }],
      },
      form: {
        name: "",
        title: "",
        position: "",
        input: "",
        input2: "",
      },
      input: "",
      dialog1: false,
      dialog2: false,
      dialogVisible: false,
      dialogVisible2: false,
      dialogVisible3: false,
      dialogVisible4: false,
      dialogVisible5: false,
      dialogVisible6: false,

      administrativeList: [],
      productList: [],
      SkuList: [],
      QUARTER: "",
      WEEK: "",
      activeName: "",
      data: [],
      data2: [],
      loadArr: [],
      loadCount: 0,
      index: "",
      defaultProps: {
        children: "children",
        label: "label",
      },
      institution_name: "",
      address: "",
      location_id: "",
      isUpload: false,
      isUpload2: false,
      isUpload3: false,
      isUpload4: false,
      Mechanism: [],
      Mechanism2: [],
      Mechanism3: [],
      Mechanism4: [],
      arr: [],
      arr2: [],
      arr3: [],
      arr4: [],
      Institution: [],
      deriveHcpList: [],
      AGREEMENT_STAGE: [],
      addDeptList: {
        dept_name: "",
        dept_code: "",
        standard_dept: "",
      },
      old_department: "",
      dialogLoaction: false,
      locationDate: [],
      file: "",
      file2: "",
      file3: "",
      isDetail: false,
      isDetail1: false,
      tags: [],
      photoUrl: "",
      uuidAgenda: "",
      categoryAgenda: {},
      photoIdObj: {},
      photoIdArray: [],
      tagText: "",
      imgArray: [],
      photo_id_arr: [],
      editTags: [],
      type: "",
      selectPhotoId: "",
      tags1: [],
      photoUrl1: "",
      uuidAgenda1: "",
      categoryAgenda1: {},
      photoIdObj1: {},
      photoIdArray1: [],
      tagText1: "",
      imgArray1: [],
      photo_id_arr1: [],
      editTags1: [],
      type1: "",
      selectPhotoId1: "",
      fileDetail: false,
      fileInfo: {},
      fileTag: "",
      fileTags: [],
      fileTable: [],
      selectFileId: "",
      statistics: {},
      fileTable1: [],
      statistics1: {},
      selectDeptId: "",
      InstituionList: [],
      markerRefs: [],
      markerRefsTime: "",
    };
  },
  beforeDestroy() {
    amapManager.getMap().destroy();
  },
  created() {
    // this.province_id = this.$route.query.province_id
    // this.city_id = this.node_key = this.$route.query.city_id
    // this.province_id = null
    // this.city_id = null
    // this.city_lng = this.$route.query.city_lng
    // this.city_lat=this.$route.query.city_lat
    this.province_id = this.cache_page("province_id");
    this.city_id = this.node_key = this.cache_page("city_id");
    this.city_lng = this.cache_page("city_lng");
    this.city_lat = this.cache_page("city_lat");
    if (!this.province_id && !this.city_id) {
      this.province_id = "110000";
      this.city_id = "110100";
    }

    // this.province_id = this.$route.query.province_id
    // this.city_id = this.$route.query.city_id
    this.getProvinceAndCityList();
    // this.getEtmsInstituionListAction()

    this.getDictionaryListByKOL_LEVEL();
    this.getDictionaryListByKOL_LEVEL2();
    this.getDictionaryListBySPEAKER_LEVEL();

    this.getItitutionTypeList();
  },

  computed: {
    ...mapGetters({
      cache_page: "getMainCustomer",
    }),
  },
  components: {
    quarter,
    monthComponent,
  },

  watch: {
    province_id(val) {
      this.setMainCustomer({ province_id: val });
    },
    city_id(val) {
      this.setMainCustomer({ city_id: val });
      this.node_key = val ? val : this.province_id;
    },
    city_lng(val) {
      this.setMainCustomer({ city_lng: val });
    },
    city_lat(val) {
      this.setMainCustomer({ city_lat: val });
    },
    filterText(val) {
      this.$refs.tree.filter(val);
      this.$refs.tree2.filter(val);
    },
    dialogVisible2(newVal, oldVal) {
      if (newVal == false) {
        this.fileDetail = false;
        this.isDetail = false;
      }
    },
  },
  methods: {
    ...mapMutations(["setMainCustomer", "resetMainCustomer"]),
    _amapInit(o) {
      this.cluster = new AMap.MarkerClusterer(o, [], {
        gridSize: 80,
        minClusterSize: 8,
        // renderCluserMarker: self._renderCluserMarker
      });
      infoWindow = new AMap.InfoWindow({
        isCustom: true, //使用自定义窗体
        // content: self.createInfoWindow.call(self,name, content,item),
        offset: new AMap.Pixel(0, -35),
      });
      this.getEtmsInstituionListAction();
    },
    _renderCluserMarker(context) {
      const count = this.centers.length;

      let factor = Math.pow(context.count / count, 1 / 18);
      let div = document.createElement("div");
      let Hue = 180 - factor * 180;
      let bgColor = "hsla(" + Hue + ",100%,50%,0.7)";
      let fontColor = "hsla(" + Hue + ",100%,20%,1)";
      let borderColor = "hsla(" + Hue + ",100%,40%,1)";
      let shadowColor = "hsla(" + Hue + ",100%,50%,1)";
      div.style.backgroundColor = bgColor;
      let size = Math.round(30 + Math.pow(context.count / count, 1 / 5) * 20);
      div.style.width = div.style.height = size + "px";
      div.style.border = "solid 1px " + borderColor;
      div.style.borderRadius = size / 2 + "px";
      div.style.boxShadow = "0 0 1px " + shadowColor;
      div.innerHTML = context.count;
      div.style.lineHeight = size + "px";
      div.style.color = fontColor;
      div.style.fontSize = "14px";
      div.style.textAlign = "center";
      context.marker.setOffset(new AMap.Pixel(-size / 2, -size / 2));
      context.marker.setContent(div);
    },
    // 关闭
    detailsOffClick() {
      this.detailsOff = false;
      let map = amapManager.getMap();
      infoWindow.open(map, this.LngLat);
    },

    // 点击swiper
    mapArrayClick(item) {
      this.InstituionList.forEach((item) => {
        item.selected = false;
      });

      item.selected = true;

      this.center = [item.lng, item.lat];
      this.zoom = 15;
    },
    // 查看详情
    details(e) {
      const item = e.currentTarget.CustomData;
      infoWindow.close();
      this.detailsOff = false;
      this.detailsOff = true;
      this.getProvinceList();
      this.getAdministrativeList();
      this.getProductList();
      if (item.category == "INSTITUTION") {
        this.category = "INSTITUTION";
        this.institution_id = item.institution_id;
        this.getDistributor();
        this.getDictionaryListByKOL_LEVEL2();
        this.getInstitutionInfo(item.institution_id);
        this.getItitutionTypeList();
        this.getInstitutionDeptList(item.institution_id);
        this.getImgInfo();
        this.getFilesInfo();
      } else if (item.category == "RETAILSTORE") {
        this.category = "RETAILSTORE";
        this.store_id = item.store_id;
        this.getRetailstoreTypeList();
        this.getInstitution();
        this.getDistributor();
        this.getRetailstoreClerkList();
        this.getRetailstoreInfo(item.store_id);
      } else if (item.category == "DISTRIBUTOR") {
        this.category = "DISTRIBUTOR";
        this.distributor_id = item.distributor_id;
        this.getDistributorTypeList();
        this.getDictionaryListByKOL_LEVEL3();
        this.getDistributorInfo(item.distributor_id);
        this.getDistributorContactList();
      }
    },

    //             async getEtmsInstituionList() {
    //                 const loading1 = this.$loading({
    //                     lock: true,
    //                     text: '拼命加载中',
    //                     spinner: 'el-icon-loading',
    //                     background: 'rgba(0, 0, 0, 0.7)'
    //                 });
    //
    //                 this.InstituionList = []
    //                 this.center = []
    //                 this.centers = []
    //                 let data = {
    //                     user_id: this.$store.getters.getUser.user_id,
    //                     tenant_id: this.$store.getters.getUser.tenant_id,
    //                     city_id:this.city_id
    //                 }
    //                 let self = this
    //                 await http.post('/wapi/InstitutionClient/getStaffMapList', data).then(res => {
    //                     if (res.success) {
    //
    //                         self.InstituionList = res.data
    //                         self.markerRefs = []
    //                         console.log(self.InstituionList)
    //                         this.$nextTick(()=>{
    //                             this.mySwiper = new Swiper('.swiper-container', {
    //                                 slidesPerView:"auto",
    //                                 freeMode : true,
    //                                 grabCursor: true,
    //                             });
    //                         })
    //                         if(self.InstituionList.length>0){
    //                             if(self.InstituionList[0].lng){
    //                                 self.center=[self.InstituionList[0].lng,self.InstituionList[0].lat]
    //                             }
    //
    //
    //
    //
    //                             self.InstituionList.forEach((item,index)=>{
    //                                 if(item.category == 'INSTITUTION' && item.lng){
    //                                     self.centers.push({
    //                                                     position: [item.lng, item.lat],
    //                                                     template: `<div style="width: 22px;color:#fff;height: 30px;text-align: center;font-size: 12px; line-height: 20px; background:url(${imgUrl})">${item.target_num}</div>`,
    //                                                     events: {
    //                                                         init(o) {
    //                                                             self.markerRefs.push(o);
    //                                                         },
    //                                                         click: () => {
    //                                                             this.mySwiper.slideTo(index, 1000, false)
    //                                                             self.InstituionList.forEach((item1,index1)=>{
    //                                                                 item1.selected = false
    //                                                             })
    //                                                             item.selected = true
    //
    //                                                         }
    //                                                     },
    //                                                     visible: true,
    //                                                 });
    //                                 }else if(item.category == 'RETAILSTORE' && item.lng){
    //                                     self.centers.push({
    //                                                     position: [item.lng, item.lat],
    //                                                     template: `<div style="width: 22px;color:#fff;height: 30px;text-align: center;font-size: 12px; line-height: 20px; background:url(${imgUrl})">${item.clerk_num}</div>`,
    //                                                     events: {
    //                                                         init(o) {
    //                                                             self.markerRefs.push(o);
    //                                                         },
    //                                                         click: () => {
    //                                                             this.mySwiper.slideTo(index, 1000, false)
    //                                                             self.InstituionList.forEach((item1,index1)=>{
    //                                                                 item1.selected = false
    //                                                             })
    //                                                             item.selected = true
    //                                                         }
    //                                                     },
    //                                                     visible: true,
    //                                                 });
    //                                 }else if(item.category == 'DISTRIBUTOR' && item.lng){
    //                                     self.centers.push({
    //                                                     position: [item.lng, item.lat],
    //                                                     template: `<div style="width: 22px;color:#fff;height: 30px;text-align: center;font-size: 12px; line-height: 20px; background:url(${imgUrl})">${item.contact_count}</div>`,
    //                                                     events: {
    //                                                         init(o) {
    //                                                             self.markerRefs.push(o);
    //                                                         },
    //                                                         click: () => {
    //                                                             this.mySwiper.slideTo(index, 1000, false)
    //                                                             self.InstituionList.forEach((item1,index1)=>{
    //                                                                 item1.selected = false
    //                                                             })
    //                                                             item.selected = true
    //                                                         }
    //                                                     },
    //                                                     visible: true,
    //
    //                                                 });
    //                                 }
    //                             })
    //                             // var map = amapManager.getMap();
    //                             //
    //                             //
    //                             // let cluster = new AMap.MarkerClusterer(map, self.markerRefs,{
    //                             //     gridSize: 80,
    //                             //     renderCluserMarker: self._renderCluserMarker
    //                             // });
    //
    //
    //                             //基本地图加载
    // //
    // //
    // //                             var sts = [{//聚合点的样式
    // //                                 url: "https://a.amap.com/jsapi_demos/static/images/blue.png",
    // //                                 size: new AMap.Size(34, 34),
    // //                                 offset: new AMap.Pixel(-16, -16)
    // //                             }]
    //
    //
    //                             // self.cluster = new AMap.MarkerClusterer(
    //                             //     map,     // 地图实例
    //                             //     self.centers,    // 海量点组成的数组
    //                             //     {
    //                             //         styles: sts,
    //                             //         gridSize: 20,
    //                             //         minClusterSize:2,
    //                             //         maxZoom:18
    //                             //     });
    //
    //
    //                         }
    //                         self.mapOff = true
    //
    //                         loading1.close()
    //
    //
    //                     } else {
    //                         loading1.close()
    //                         Message.error(res.message);
    //                     }
    //
    //                 })
    //             },

    // 机构详情(查看所有属性)
    insInfoClick() {
      this.activeName2 = "first";
      this.getExtendedInfo();
      this.getImgInfo();
      this.getFilesInfo();
    },
    hcpClickInfo(row) {
      this.getJobtList();
      this.getProList();
      this.getStandardDeptList();
      this.isfalse = true;
      this.extendedInfo1 = [];
      this.hcp_id = row.hcp_id;
      this.activeName1 = "first";
      this.dialogVisible3 = true;
      this.Hcplist.title = row.dept_id;
      this.Hcplist.name = row.hcp_name;
      this.Hcplist.sex = row.gender;
      this.Hcplist.zhiwu = row.job_title_id;
      this.Hcplist.zhicheng = row.pro_title_id;
      this.Hcplist.phone = row.mobile;
      this.Hcplist.mali = row.email;
      this.Hcplist.value1 = row.birthday;
      this.Hcplist.hobby = row.hobby;
      this.Hcplist.hcp_id = row.hcp_id;
      this.Hcplist.hcp_code = row.hcp_code;
      this.Hcplist.stastus = row.stastus == "ACTIVE" ? true : false;

      this.Hcplist.specialties = row.specialties;
      this.Hcplist.consulting_hours = row.consulting_hours;
      this.Hcplist.education = row.education;
      this.Hcplist.fellowships = row.fellowships;
      this.Hcplist.speaker_level = row.speaker_level_name;
      this.Hcplist.kol_level = row.kol_level_name;
      this.Hcplist.department = row.department;
      this.Hcplist.standard_dept = row.standard_dept;

      if (row.speaker == "T") {
        this.Hcplist.speaker = true;
      } else {
        this.Hcplist.speaker = false;
      }
      if (row.kol == "T") {
        this.Hcplist.kol = true;
      } else {
        this.Hcplist.kol = false;
      }

      if (row.status == "ACTIVE") {
        this.Hcplist.institutionStatus = true;
        this.Hcplist.status = true;
      } else {
        this.Hcplist.institutionStatus = false;
        this.Hcplist.status = false;
      }
      this.getExtendedInfo2();
      this.getImgInfo1();
      this.getFilesInfo1();
    },

    fangfa1_1(b) {
      this.insList.institution_grade_name = "";
      this.getItitutionGardeList(b);
    },
    baocun1_1() {
      if (this.activeName2 == "first") {
        this.$refs["insList"].validate((valid) => {
          if (!valid) {
            return false;
          } else {
            this.updateInstitution();
          }
        });
      } else {
        let off = true;
        if (this.extendedInfo[this.tabIndex - 1].fieldArray.length > 0) {
          for (
            var i = 0;
            i < this.extendedInfo[this.tabIndex - 1].fieldArray.length;
            i++
          ) {
            if (
              this.extendedInfo[this.tabIndex - 1].fieldArray[i].mandatory ==
              "T"
            ) {
              this.$refs["inslist" + i][0].validate((valid) => {
                if (!valid) {
                  off = false;
                }
              });
            }
          }
          if (off) {
            this.updateExtendedInfo();
          }
        }
      }
    },
    guanbi1_1() {
      this.insdialogVisible = false;
    },

    // 机构
    async getProvinceList() {
      let data = {
        tenant_id: this.$store.getters.getUser.tenant_id,
      };
      let self = this;
      await http.post("/wapi/Province/getProvinceList", data).then((res) => {
        if (res.success) {
          self.provinceList = res.data;
        } else {
          Message.error(res.message);
        }
      });
    },
    getAdministrativeList() {
      let data = {
        tenant_id: this.$store.getters.getUser.tenant_id,
        category: "STANDARD_DEPT",
      };
      http.post("/wapi/Institution/getAdministrativeList", data).then((res) => {
        if (res.success) {
          this.administrativeList = res.data;
        }
      });
    },
    getProductList() {
      let data = {
        tenant_id: this.$store.getters.getUser.tenant_id,
      };
      http.post("/wapi/Institution/getProductList", data).then((res) => {
        if (res.success) {
          this.productList = res.data;
        }
      });
    },
    getSkuList(item) {
      let product_id = "";
      if (item instanceof Object) {
        product_id = item.addTableList.product_id;
        item.addTableList.sku_id = "";
        item.addTableList.sku_name = "";
      } else {
        product_id = item;
      }

      let data = {
        tenant_id: this.$store.getters.getUser.tenant_id,
        product_id: product_id,
      };
      http.post("/wapi/Institution/getSkuList", data).then((res) => {
        if (res.success) {
          this.SkuList = res.data;
        }
      });
    },
    async getDistributor() {
      let data = {
        tenant_id: this.$store.getters.getUser.tenant_id,
        province_id: this.province_id,
      };
      await http.post("/wapi/Institution/getDistributor", data).then((res) => {
        if (res.success) {
          this.distributorList.length = 0;
          for (var i = 0; i < res.data.length; i++) {
            this.distributorList.push({
              distributor_id: res.data[i].distributor_id,
              distributor_name: res.data[i].distributor_name,
            });
          }
        } else {
          Message.error(res.message);
        }
      });
    },
    async getDictionaryListByKOL_LEVEL2() {
      let data = {
        tenant_id: this.$store.getters.getUser.tenant_id,
        category: "INSTITUTION_AGREEMENT_STAGE",
      };
      let self = this;
      await http
        .post("/wapi/v1/getDictionaryListByCategory", data)
        .then((res) => {
          if (res.success) {
            self.AGREEMENT_STAGE = res.data;
          } else {
            Message.error(res.message);
          }
          this.dialogVisible4 = false;
        });
    },
    //客户管理-医疗机构获取医院详情
    async getInstitutionInfo(id, territory_id) {
      // let loading = this.$loading({
      //     lock: true,
      //     text: '拼命加载中',
      //     spinner: 'el-icon-loading',
      //     background: 'rgba(0, 0, 0, 0.7)'
      // });

      let data = {
        // territory_id: territory_id,
        tenant_id: this.$store.getters.getUser.tenant_id,
        institution_id: id,
      };
      let self = this;
      await http
        .post("/wapi/Institution/getInstitutionInfo", data)
        .then((res) => {
          if (res.success) {
            self.InstitutionInfo = res.data[0];
            (this.hospitalInstitution_id = res.data[0].institution_id),
              (self.insList.institution_code = res.data[0].institution_code),
              (self.insList.institution_id = res.data[0].institution_id),
              (self.insList.distributor_id = res.data[0].distributor_id),
              (self.insList.institution_name = res.data[0].institution_name),
              (self.insList.institution_type = res.data[0].institution_type),
              (self.insList.institution_type_name =
                res.data[0].institution_type_name),
              (self.insList.institution_grade = res.data[0].institution_grade),
              (self.insList.institution_grade_name =
                res.data[0].institution_grade_name),
              (self.insList.province_id = res.data[0].province_id),
              (self.insList.province_name = res.data[0].province_name),
              (self.insList.city_id = res.data[0].city_id),
              (self.insList.city_name = res.data[0].city_name),
              (self.insList.address = res.data[0].address),
              (self.insList.telephone = res.data[0].telephone),
              (self.insList.website = res.data[0].website),
              (self.insList.comments = res.data[0].comments),
              (self.insList.status = res.data[0].status),
              (self.insList.postcode = res.data[0].postcode),
              (self.insList.location_id = res.data[0].location_id),
              (self.insList.lat = res.data[0].lat),
              (self.insList.lng = res.data[0].lng),
              (self.insList.alias = res.data[0].alias);

            self.insList.agreement_stage = res.data[0].agreement_stage;

            if (res.data[0].agreement_signed == "T") {
              self.insList.agreement_signed = true;
            } else {
              self.insList.agreement_signed = false;
            }
            if (res.data[0].lng) {
              this.center = [res.data[0].lng, res.data[0].lat];
            }

            // loading.close()
            if (res.data[0].province_id != "") {
              this.getCityList(res.data[0].province_id);
            }
          } else {
            // loading.close()
            Message.error(res.message);
          }
        });
    },
    async getItitutionTypeList() {
      let data = {
        tenant_id: this.$store.getters.getUser.tenant_id,
      };

      let self = this;
      await http
        .post("/wapi/Institution/getItitutionTypeList", data)
        .then((res) => {
          if (res.success) {
            self.TypeList = res.data;
          } else {
            Message.error(res.message);
          }
        });
    },
    //客户管理-医疗机构获取HCP部门与人员列表
    async getInstitutionDeptList(id) {
      this.loading = true;

      let data = {
        tenant_id: this.$store.getters.getUser.tenant_id,
        institution_id: id,
        // territory_id:territory_id,
        owner_id: this.$store.getters.getUser.user_id,
      };
      let self = this;
      await http
        .post("/wapi/Institution/getInstitutionDeptList", data)
        .then((res) => {
          if (res.success) {
            self.DeptList = [];
            for (var i = 0; i < res.data.length; i++) {
              let obj = res.data[i];
              let obj1 = {
                tenant_id: "",
                dept_id: "",
                dept_name: "",
                standard_dept: "",
                standard_dept_name: "",
                institution_id: "",
                hcpArray: [],
              };
              obj1.tenant_id = obj.tenant_id;
              obj1.dept_id = obj.dept_id;
              obj1.dept_name = obj.dept_name;
              obj1.standard_dept = obj.standard_dept;
              obj1.standard_dept_name = obj.standard_dept_name;
              obj1.institution_id = obj.institution_id;

              for (var j = 0; j < obj.hcpArray.length; j++) {
                let obj2 = obj.hcpArray[j];

                let obj3 = {
                  hcp_name: "",
                  hcp_id: "",
                  hcp_code: "",
                  institution_id: "",
                  dept_id: "",
                  dept_name: "",
                  account_id: "",
                  account_status: "",
                  segment_name: "",
                  segment_id: "",
                  gender_name: "",
                  gender: "",
                  pro_title_id: "",
                  pro_title_name: "",
                  job_title_id: "",
                  job_title_name: "",
                  mobile: "",
                  email: "",
                  birthday: "",
                  hobby: "",
                  status: "",
                  status_name: "",
                  call_count: "",
                  campaign_count: "",
                  AccountArray: [],
                  canAdd: "",

                  specialties: "",
                  consulting_hours: "",
                  education: "",
                  fellowships: "",
                  speaker: "",
                  speaker_level: "",
                  kol: "",
                  kol_level: "",
                  speaker_level_name: "",
                  kol_level_name: "",
                  department: "",
                  standard_dept: "",
                };
                obj3.hcp_name = obj2.hcp_name;
                obj3.hcp_id = obj2.hcp_id;
                obj3.hcp_code = obj2.hcp_code;
                obj3.institution_id = obj2.institution_id;
                obj3.dept_id = obj2.dept_id;
                obj3.dept_name = obj2.dept_name;
                obj3.account_id = obj2.account_id;
                obj3.account_status = obj2.account_status;
                obj3.segment_name = obj2.segment_name;
                obj3.segment_id = obj2.segment_id;
                obj3.old_segment_id = obj2.segment_id;
                obj3.gender_name = obj2.gender_name;
                obj3.gender = obj2.gender;
                obj3.pro_title_id = obj2.pro_title_id;
                obj3.pro_title_name = obj2.pro_title_name;
                obj3.job_title_id = obj2.job_title_id;
                obj3.job_title_name = obj2.job_title_name;
                obj3.mobile = obj2.mobile;
                obj3.email = obj2.email;
                obj3.birthday = obj2.birthday;
                obj3.hobby = obj2.hobby;
                obj3.status = obj2.status;
                obj3.old_account_status = obj2.account_status;
                obj3.status_name = obj2.status_name;
                obj3.canAdd = obj2.canAdd;

                obj3.specialties = obj2.specialties;
                obj3.consulting_hours = obj2.consulting_hours;
                obj3.education = obj2.education;
                obj3.fellowships = obj2.fellowships;
                obj3.speaker = obj2.speaker;
                obj3.speaker_level = obj2.speaker_level;
                obj3.kol = obj2.kol;
                obj3.kol_level = obj2.kol_level;
                obj3.speaker_level_name = obj2.speaker_level_name;
                obj3.kol_level_name = obj2.kol_level_name;
                (obj3.department = obj2.department),
                  (obj3.standard_dept = obj2.standard_dept);

                // for (var z = 0; z < obj2.AccountArray.length; z++) {
                //     let obj4 = obj2.AccountArray[z]
                //     obj3.AccountArray.push(obj4)
                // }

                obj1.hcpArray.push(obj3);
              }

              self.DeptList.push(obj1);
              console.log(this.DeptList, 12);
            }

            if (self.DeptList.length > 0) {
              if (self.index == "") {
                self.index = "0";
              }
              self.activeName = this.DeptList[self.index].standard_dept;
            }
          } else {
            Message.error(res.message);
          }
          //关闭菊花
          self.loading = false;
        });
    },

    // 门店
    storeInfoClick() {
      this.isfalse = true;
      this.activeName2 = "first";
      this.getStoreExtendedInfo();
      this.getStoreImgInfo();
      this.getStoreFilesInfo();
    },
    fangfa2_1() {
      this.storelist.retailstore_grade_name = "";
      this.getRetailstoreGardeList(b);
    },
    baocun2_1() {
      if (this.activeName2 == "first") {
        this.$refs["storelist"].validate((valid) => {
          if (!valid) {
            return false;
          } else {
            this.updateRetailstore();
          }
        });
      } else {
        let off = true;
        if (this.extendedInfo2_1[this.tabIndex - 1].fieldArray.length > 0) {
          for (
            var i = 0;
            i < this.extendedInfo2_1[this.tabIndex - 1].fieldArray.length;
            i++
          ) {
            if (
              this.extendedInfo2_1[this.tabIndex - 1].fieldArray[i].mandatory ==
              "T"
            ) {
              this.$refs["storelist" + i][0].validate((valid) => {
                if (!valid) {
                  off = false;
                }
              });
            }
          }
          if (off) {
            this.updateStoreExtendedInfo();
          }
        }
      }
    },
    async updateRetailstore() {
      let status = "";
      if (this.storelist.status == true) {
        status = "ACTIVE";
      } else {
        status = "INACTIVE";
      }
      let data = {
        tenant_id: this.$store.getters.getUser.tenant_id,
        store_id: this.store_id,
        store_code: this.storelist.store_code,
        store_name: this.storelist.store_name,
        store_type: this.storelist.store_type,
        retailstore_grade: this.storelist.retailstore_grade,
        province_id: this.storelist.province_id,
        city_id: this.storelist.city_id,
        institution_id: this.storelist.institution_id,
        address: this.storelist.address,
        telephone: this.storelist.telephone,
        postcode: this.storelist.postcode,
        website: this.storelist.website,
        comments: this.storelist.comments,
        distributor_id: this.storelist.distributor_id,
        user_id: this.$store.getters.getUser.user_id,
        status: status,
      };
      //                let self = this
      await http
        .post("/wapi/Retailstore/updateRetailstore", data)
        .then((res) => {
          if (res.success) {
            this.storedialogVisible = false;
          } else {
            Message.error(res.message);
            this.storedialogVisible = true;
          }
        });
    },
    guanbi2_1() {
      this.storedialogVisible = false;
    },
    async getStoreImgInfo() {
      try {
        let data = {
          tenant_id: this.$store.getters.getUser.tenant_id,
          store_id: this.storelist.store_id,
          user_id: this.$store.getters.getUser.user_id,
        };
        await http.post("/wapi/Retailstore/getImgInfo", data).then((res) => {
          if (res.data) {
            this.photo_id_arr = res.data;
            this.getStoreImgUrl();
          }
        });
      } catch (e) {
        return e;
      }
    },
    async getStoreImgUrl() {
      try {
        this.imgArray = [];
        for (let i = 0; i < this.photo_id_arr.length; i++) {
          let obj = this.photo_id_arr[i];
          let data = {
            reference_obj: "RETAILSTORE",
            reference_id: "com.saasyun.android",
            credential: "0a4da4e6-e36a-4e78-b4fc-78bb62aa9ff4",
            photo_ids: obj.photo_id,
            tenant_id: this.$store.getters.getUser.tenant_id,
          };
          let res = await http.post("/photos/downloadphotos", data);

          this.imgArray.push({
            url: res.data[0].url,
            photo_id: res.data[0].photoid,
            tag: obj.tag,
          });
        }
      } catch (err) {
        console.log(`error:${err}`);
      }
    },
    async getStoreFilesInfo() {
      try {
        let data = {
          tenant_id: this.$store.getters.getUser.tenant_id,
          store_id: this.storelist.store_id,
          user_id: this.$store.getters.getUser.user_id,
        };
        await http.post("/wapi/Retailstore/getFilesInfo", data).then((res) => {
          if (res.success) {
            this.fileTable = res.data;
            let numObj = {
              imgNum: 0,
              slideNum: 0,
              mp4Num: 0,
              docNum: 0,
              restsNum: 0,
            };
            for (let i = 0; i < this.fileTable.length; i++) {
              let obj = this.fileTable[i];
              obj.file_name = obj.file_name.split(".")[0];
              if (obj.category == "PICTURE") {
                numObj.imgNum++;
              } else if (obj.category == "VIDEO") {
                numObj.mp4Num++;
              } else if (obj.category == "SLIDE") {
                numObj.slideNum++;
              } else if (obj.category == "DOCUMENT") {
                numObj.docNum++;
              } else {
                numObj.restsNum++;
              }
            }
            this.statistics = numObj;
          }
        });
      } catch (e) {
        return e;
      }
    },
    async getStoreExtendedInfo() {
      this.loading = true;
      let data = {
        tenant_id: this.$store.getters.getUser.tenant_id,
        retailstore_id: this.store_id,
      };
      await http.post("/wapi/Retailstore/getExtendedInfo", data).then((res) => {
        if (res.success) {
          this.extendedInfo2_1 = res.data;
          if (this.extendedInfo2_1.length > 0) {
            for (let i = 0; i < this.extendedInfo2_1.length; i++) {
              this.extendedInfo2_1[i].fieldArray.forEach((item) => {
                if (
                  item.input_type === "LIST" &&
                  item.multiple === "T" &&
                  item.field_value.indexOf("|") == -1 &&
                  item.field_value !== ""
                ) {
                  item.field_value = [item.field_value];
                }
                if (
                  item.input_type === "LIST" &&
                  item.field_value.indexOf("|") !== -1
                ) {
                  item.field_value = item.field_value.split("|");
                }
                if (
                  item.input_type === "LIST" &&
                  item.multiple === "T" &&
                  item.field_value === ""
                ) {
                  item.field_value = [];
                }
                if (item.input_type === "TABLE" && item.field_value !== "") {
                  item.field_value = JSON.parse(item.field_value);
                }
                if (item.input_type === "TABLE" && item.field_value === "") {
                  item.field_value = [];
                }
                if (
                  item.input_type === "TRUE-FALSE" &&
                  item.field_value === ""
                ) {
                  item.field_value = "F";
                }
              });
            }
          }

          this.storedialogVisible = true;
          this.loading = false;
        } else {
          Message.error(res.message);
          this.loading = false;
        }
      });
    },
    async updateStoreExtendedInfo() {
      let data = {
        tenant_id: this.$store.getters.getUser.tenant_id,
        user_id: this.$store.getters.getUser.user_id,
        retailstore_id: this.store_id,
        ExtensionArray: this.extendedInfo2_1[this.tabIndex - 1].fieldArray,
      };
      await http.post("/wapi/Retailstore/setExtendedList", data).then((res) => {
        if (res.success) {
          Message({
            type: "success",
            message: "保存成功",
          });

          this.storedialogVisible = false;
          this.isfalse = false;
          this.extendedInfo2_1[this.tabIndex - 1].fieldArray = [];
        } else {
          Message.error(res.message);
        }
      });
    },
    // 店员详情
    assistantPeople(row) {
      this.clerk_id = row.clerk_id;
      (this.clerkClass.birthday = row.birthday),
        (this.clerkClass.clerk_code = row.clerk_code),
        (this.clerkClass.clerk_id = row.clerk_id),
        (this.clerkClass.clerk_name = row.clerk_name),
        (this.clerkClass.email = row.email),
        (this.clerkClass.gender = row.gender),
        (this.clerkClass.gender_name = row.gender_name),
        (this.clerkClass.hobby = row.hobby),
        (this.clerkClass.mobile = row.mobile),
        (this.clerkClass.retailstore_id = row.retailstore_id),
        (this.clerkClass.status_name = row.status_name),
        (this.clerkClass.tenant_id = row.tenant_id);
      this.clerkClass.manager_name = row.manager_name;
      if (row.status == "ACTIVE") {
        this.clerkClass.status = true;
      } else {
        this.clerkClass.status = false;
      }

      if (row.manager == "T") {
        this.clerkClass.manager = true;
      } else {
        this.clerkClass.manager = false;
      }

      this.activeName1 = "first";
      this.getAssistantExtendedInfo();
    },
    baocun2_2() {
      if (this.activeName1 == "first") {
        this.$refs["clerkClass"].validate((valid) => {
          if (!valid) {
            return false;
          } else {
            this.updateRetailstoreClerk();
          }
        });
      } else {
        let off = true;
        if (this.extendedInfo2_2[this.tabIndex - 1].fieldArray.length > 0) {
          for (
            var i = 0;
            i < this.extendedInfo2_2[this.tabIndex - 1].fieldArray.length;
            i++
          ) {
            if (
              this.extendedInfo2_2[this.tabIndex - 1].fieldArray[i].mandatory ==
              "T"
            ) {
              this.$refs["assistantList" + i][0].validate((valid) => {
                if (!valid) {
                  off = false;
                }
              });
            }
          }
          if (off) {
            this.updateAssistantExtendedInfo();
          }
        }
      }
    },
    async updateRetailstoreClerk() {
      let status = "";
      if (this.clerkClass.status == true) {
        status = "ACTIVE";
      } else {
        status = "INACTIVE";
      }

      let manager = "";
      if (this.clerkClass.manager == true) {
        manager = "T";
      } else {
        manager = "F";
      }
      let data = {
        tenant_id: this.$store.getters.getUser.tenant_id,
        user_id: this.$store.getters.getUser.user_id,
        retailstore_id: this.retailstore_id,
        clerk_id: this.clerkClass.clerk_id,
        clerk_name: this.clerkClass.clerk_name,
        clerk_code: this.clerkClass.clerk_code,
        gender: this.clerkClass.gender,
        birthday: this.clerkClass.birthday,
        hobby: this.clerkClass.hobby,
        email: this.clerkClass.email,
        mobile: this.clerkClass.mobile,
        manager: manager,
        status: status,
      };
      //                let self = this
      await http
        .post("/wapi/Retailstore/updateRetailstoreClerk", data)
        .then((res) => {
          if (res.success) {
            this.storedialogVisible2 = false;
          } else {
            this.storedialogVisible2 = true;
            Message.error(res.message);
          }
        });
    },
    guanbi2_2() {
      this.storedialogVisible2 = false;
    },

    async getAssistantExtendedInfo() {
      this.loading = true;
      let data = {
        tenant_id: this.$store.getters.getUser.tenant_id,
        clerk_id: this.clerk_id,
      };
      await http
        .post("/wapi/Retailstore/getAssistantExtendedInfo", data)
        .then((res) => {
          if (res.success) {
            this.extendedInfo2_2 = res.data;
            console.log(this.extendedInfo2_2);
            if (this.extendedInfo2_2.length > 0) {
              for (let i = 0; i < this.extendedInfo2_2.length; i++) {
                this.extendedInfo2_2[i].fieldArray.forEach((item) => {
                  if (
                    item.input_type === "LIST" &&
                    item.multiple === "T" &&
                    item.field_value.indexOf("|") == -1 &&
                    item.field_value !== ""
                  ) {
                    item.field_value = [item.field_value];
                  }
                  if (
                    item.input_type === "LIST" &&
                    item.field_value.indexOf("|") !== -1
                  ) {
                    item.field_value = item.field_value.split("|");
                  }
                  if (
                    item.input_type === "LIST" &&
                    item.multiple === "T" &&
                    item.field_value === ""
                  ) {
                    item.field_value = [];
                  }
                  if (item.input_type === "TABLE" && item.field_value !== "") {
                    item.field_value = JSON.parse(item.field_value);
                  }
                  if (item.input_type === "TABLE" && item.field_value === "") {
                    item.field_value = [];
                  }
                  if (
                    item.input_type === "TRUE-FALSE" &&
                    item.field_value === ""
                  ) {
                    item.field_value = "F";
                  }
                });
              }
            }

            this.loading = false;
            this.storedialogVisible2 = true;
          } else {
            Message.error(res.message);
            this.loading = false;
          }
        });
    },

    async updateAssistantExtendedInfo() {
      let data = {
        tenant_id: this.$store.getters.getUser.tenant_id,
        user_id: this.$store.getters.getUser.user_id,
        retailstore_id: this.store_id,
        clerk_id: this.clerk_id,
        ExtensionArray: this.extendedInfo2_2[this.tabIndex - 1].fieldArray,
      };
      await http
        .post("/wapi/Retailstore/setAssistantExtendedList", data)
        .then((res) => {
          if (res.success) {
            Message({
              type: "success",
              message: "保存成功",
            });
            this.storedialogVisible2 = false;
            this.extendedInfo2_2[this.tabIndex - 1].fieldArray = [];
          } else {
            Message.error(res.message);
          }
        });
    },

    async getRetailstoreTypeList() {
      let data = {
        tenant_id: this.$store.getters.getUser.tenant_id,
      };

      let self = this;
      await http
        .post("/wapi/Retailstore/getRetailstoreTypeList", data)
        .then((res) => {
          if (res.success) {
            self.TypeList = res.data;
          } else {
            Message.error(res.message);
          }
        });
    },
    fangfa2(b) {
      this.storelist.retailstore_grade_name = "";
      this.getRetailstoreGardeList(b);
    },
    async getRetailstoreGardeList(b) {
      let data = {
        tenant_id: this.$store.getters.getUser.tenant_id,
        key: b,
      };

      let self = this;
      await http
        .post("/wapi/Retailstore/getRetailstoreGardeList", data)
        .then((res) => {
          if (res.success) {
            self.GardeList = res.data;
          } else {
            Message.error(res.message);
          }
        });
    },
    async getInstitution() {
      let data = {
        tenant_id: this.$store.getters.getUser.tenant_id,
        store_id: this.store_id,
      };
      await http.post("/wapi/Collect/getInstitution", data).then((res) => {
        if (res.success) {
          this.institutionList = res.data;
        } else {
          Message.error(res.message);
        }
      });
    },
    async getRetailstoreClerkList() {
      let data = {
        tenant_id: this.$store.getters.getUser.tenant_id,
        retailstore_id: this.store_id,
      };
      let self = this;
      await http
        .post("/wapi/RetailstoreClient/getRetailstoreClerkList", data)
        .then((res) => {
          if (res.success) {
            self.ClerkList = res.data;
          } else {
            Message.error(res.message);
          }
        });
    },
    async getRetailstoreInfo(id) {
      this.loading = true;
      let data = {
        tenant_id: this.$store.getters.getUser.tenant_id,
        store_id: id,
        // territory_id:territory_id,
        user_id: this.$store.getters.getUser.user_id,
      };
      let self = this;
      await http
        .post("/wapi/Retailstore/getRetailstoreInfo", data)
        .then((res) => {
          if (res.success) {
            //                        self.ClerkList=res.data
            self.storeInfoAction = res.data[0];
            this.hospitalInstitution_id = res.data[0].store_id;
            self.storelist.store_code = res.data[0].store_code;
            self.storelist.account_id = res.data[0].account_id;
            self.storelist.account_status = res.data[0].account_status;
            self.storelist.segment_name = res.data[0].segment_name;
            self.storelist.segment_id = res.data[0].segment_id;
            self.storelist.tenant_id = res.data[0].tenant_id;
            self.storelist.store_id = res.data[0].store_id;
            self.storelist.store_name = res.data[0].store_name;
            self.storelist.store_type_name = res.data[0].store_type_name;
            self.storelist.store_type = res.data[0].store_type;
            self.storelist.retailstore_grade_name =
              res.data[0].retailstore_grade_name;
            self.storelist.retailstore_grade = res.data[0].retailstore_grade;
            self.storelist.province_id = res.data[0].province_id;
            self.storelist.province_name = res.data[0].province_name;
            self.storelist.city_id = res.data[0].city_id;
            self.storelist.status = res.data[0].status;
            self.storelist.city_name = res.data[0].city_name;
            self.storelist.address = res.data[0].address;
            self.storelist.telephone = res.data[0].telephone;
            self.storelist.postcode = res.data[0].postcode;
            self.storelist.website = res.data[0].website;
            //                        self.storelist.comments=res.data[0].comments
            self.storelist.location_id = res.data[0].location_id;
            self.storelist.lat = res.data[0].lat;
            self.storelist.lng = res.data[0].lng;
            self.storelist.alias = res.data[0].alias;
            self.storelist.AccountArray = res.data[0].AccountArray;
            self.storelist.canAdd = res.data[0].canAdd;

            self.storelist.old_segment_id = res.data[0].segment_id;
            self.storelist.old_account_status = res.data[0].status;

            this.center = [res.data[0].lng, res.data[0].lat];
            if (res.data[0].province_id != "") {
              this.getCityList(res.data[0].province_id);
            }

            if (res.data[0].account_status == "ACTIVE") {
              self.storelist.account_status = true;
            } else {
              self.storelist.account_status = false;
            }

            if (res.data[0].canAdd == "F") {
              this.isDisabled = true;
            } else {
              this.isDisabled = false;
            }

            this.storelistData = res.data[0].AccountArray;

            this.loading = false;
          } else {
            Message.error(res.message);
          }
          this.loading = false;
        });
    },

    // 经销商
    disInfoClick() {
      this.isfalse = true;
      this.activeName2 = "first";
      this.getDisExtendedInfo();
      this.getDisImgInfo();
      this.getDisFilesInfo();
    },
    async getDisExtendedInfo() {
      this.loading = true;
      let data = {
        tenant_id: this.$store.getters.getUser.tenant_id,
        distributor_id: this.distributor_id,
      };
      await http.post("/wapi/Distributor/getExtendedInfo", data).then((res) => {
        if (res.success) {
          this.extendedInfo3_1 = res.data;
          if (this.extendedInfo3_1.length > 0) {
            for (let i = 0; i < this.extendedInfo3_1.length; i++) {
              this.extendedInfo3_1[i].fieldArray.forEach((item) => {
                if (
                  item.input_type === "LIST" &&
                  item.multiple === "T" &&
                  item.field_value.indexOf("|") == -1 &&
                  item.field_value !== ""
                ) {
                  item.field_value = [item.field_value];
                }
                if (
                  item.input_type === "LIST" &&
                  item.field_value.indexOf("|") !== -1
                ) {
                  item.field_value = item.field_value.split("|");
                }
                if (
                  item.input_type === "LIST" &&
                  item.multiple === "T" &&
                  item.field_value === ""
                ) {
                  item.field_value = [];
                }
                if (item.input_type === "TABLE" && item.field_value !== "") {
                  item.field_value = JSON.parse(item.field_value);
                }
                if (item.input_type === "TABLE" && item.field_value === "") {
                  item.field_value = [];
                }
                if (
                  item.input_type === "TRUE-FALSE" &&
                  item.field_value === ""
                ) {
                  item.field_value = "F";
                }
              });
            }
          }

          this.loading = false;
          this.disdialogVisible = true;
        } else {
          Message.error(res.message);
          this.loading = false;
        }
      });
    },
    async getContactExtendedInfo() {
      this.loading = true;
      let data = {
        tenant_id: this.$store.getters.getUser.tenant_id,
        contact_id: this.contact_id,
      };
      await http
        .post("/wapi/Distributor/getContactExtendedInfo", data)
        .then((res) => {
          if (res.success) {
            this.extendedInfo3_2 = res.data;
            if (this.extendedInfo3_2.length > 0) {
              for (let i = 0; i < this.extendedInfo3_2.length; i++) {
                this.extendedInfo3_2[i].fieldArray.forEach((item) => {
                  if (
                    item.input_type === "LIST" &&
                    item.multiple === "T" &&
                    item.field_value.indexOf("|") == -1 &&
                    item.field_value !== ""
                  ) {
                    item.field_value = [item.field_value];
                  }
                  if (
                    item.input_type === "LIST" &&
                    item.field_value.indexOf("|") !== -1
                  ) {
                    item.field_value = item.field_value.split("|");
                  }
                  if (
                    item.input_type === "LIST" &&
                    item.multiple === "T" &&
                    item.field_value === ""
                  ) {
                    item.field_value = [];
                  }
                  if (item.input_type === "TABLE" && item.field_value !== "") {
                    item.field_value = JSON.parse(item.field_value);
                  }
                  if (item.input_type === "TABLE" && item.field_value === "") {
                    item.field_value = [];
                  }
                  if (
                    item.input_type === "TRUE-FALSE" &&
                    item.field_value === ""
                  ) {
                    item.field_value = "F";
                  }
                });
              }
            }

            this.disdialogVisible2 = true;
            this.loading = false;
          } else {
            Message.error(res.message);
            this.loading = false;
          }
        });
    },
    async updateContactExtendedInfo() {
      let data = {
        tenant_id: this.$store.getters.getUser.tenant_id,
        user_id: this.$store.getters.getUser.user_id,
        distributor_id: this.distributor_id,
        contact_id: this.contact_id,
        ExtensionArray: this.extendedInfo3_2[this.tabIndex - 1].fieldArray,
      };
      await http
        .post("/wapi/Distributor/setContactExtendedList", data)
        .then((res) => {
          if (res.success) {
            Message({
              type: "success",
              message: "保存成功",
            });
            this.disdialogVisible2 = false;
            this.extendedInfo3_2[this.tabIndex - 1].fieldArray = [];
          } else {
            Message.error(res.message);
          }
        });
    },
    async getDisImgInfo() {
      try {
        let data = {
          tenant_id: this.$store.getters.getUser.tenant_id,
          distributor_id: this.formlist.distributor_id,
          user_id: this.$store.getters.getUser.user_id,
        };
        await http.post("/wapi/Distributor/getImgInfo", data).then((res) => {
          if (res.data) {
            this.photo_id_arr = res.data;
            this.getDisImgUrl();
          }
        });
      } catch (e) {
        return e;
      }
    },
    async getDisImgUrl() {
      try {
        this.imgArray = [];
        for (let i = 0; i < this.photo_id_arr.length; i++) {
          let obj = this.photo_id_arr[i];
          let data = {
            reference_obj: "DISTRIBUTOR",
            reference_id: "com.saasyun.android",
            credential: "0a4da4e6-e36a-4e78-b4fc-78bb62aa9ff4",
            photo_ids: obj.photo_id,
            tenant_id: this.$store.getters.getUser.tenant_id,
          };
          let res = await http.post("/photos/downloadphotos", data);

          this.imgArray.push({
            url: res.data[0].url,
            photo_id: res.data[0].photoid,
            tag: obj.tag,
          });
        }
      } catch (err) {
        console.log(`error:${err}`);
      }
    },
    async getDisFilesInfo() {
      try {
        let data = {
          tenant_id: this.$store.getters.getUser.tenant_id,
          distributor_id: this.formlist.distributor_id,
          user_id: this.$store.getters.getUser.user_id,
        };
        await http.post("/wapi/Distributor/getFilesInfo", data).then((res) => {
          if (res.success) {
            this.fileTable = res.data;
            let numObj = {
              imgNum: 0,
              slideNum: 0,
              mp4Num: 0,
              docNum: 0,
              restsNum: 0,
            };
            for (let i = 0; i < this.fileTable.length; i++) {
              let obj = this.fileTable[i];
              obj.file_name = obj.file_name.split(".")[0];
              if (obj.category == "PICTURE") {
                numObj.imgNum++;
              } else if (obj.category == "VIDEO") {
                numObj.mp4Num++;
              } else if (obj.category == "SLIDE") {
                numObj.slideNum++;
              } else if (obj.category == "DOCUMENT") {
                numObj.docNum++;
              } else {
                numObj.restsNum++;
              }
            }
            this.statistics = numObj;
          }
        });
      } catch (e) {
        return e;
      }
    },
    baocun3_1() {
      if (this.activeName2 == "first") {
        this.$refs["distributorlist"].validate((valid) => {
          if (!valid) {
            return false;
          } else {
            this.updateDistributor();
          }
        });
      } else {
        let off = true;
        if (this.extendedInfo3_1[this.tabIndex - 1].fieldArray.length > 0) {
          for (
            var i = 0;
            i < this.extendedInfo3_1[this.tabIndex - 1].fieldArray.length;
            i++
          ) {
            if (
              this.extendedInfo3_1[this.tabIndex - 1].fieldArray[i].mandatory ==
              "T"
            ) {
              this.$refs["dislist" + i][0].validate((valid) => {
                if (!valid) {
                  off = false;
                }
              });
            }
          }
          if (off) {
            this.updateDisExtendedInfo();
          }
        }
      }
    },
    async updateDistributor() {
      let status = "";
      if (this.distributorlist.status == true) {
        status = "ACTIVE";
      } else {
        status = "INACTIVE";
      }
      let status2 = "";
      if (this.distributorlist.agreement_signed == true) {
        status2 = "T";
      } else {
        status2 = "F";
      }
      let data = {
        tenant_id: this.$store.getters.getUser.tenant_id,
        distributor_id: this.distributorlist.distributor_id,
        distributor_name: this.distributorlist.distributor_name,
        distributor_code: this.distributorlist.distributor_code,
        distributor_type: this.distributorlist.distributor_type,
        distributor_grade: this.distributorlist.distributor_grade_name,
        province_id: this.distributorlist.province_id,
        city_id: this.distributorlist.city_id,
        address: this.distributorlist.address,
        telephone: this.distributorlist.telephone,
        postcode: this.distributorlist.postcode,
        website: this.distributorlist.website,
        comments: this.distributorlist.comments,
        agreement_signed: status2,
        agreement_stage: this.distributorlist.agreement_stage,
        user_id: this.$store.getters.getUser.user_id,
        status: status,
      };

      //                let self = this
      await http
        .post("/wapi/Distributor/updateDistributor", data)
        .then((res) => {
          if (res.success) {
            //                        self.GardeList=res.data

            this.disdialogVisible = false;
          } else {
            Message.error(res.message);
          }
        });
    },
    async updateDisExtendedInfo() {
      let data = {
        tenant_id: this.$store.getters.getUser.tenant_id,
        user_id: this.$store.getters.getUser.user_id,
        distributor_id: this.distributor_id,
        ExtensionArray: this.extendedInfo3_1[this.tabIndex - 1].fieldArray,
      };
      await http.post("/wapi/Distributor/setExtendedList", data).then((res) => {
        if (res.success) {
          Message({
            type: "success",
            message: "保存成功",
          });

          this.disdialogVisible = false;
          this.isfalse = false;
          this.extendedInfo3_1[this.tabIndex - 1].fieldArray = [];
        } else {
          Message.error(res.message);
        }
      });
    },
    guanbi3_1() {
      this.disdialogVisible = false;
    },
    contactDetails(row) {
      this.activeName1 = "first";
      this.contact_id = row.contact_id;
      this.getContactExtendedInfo();

      this.contactClass.department = row.department;
      this.contactClass.distributor_id = row.distributor_id;
      this.contactClass.contact_name = row.contact_name;
      this.contactClass.contact_code = row.contact_code;
      this.contactClass.gender = row.gender;
      this.contactClass.hobby = row.hobby;
      this.contactClass.job_title_name = row.job_title_name;
      this.contactClass.mobile = row.mobile;
      this.contactClass.pro_title_name = row.pro_title_name;
      this.contactClass.birthday = row.birthday;
      this.contactClass.contact_id = row.contact_id;
      this.contactClass.email = row.email;
      this.contactClass.gender_name = row.gender_name;
      this.contactClass.job_title = row.job_title;
      this.contactClass.pro_title_id = row.pro_title_id;
      this.contactClass.status_name = row.status_name;
      if (row.status == "ACTIVE") {
        this.contactClass.status = true;
      } else {
        this.contactClass.status = false;
      }
      this.contactClass.tenant_id = row.tenant_id;
    },

    async getDistributorTypeList() {
      let data = {
        tenant_id: this.$store.getters.getUser.tenant_id,
      };

      let self = this;
      await http
        .post("/wapi/Distributor/getDistributorTypeList", data)
        .then((res) => {
          if (res.success) {
            self.TypeList = res.data;
          } else {
            Message.error(res.message);
          }
        });
    },
    async getDistributorGardeList(b) {
      let data = {
        tenant_id: this.$store.getters.getUser.tenant_id,
        key: b,
      };

      let self = this;
      await http
        .post("/wapi/Distributor/getDistributorGardeList", data)
        .then((res) => {
          if (res.success) {
            self.disGardeList = res.data;
          } else {
            Message.error(res.message);
          }
        });
    },
    fangfa3_1(b) {
      this.getDistributorGardeList(b);
      this.distributorlist.distributor_grade_name = "";
      this.pushlist.distributor_grade = "";
    },
    async getDictionaryListByKOL_LEVEL3() {
      let data = {
        tenant_id: this.$store.getters.getUser.tenant_id,
        category: "DISTRIBUTOR_AGREEMENT_STAGE",
      };
      let self = this;
      await http
        .post("/wapi/v1/getDictionaryListByCategory", data)
        .then((res) => {
          if (res.success) {
            self.AGREEMENT_STAGE = res.data;
          } else {
            Message.error(res.message);
          }
        });
    },
    //客户管理-分销客户经销商详情
    async getDistributorInfo(id) {
      this.loading = true;
      let data = {
        tenant_id: this.$store.getters.getUser.tenant_id,
        distributor_id: id,
        // territory_id:territory_id,
        user_id: this.$store.getters.getUser.user_id,
      };

      let self = this;
      await http
        .post("/wapi/Distributor/getDistributorInfo", data)
        .then((res) => {
          if (res.success) {
            self.butorInfo = res.data[0];
            this.hospitalInstitution_id = res.data[0].distributor_id;
            self.distributorlist.distributor_code =
              res.data[0].distributor_code;
            self.distributorlist.distributor_name =
              res.data[0].distributor_name;
            self.distributorlist.distributor_type =
              res.data[0].distributor_type;
            self.distributorlist.distributor_grade =
              res.data[0].distributor_grade;
            self.distributorlist.province_id = res.data[0].province_id;
            self.distributorlist.city_id = res.data[0].city_name;
            self.distributorlist.account_id = res.data[0].account_id;
            self.distributorlist.account_status = res.data[0].account_status;
            self.distributorlist.segment_name = res.data[0].segment_name;
            self.distributorlist.segment_id = res.data[0].segment_id;
            self.distributorlist.tenant_id = res.data[0].tenant_id;
            self.distributorlist.distributor_id = res.data[0].distributor_id;
            self.distributorlist.distributor_type_name =
              res.data[0].distributor_type_name;
            self.distributorlist.distributor_grade_name =
              res.data[0].distributor_grade_name;
            self.distributorlist.status = res.data[0].status;
            self.distributorlist.province_name = res.data[0].province_name;
            self.distributorlist.city_name = res.data[0].city_name;
            self.distributorlist.address = res.data[0].address;
            self.distributorlist.telephone = res.data[0].telephone;
            self.distributorlist.postcode = res.data[0].postcode;
            self.distributorlist.website = res.data[0].website;
            self.distributorlist.comments = res.data[0].comments;
            self.distributorlist.location_id = res.data[0].location_id;
            self.distributorlist.lat = res.data[0].lat;
            self.distributorlist.lng = res.data[0].lng;
            self.distributorlist.alias = res.data[0].alias;
            self.distributorlist.alias = res.data[0].alias;
            self.distributorlist.AccountArray = res.data[0].AccountArray;
            self.distributorlist.canAdd = res.data[0].canAdd;

            self.distributorlist.old_segment_id = res.data[0].segment_id;
            self.distributorlist.old_account_status = res.data[0].status;

            self.distributorlist.agreement_stage = res.data[0].agreement_stage;
            if (res.data[0].agreement_signed == "T") {
              self.distributorlist.agreement_signed = true;
            } else {
              self.distributorlist.agreement_signed = false;
            }

            if (res.data[0].account_status == "ACTIVE") {
              self.distributorlist.account_status = true;
            } else {
              self.distributorlist.account_status = false;
            }

            if (res.data[0].canAdd == "F") {
              this.isDisabled = true;
            } else {
              this.isDisabled = false;
            }

            self.dislistData = res.data[0].AccountArray;

            this.center = [res.data[0].lng, res.data[0].lat];

            if (res.data[0].province_id != "") {
              this.getCityList(res.data[0].province_id);
            }
          } else {
            Message.error(res.message);
          }
          this.loading = false;
        });
    },
    async getDistributorContactList() {
      let data = {
        tenant_id: this.$store.getters.getUser.tenant_id,
        distributor_id: this.distributor_id,
      };
      let self = this;
      await http
        .post("/wapi/DistributorClient/getDistributorContactList", data)
        .then((res) => {
          if (res.success) {
            self.Contact = res.data;
          } else {
            Message.error(res.message);
          }
        });
    },
    baocun3_2() {
      if (this.activeName1 == "first") {
        this.$refs["contactClass"].validate((valid) => {
          if (!valid) {
            return false;
          } else {
            this.updateDistributorContact();
          }
        });
      } else {
        let off = true;
        if (this.extendedInfo3_2[this.tabIndex - 1].fieldArray.length > 0) {
          for (
            var i = 0;
            i < this.extendedInfo3_2[this.tabIndex - 1].fieldArray.length;
            i++
          ) {
            if (
              this.extendedInfo3_2[this.tabIndex - 1].fieldArray[i].mandatory ==
              "T"
            ) {
              this.$refs["contactList" + i][0].validate((valid) => {
                if (!valid) {
                  off = false;
                }
              });
            }
          }
          if (off) {
            this.updateContactExtendedInfo();
          }
        }
      }
    },
    async updateDistributorContact() {
      let status = "";
      if (this.contactClass.status == true) {
        status = "ACTIVE";
      } else {
        status = "INACTIVE";
      }
      let data = {
        //                    tenant_id:"2189100436",
        //                    distributor_id:this.distributor_id
        tenant_id: this.$store.getters.getUser.tenant_id,
        distributor_id: this.contactClass.distributor_id,
        contact_id: this.contactClass.contact_id,
        contact_name: this.contactClass.contact_name,
        contact_code: this.contactClass.contact_code,
        gender: this.contactClass.gender,
        birthday: this.contactClass.birthday,
        hobby: this.contactClass.hobby,
        email: this.contactClass.email,
        mobile: this.contactClass.mobile,
        status: status,
        user_id: this.$store.getters.getUser.user_id,
        job_title: this.contactClass.job_title,
        department: this.contactClass.department,
      };
      //                let self = this
      await http
        .post("/wapi/Distributor/updateDistributorContact", data)
        .then((res) => {
          if (res.success) {
            //                        self.listData=res.data

            this.disdialogVisible2 = false;
          } else {
            Message.error(res.message);
          }
        });
    },
    guanbi3_2() {
      this.disdialogVisible2 = false;
    },

    changeQUARTER(item) {
      this.QUARTER = "";
      var arr = item.split("-");
      if (arr[1] < 4) {
        this.QUARTER = arr[0] + "Q1";
      } else if (arr[1] > 3 && arr[1] < 7) {
        this.QUARTER = arr[0] + "Q2";
      } else if (arr[1] > 6 && arr[1] < 9) {
        this.QUARTER = arr[0] + "Q3";
      } else {
        this.QUARTER = arr[0] + "Q4";
      }

      console.log(item, this.QUARTER);
    },
    changeWEEK(item) {
      this.WEEK = "";
      var arr = item.split("-");
      if (arr[2] < 8) {
        this.WEEK = arr[0] + arr[1] + "W1";
      } else if (arr[2] > 7 && arr[2] < 15) {
        this.WEEK = arr[0] + arr[1] + "W2";
      } else if (arr[2] > 14 && arr[2] < 22) {
        this.WEEK = arr[0] + arr[1] + "W3";
      } else {
        this.WEEK = arr[0] + arr[1] + "W4";
      }
      console.log(item, this.WEEK);
    },
    getUuid() {
      var s = [];
      var hexDigits = "0123456789abcdef";
      for (var i = 0; i < 36; i++) {
        s[i] = hexDigits.substr(Math.floor(Math.random() * 0x10), 1);
      }
      s[14] = "4"; // bits 12-15 of the time_hi_and_version field to 0010
      s[19] = hexDigits.substr((s[19] & 0x3) | 0x8, 1); // bits 6-7 of the clock_seq_hi_and_reserved to 01
      s[8] = s[13] = s[18] = s[23] = "-";

      var uuid = s.join("");
      return uuid;
    },
    delateTableData(item) {
      for (let i = 0; i < item.field_value.length; i++) {
        if (item.addTableList.id == item.field_value[i].id) {
          item.field_value.splice(i, 1);
          item.isAddTable = false;
          this.$forceUpdate();
        }
      }
    },
    addNewTable(item) {
      this.delateFalse = false;
      console.log(item);
      item.isAddTable = true;
      item.addTableList = {
        id: "",
        dept_id: "",
        dept_name: "",
        product_id: "",
        product_name: "",
        sku_id: "",
        sku_name: "",
        info_date: "",
        date_name: "",
        field_value: "",
      };
      this.addTableList = {};
      this.addTableList = item.addTableList;
      this.$forceUpdate();
    },

    addTableData(item) {
      this.$refs["addTable1"][0].validate((valid) => {
        if (!valid) {
          return false;
        } else {
          if (this.QUARTER) {
            item.addTableList.info_date = this.QUARTER;
            let arr = this.QUARTER.split("Q");
            let year = arr[0].slice(0, 4);
            item.addTableList.date_name = `${year}年第${arr[1]}季度`;
          }
          if (this.WEEK) {
            item.addTableList.info_date = this.WEEK;
            let arr = this.WEEK.split("W");
            let year = arr[0].slice(0, 4);
            let month = arr[0].slice(4);
            item.addTableList.date_name = `${year}年${month}月第${arr[1]}周`;
          }

          if (item.addTableList.id) {
            //编辑
            for (let i = 0; i < item.field_value.length; i++) {
              if (item.addTableList.id == item.field_value[i].id) {
                item.field_value[i].dept_id = item.addTableList.dept_id;
                if (item.addTableList.dept_id) {
                  for (let j = 0; j < this.administrativeList.length; j++) {
                    if (
                      item.addTableList.dept_id ==
                      this.administrativeList[j].key
                    ) {
                      item.addTableList.dept_name = this.administrativeList[
                        j
                      ].value1;
                      break;
                    }
                  }
                }
                item.field_value[i].dept_name = item.addTableList.dept_name;
                item.field_value[i].product_id = item.addTableList.product_id;
                if (item.addTableList.product_id) {
                  for (let j = 0; j < this.productList.length; j++) {
                    if (
                      item.addTableList.product_id == this.productList[j].key
                    ) {
                      item.addTableList.product_name = this.productList[
                        j
                      ].value1;
                      break;
                    }
                  }
                }
                item.field_value[i].product_name =
                  item.addTableList.product_name;
                item.field_value[i].sku_id = item.addTableList.sku_id;
                if (item.addTableList.sku_id) {
                  for (let j = 0; j < this.SkuList.length; j++) {
                    if (item.addTableList.sku_id == this.SkuList[j].key) {
                      item.addTableList.sku_name = this.SkuList[j].value1;
                      break;
                    }
                  }
                }
                item.field_value[i].sku_name = item.addTableList.sku_name;
                item.field_value[i].info_date = item.addTableList.info_date;
                item.field_value[i].date_name = item.addTableList.date_name;
                item.field_value[i].field_value = item.addTableList.field_value;
              }
            }
          } else {
            //新增
            item.addTableList.id = this.getUuid();
            if (item.addTableList.dept_id) {
              for (let i = 0; i < this.administrativeList.length; i++) {
                if (
                  item.addTableList.dept_id == this.administrativeList[i].key
                ) {
                  item.addTableList.dept_name = this.administrativeList[
                    i
                  ].value1;
                }
              }
            }
            if (item.addTableList.product_id) {
              for (let i = 0; i < this.productList.length; i++) {
                if (item.addTableList.product_id == this.productList[i].key) {
                  item.addTableList.product_name = this.productList[i].value1;
                }
              }
            }
            if (item.addTableList.sku_id) {
              for (let i = 0; i < this.SkuList.length; i++) {
                if (item.addTableList.sku_id == this.SkuList[i].key) {
                  item.addTableList.sku_name = this.SkuList[i].value1;
                }
              }
            }
            if (this.QUARTER) {
              item.addTableList.info_date = this.QUARTER;
              let arr = this.QUARTER.split("Q");
              let year = arr[0].slice(0, 4);
              item.addTableList.date_name = `${year}年第${arr[1]}季度`;
            } else if (this.WEEK) {
              item.addTableList.info_date = this.WEEK;
              let arr = this.WEEK.split("W");
              let year = arr[0].slice(0, 4);
              let month = arr[0].slice(4);
              item.addTableList.date_name = `${year}年${month}月第${arr[1]}周`;
            } else {
              item.addTableList.date_name = item.addTableList.info_date;
            }
            item.field_value.push(item.addTableList);
          }

          item.isAddTable = false;
          item.addTableList = {
            id: "",
            dept_id: "",
            dept_name: "",
            product_id: "",
            product_name: "",
            sku_id: "",
            sku_name: "",
            info_date: "",
            date_name: "",
            field_value: "",
          };
          this.$forceUpdate();
        }
      });
    },

    addTableDataHcp(item) {
      this.$refs["addTableHcp"][0].validate((valid) => {
        if (!valid) {
          return false;
        } else {
          if (this.QUARTER) {
            item.addTableList.info_date = this.QUARTER;
            let arr = this.QUARTER.split("Q");
            let year = arr[0].slice(0, 4);
            item.addTableList.date_name = `${year}年第${arr[1]}季度`;
          }
          if (this.WEEK) {
            item.addTableList.info_date = this.WEEK;
            let arr = this.WEEK.split("W");
            let year = arr[0].slice(0, 4);
            let month = arr[0].slice(4);
            item.addTableList.date_name = `${year}年${month}月第${arr[1]}周`;
          }

          if (item.addTableList.id) {
            //编辑
            for (let i = 0; i < item.field_value.length; i++) {
              if (item.addTableList.id == item.field_value[i].id) {
                item.field_value[i].dept_id = item.addTableList.dept_id;
                if (item.addTableList.dept_id) {
                  for (let j = 0; j < this.administrativeList.length; j++) {
                    if (
                      item.addTableList.dept_id ==
                      this.administrativeList[j].key
                    ) {
                      item.addTableList.dept_name = this.administrativeList[
                        j
                      ].value1;
                      break;
                    }
                  }
                }
                item.field_value[i].dept_name = item.addTableList.dept_name;
                item.field_value[i].product_id = item.addTableList.product_id;
                if (item.addTableList.product_id) {
                  for (let j = 0; j < this.productList.length; j++) {
                    if (
                      item.addTableList.product_id == this.productList[j].key
                    ) {
                      item.addTableList.product_name = this.productList[
                        j
                      ].value1;
                      break;
                    }
                  }
                }
                item.field_value[i].product_name =
                  item.addTableList.product_name;
                item.field_value[i].sku_id = item.addTableList.sku_id;
                if (item.addTableList.sku_id) {
                  for (let j = 0; j < this.SkuList.length; j++) {
                    if (item.addTableList.sku_id == this.SkuList[j].key) {
                      item.addTableList.sku_name = this.SkuList[j].value1;
                      break;
                    }
                  }
                }
                item.field_value[i].sku_name = item.addTableList.sku_name;
                item.field_value[i].info_date = item.addTableList.info_date;
                item.field_value[i].date_name = item.addTableList.date_name;
                item.field_value[i].field_value = item.addTableList.field_value;
              }
            }
          } else {
            //新增
            item.addTableList.id = this.getUuid();
            if (item.addTableList.dept_id) {
              for (let i = 0; i < this.administrativeList.length; i++) {
                if (
                  item.addTableList.dept_id == this.administrativeList[i].key
                ) {
                  item.addTableList.dept_name = this.administrativeList[
                    i
                  ].value1;
                }
              }
            }
            if (item.addTableList.product_id) {
              for (let i = 0; i < this.productList.length; i++) {
                if (item.addTableList.product_id == this.productList[i].key) {
                  item.addTableList.product_name = this.productList[i].value1;
                }
              }
            }
            if (item.addTableList.sku_id) {
              for (let i = 0; i < this.SkuList.length; i++) {
                if (item.addTableList.sku_id == this.SkuList[i].key) {
                  item.addTableList.sku_name = this.SkuList[i].value1;
                }
              }
            }
            if (this.QUARTER) {
              item.addTableList.info_date = this.QUARTER;
              let arr = this.QUARTER.split("Q");
              let year = arr[0].slice(0, 4);
              item.addTableList.date_name = `${year}年第${arr[1]}季度`;
            } else if (this.WEEK) {
              item.addTableList.info_date = this.WEEK;
              let arr = this.WEEK.split("W");
              let year = arr[0].slice(0, 4);
              let month = arr[0].slice(4);
              item.addTableList.date_name = `${year}年${month}月第${arr[1]}周`;
            } else {
              item.addTableList.date_name = item.addTableList.info_date;
            }
            item.field_value.push(item.addTableList);
          }

          item.isAddTable = false;
          item.addTableList = {
            id: "",
            dept_id: "",
            dept_name: "",
            product_id: "",
            product_name: "",
            sku_id: "",
            sku_name: "",
            info_date: "",
            date_name: "",
            field_value: "",
          };
          this.$forceUpdate();
        }
      });
    },

    cancelTableData(item) {
      item.isAddTable = false;
      item.addTableList = {
        id: "",
        dept_id: "",
        dept_name: "",
        product_id: "",
        product_name: "",
        sku_id: "",
        sku_name: "",
        info_date: "",
        date_name: "",
        field_value: "",
      };
      this.$forceUpdate();
    },
    parentEvent(data) {
      this.addTableList.info_date = data;
    },
    getQuarterValue(a, b) {
      this.QUARTER = a + "Q" + b;
    },
    getWeekValue(a, b, c) {
      let month = b.toString();
      this.WEEK = a + month + "W" + c;
      console.log(this.WEEK);
    },
    parentWeekEvent(data) {
      this.addTableList.info_date = data;
    },
    handleTableClick(index, row, item) {
      this.delateFalse = true;
      item.isAddTable = true;
      this.getSkuList(row.product_id);
      item.addTableList = {
        id: row.id,
        dept_id: row.dept_id,
        dept_name: row.dept_name,
        product_id: row.product_id,
        product_name: row.product_name,
        sku_id: row.sku_id,
        sku_name: row.sku_name,
        info_date: row.info_date,
        date_name: row.date_name,
        field_value: row.field_value,
      };
      this.$forceUpdate();
    },

    fangfa3(val) {
      let obj = {};
      for (let i = 0; i < this.administrative.length; i++) {
        obj = this.administrative[i];
        if (val == obj.key) {
          this.HcpAdd.department = obj.value1;
          this.selectDeptId = obj.dept_id;
          return;
        }
      }
    },

    xiazai() {
      this.deriveInstitution();
    },
    xiazai2() {
      this.deriveHcp();
    },
    xiazai3() {
      let data = {
        tenant_id: this.$store.getters.getUser.tenant_id,
        province_id: this.form.position,
        reference_obj: "INSTITUTION",
      };
      let self = this;
      self.loading = true;
      http
        .post("/wapi/derive/deriveCoordinates", data)
        .then((res) => {
          self.coordinatesList = res;
          this.handleExportData7();
        })
        .catch((err) => {
          Message({
            type: "error",
            message: "下载失败",
          });
        });
      self.loading = false;
    },
    async deriveHcp() {
      this.loading = true;

      let data = {
        tenant_id: this.$store.getters.getUser.tenant_id,
        province_id: this.form.title,
      };
      let self = this;
      await http
        .post("/wapi/derive/deriveHcp", data)
        .then((res) => {
          //self.deriveHcpList=res
          for (var i = 0; i < res.length; i++) {
            this.handleExportData4(res[i], i, res.length);
          }
        })
        .catch((err) => {
          Message({
            type: "error",
            message: "下载失败",
          });
        });
      this.loading = false;
    },
    async deriveInstitution() {
      this.loading = true;

      let data = {
        tenant_id: this.$store.getters.getUser.tenant_id,
        province_id: this.form.name,
      };
      let self = this;
      await http
        .post("/wapi/derive/deriveInstitution", data)
        .then((res) => {
          self.Institution = res;
          this.handleExportData1();
        })
        .catch((err) => {
          Message({
            type: "error",
            message: "下载失败",
          });
        });
      this.loading = false;
    },
    handleExportData4(arr, i, count) {
      try {
        const loading = this.$loading({
          lock: true,
          text: "拼命加载中",
          spinner: "el-icon-loading",
          background: "rgba(0, 0, 0, 0.7)",
        });
        //                    this.deriveHcpList=[]
        import("@/vendor/Export2Excel").then((excel) => {
          const tHeader = [
            "机构编码",
            "机构名称",
            "客户编码",
            "客户姓名",
            "标准科室编码",
            "标准科室名称",
            "所属科室/部门",
            "性别",
            "职务",
            "职称",
            "联系电话",
            "电子邮件",
            "生日",
            "爱好",
            "主治病症",
            "门诊时间",
            "毕业院校",
            "担任协会职务",
            "是否专家讲者",
            "讲者级别",
            "是否KOL",
            "KOL级别",
          ];
          const filterVal = [
            "institution_code",
            "institution_name",
            "hcp_code",
            "hcp_name",
            "standard_code",
            "standard_dept",
            "dept_name",
            "gender",
            "job_title",
            "pro_title",
            "phone",
            "email",
            "birthday",
            "hobby",
            "specialties",
            "consulting_hours",
            "education",
            "fellowships",
            "speaker",
            "speaker_level",
            "kol",
            "kol_level",
          ];

          const list = arr; //this.deriveHcpList
          const data = this.formatJson(filterVal, list);
          excel.export_json_to_excel({
            header: tHeader,
            data,
            filename:
              count == 1
                ? this.institutionData_hcp
                : this.institutionData_hcp + "(" + (i + 1) + ")",
            autoWidth: this.autoWidth,
          });
        });
        loading.close();
      } catch (err) {
        loading.close();
        this.error();
      }
    },
    handleExportData1() {
      const loading = this.$loading({
        lock: true,
        text: "拼命加载中",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      });
      try {
        //                    this.Institution=[]
        import("@/vendor/Export2Excel").then((excel) => {
          const tHeader = [
            "机构编码",
            "机构名称",
            "类型",
            "级别",
            "省份",
            "城市",
            "地址",
            "联系电话",
            "邮政编码",
            "官方网址",
            "所属经销商",
          ];
          const filterVal = [
            "institution_code",
            "institution_name",
            "institution_type",
            "institution_grade",
            "province_name",
            "city_name",
            "address",
            "telephone",
            "postcode",
            "website",
            "distributor_name",
          ];
          const list = this.Institution;
          const data = this.formatJson(filterVal, list);

          excel.export_json_to_excel({
            header: tHeader,
            data,
            filename: this.institutionData_name,
            autoWidth: this.autoWidth,
          });
        });
        loading.close();
      } catch (err) {
        loading.close();
        this.error();
      }
    },
    handleExportData3() {
      try {
        const loading = this.$loading({
          lock: true,
          text: "拼命加载中",
          spinner: "el-icon-loading",
          background: "rgba(0, 0, 0, 0.7)",
        });
        //                    this.Institution=[]
        import("@/vendor/Export2Excel").then((excel) => {
          const tHeader = [
            "机构编码",
            "机构名称",
            "标准科室编码",
            "级别",
            "标准科室名称",
            "所属科室/部门",
            "报错信息",
          ];
          const filterVal = [
            "institution_code",
            "institution_name",
            "standard_dept",
            "standard_dept_name",
            "dept_name",
            "message",
          ];
          let arr = [...this.arr3];
          for (let i = 0; i < arr.length; i++) {
            let obj = arr[i].message.join(" ");
            arr[i].message = obj;
          }

          const list = arr;
          const data = this.formatJson(filterVal, list);

          excel.export_json_to_excel({
            header: tHeader,
            data,
            filename: "报错信息表",
            autoWidth: this.autoWidth,
          });
        });
        loading.close();
        this.showModal4 = false;
      } catch (err) {
        this.loading = false;
        this.error();
      }
    },
    handleExportData2() {
      try {
        import("@/vendor/Export2Excel").then((excel) => {
          const tHeader = [
            "机构编码",
            "机构名称",
            "客户编码",
            "客户姓名",
            "科室编码",
            "所属科室/部门",
            "性别",
            "职务",
            "职称",
            "联系电话",
            "电子邮件",
            "生日",
            "爱好",
            "主治病症",
            "门诊时间",
            "毕业院校",
            "担任协会职务",
            "是否专家讲者",
            "讲者级别",
            "是否KOL",
            "KOL级别",
            "报错信息",
          ];
          const filterVal = [
            "institution_code",
            "institution_name",
            "hcp_code",
            "hcp_name",
            "dept_code",
            "dept_name",
            "gender",
            "jop_title",
            "pro_title",
            "phone",
            "email",
            "birthday",
            "hobby",
            "specialties",
            "consulting_hours",
            "education",
            "fellowships",
            "speaker",
            "speaker_level",
            "kol",
            "kol_level",
            "message",
          ];
          let arr = [...this.arr2];
          for (var i = 0; i < arr.length; i++) {
            let obj = arr[i].message.join(" ");
            arr[i].message = obj;
          }

          const list = arr;
          const data = this.formatJson(filterVal, list);

          excel.export_json_to_excel({
            header: tHeader,
            data,
            filename: "报错信息表",
            autoWidth: this.autoWidth,
          });
        });
        this.loading = false;
        this.showModal3 = false;
      } catch (err) {
        this.loading = false;
        this.error();
      }
    },
    handleExportData() {
      try {
        import("@/vendor/Export2Excel").then((excel) => {
          const tHeader = [
            "机构编码",
            "机构名称",
            "类别",
            "级别",
            "省份",
            "城市",
            "地址",
            "联系电话",
            "邮政编码",
            "官方网址",
            "备注",
            "报错信息",
          ];
          const filterVal = [
            "institution_code",
            "institution_name",
            "institution_type",
            "institution_grade",
            "province_id",
            "city_id",
            "address",
            "telephone",
            "postcode",
            "website",
            "comments",
            "message",
          ];
          let arr = [...this.arr];
          for (var i = 0; i < arr.length; i++) {
            let obj = arr[i].message.join(" ");
            arr[i].message = obj;
          }

          const list = arr;
          const data = this.formatJson(filterVal, list);

          excel.export_json_to_excel({
            header: tHeader,
            data,
            filename: "报错信息表",
            autoWidth: this.autoWidth,
          });
        });
        this.loading = false;
        this.showModal2 = false;
      } catch (err) {
        this.loading = false;
        this.error();
      }
    },
    handleExportData5() {
      try {
        import("@/vendor/Export2Excel").then((excel) => {
          const tHeader = [
            "年月",
            "辖区编码",
            "辖区名称",
            "代表工号",
            "代表姓名",
            "目标客户编码",
            "目标客户姓名",
            "客户级别",
            "报错信息",
          ];
          const filterVal = [
            "yyyyMM",
            "territory_code",
            "territory_name",
            "user_code",
            "user_name",
            "hcp_code",
            "hcp_name",
            "segment_id",
            "message",
          ];
          let arr = [...this.arr3];
          for (var i = 0; i < arr.length; i++) {
            let obj = arr[i].message.join(" ");
            arr[i].message = obj;
          }

          const list = arr;
          const data = this.formatJson(filterVal, list);

          excel.export_json_to_excel({
            header: tHeader,
            data,
            filename: "报错信息表",
            autoWidth: this.autoWidth,
          });
        });
        this.loading = false;
        this.showModal4 = false;
      } catch (err) {
        this.loading = false;
        this.error();
      }
    },
    handleExportData6() {
      try {
        import("@/vendor/Export2Excel").then((excel) => {
          const tHeader = [
            "机构编码",
            "机构名称",
            "地址",
            "经度",
            "纬度",
            "报错信息",
          ];
          const filterVal = [
            "code",
            "institutions_name",
            "address",
            "longitude",
            "latitude",
            "message",
          ];
          let arr = [...this.locationDate];

          const list = arr;
          const data = this.formatJson(filterVal, list);

          excel.export_json_to_excel({
            header: tHeader,
            data,
            filename: "报错信息表",
            autoWidth: this.autoWidth,
          });
        });
        this.loading = false;
        this.showModal4 = false;
      } catch (err) {
        this.loading = false;
        this.error();
      }
    },
    handleExportData7() {
      try {
        const loading = this.$loading({
          lock: true,
          text: "拼命加载中",
          spinner: "el-icon-loading",
          background: "rgba(0, 0, 0, 0.7)",
        });
        //                    this.deriveHcpList=[]
        import("@/vendor/Export2Excel").then((excel) => {
          const tHeader = ["机构编码", "机构名称", "地址", "经度", "纬度"];
          const filterVal = [
            "institution_code",
            "institution_name",
            "address",
            "longitude",
            "latitude",
          ];

          const list = this.coordinatesList;
          const data = this.formatJson(filterVal, list);
          excel.export_json_to_excel({
            header: tHeader,
            data,
            filename: this.institutionData_location,
            autoWidth: this.autoWidth,
          });
        });
        loading.close();
      } catch (err) {
        loading.close();
        this.error();
      }
    },
    formatJson(filterVal, jsonData) {
      return jsonData.map((v) => filterVal.map((j) => v[j]));
    },

    closeModal2() {
      this.fileList = [];
      this.fileList2 = [];
      this.fileList3 = [];
      this.fileList4 = [];
      this.isUpload = false;
      this.isUpload2 = false;
      this.isUpload3 = false;
      this.isUpload4 = false;
      this.dialogVisible = false;
    },
    handleChange(file, fileList) {
      this.file = file.name;
      const nameArr = file.name.split(".");
      const extension = nameArr[nameArr.length - 1] === "xlsx";
      const isLt2M = file.size / 1024 / 1024 < 10;
      if (!extension) {
        this.file = "";
        this.fileList = [];
        Message({
          showClose: true,
          message: "上传模板只能是xlsx",
          type: "error",
        });
      }
      if (!isLt2M) {
        this.file = "";
        this.fileList = [];
        Message({
          showClose: true,
          message: "传模板大小不能超过 10MB",
          type: "error",
        });
      }
      this.isUpload = true;

      return extension && isLt2M;
    },
    handleChange2(file, fileList) {
      this.file3 = file.name;
      const nameArr = file.name.split(".");
      const extension = nameArr[nameArr.length - 1] === "xlsx";
      const isLt2M = file.size / 1024 / 1024 < 10;
      if (!extension) {
        this.file = "";
        this.fileList2 = [];
        Message({
          showClose: true,
          message: "上传模板只能是xlsx",
          type: "error",
        });
      }
      if (!isLt2M) {
        this.file = "";
        this.fileList2 = [];
        Message({
          showClose: true,
          message: "传模板大小不能超过 10MB",
          type: "error",
        });
      }
      this.isUpload2 = true;

      return extension && isLt2M;
    },

    handleChange3(file, fileList) {
      this.file = file.name;
      const nameArr = file.name.split(".");
      const extension = nameArr[nameArr.length - 1] === "xlsx";
      const isLt2M = file.size / 1024 / 1024 < 10;
      if (!extension) {
        this.file = "";
        this.fileList3 = [];
        Message({
          showClose: true,
          message: "上传模板只能是xlsx",
          type: "error",
        });
      }
      if (!isLt2M) {
        this.file = "";
        this.fileList3 = [];
        Message({
          showClose: true,
          message: "传模板大小不能超过 10MB",
          type: "error",
        });
      }
      this.isUpload3 = true;

      return extension && isLt2M;
    },
    handleChange4(file, fileList) {
      this.file2 = file.name;
      const nameArr = file.name.split(".");
      const extension = nameArr[nameArr.length - 1] === "xlsx";
      const isLt2M = file.size / 1024 / 1024 < 10;
      if (!extension) {
        this.file = "";
        this.fileList4 = [];
        Message({
          showClose: true,
          message: "上传模板只能是xlsx",
          type: "error",
        });
      }
      if (!isLt2M) {
        this.file = "";
        this.fileList4 = [];
        Message({
          showClose: true,
          message: "传模板大小不能超过 10MB",
          type: "error",
        });
      }
      this.isUpload4 = true;

      return extension && isLt2M;
    },
    async handleSuccess(res, file) {
      const loading = this.$loading({
        lock: true,
        text: "拼命加载中",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      });
      if (res.success) {
        try {
          //                        var user = this.$store.getters.getUser

          let data = {
            user_id: this.$store.getters.getUser.user_id,
            tenant_id: this.$store.getters.getUser.tenant_id,
            path: res.data,
          };

          await http.post("/wapi/excel/imortInstitution", data).then((res) => {
            loading.close();
            if (res.success) {
              this.closeModal2();
              console.log(res.data, 3286);

              if (res.data.length == 0) {
                Message({
                  type: "success",
                  message: "导入成功",
                });
              } else {
                this.showModal2 = true;
                this.Mechanism = [...res.data];
                this.arr = [...res.data];
              }
            } else {
              this.fileList = [];

              Message({
                type: "error",
                message: "导入失败",
              });
            }

            this.loading = false;
          });
        } catch (err) {
          loading.close();
          Message.error("导入失败！");
        }
      } else {
        loading.close();
        Message.error("导入失败！");
      }
    },
    async handleSuccess2(res, file) {
      const loading = this.$loading({
        lock: true,
        text: "拼命加载中",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      });
      if (res.success) {
        try {
          //                        var user = this.$store.getters.getUser

          let data = {
            user_id: this.$store.getters.getUser.user_id,
            tenant_id: this.$store.getters.getUser.tenant_id,
            path: res.data,
          };

          await http.post("/wapi/excel/imortHcp", data).then((res) => {
            loading.close();
            console.log(res);
            if (res.success) {
              this.closeModal2();
              if (res.message == "导入成功") {
                if (res.data.length > 0) {
                  this.showModal3 = true;
                  this.Mechanism2 = [...res.data];
                  this.arr2 = [...res.data];
                } else {
                  Message({
                    type: "success",
                    message: "导入成功",
                  });
                }
              } else {
                this.fileList2 = [];
                Message({
                  type: "error",
                  message: res.message,
                });
              }

              // if(res.data.length>0){
              //
              //
              // }else {
              //     Message({
              //         type: 'success',
              //         message: '导入成功'
              //     })
              //
              // }
            } else {
            }

            this.loading = false;
          });
        } catch (err) {
          loading.close();
          Message.error("导入失败！");
        }
      } else {
        loading.close();
        Message.error("导入失败！");
      }
    },
    async handleSuccess3(res, file) {
      const loading = this.$loading({
        lock: true,
        text: "拼命加载中",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      });
      if (res.success) {
        try {
          //                        var user = this.$store.getters.getUser

          let data = {
            user_id: this.$store.getters.getUser.user_id,
            tenant_id: this.$store.getters.getUser.tenant_id,
            path: res.data,
          };

          await http
            .post("/wapi/excel/imortInstitutionDept", data)
            .then((res) => {
              loading.close();
              if (res.success) {
                this.closeModal2();
                if (res.data.length == 0) {
                  Message({
                    type: "success",
                    message: "导入成功",
                  });
                } else {
                  this.showModal4 = true;
                  this.Mechanism3 = [...res.data];
                  this.arr3 = [...res.data];
                }
              } else {
                this.fileList3 = [];

                Message({
                  type: "error",
                  message: "导入失败",
                });
              }

              this.loading = false;
            });
        } catch (err) {
          loading.close();
          Message.error("导入失败！");
        }
      } else {
        loading.close();
        Message.error("导入失败！");
      }
    },
    async handleSuccess4(res, file) {
      const loading = this.$loading({
        lock: true,
        text: "拼命加载中",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      });
      if (res.success) {
        try {
          //                        var user = this.$store.getters.getUser

          let data = {
            user_id: this.$store.getters.getUser.user_id,
            tenant_id: this.$store.getters.getUser.tenant_id,
            path: res.data,
          };

          await http.post("/wapi/excel/loaction", data).then((res) => {
            loading.close();
            if (res.success) {
              if (res.data) {
                let onOff = true;
                let array = [];
                for (let i = 0; i < res.data.length; i++) {
                  if (res.data[i].success === false) {
                    onOff = false;
                    array.push(res.data[i]);
                  }
                }
                if (onOff === false) {
                  this.fileList4 = [];
                  this.dialogLoaction = true;
                  this.locationDate = array;
                  return;
                } else {
                  this.closeModal2();
                  if (res.data.success > 0) {
                    Message({
                      type: "success",
                      message: "导入成功",
                    });
                  } else {
                    this.showModal5 = false;
                    this.Mechanism4 = [...res.data];
                    this.arr4 = [...res.data];
                  }
                }
              } else {
                this.fileList4 = [];

                Message({
                  type: "error",
                  message: res.message,
                });
              }
            } else {
              this.fileList4 = [];

              Message({
                type: "error",
                message: "导入失败",
              });
            }

            this.loading = false;
          });
        } catch (err) {
          loading.close();
          Message.error("导入失败！");
        }
      } else {
        loading.close();
        Message.error("导入失败！");
      }
    },
    imortDataClick() {
      if (this.isUpload) {
        this.$refs.upload.submit();
      } else {
        Message({
          showClose: true,
          message: "导入模板不能为空",
          type: "error",
        });
      }
    },
    imortDataClick2() {
      if (this.isUpload2) {
        this.$refs.upload2.submit();
      } else {
        Message({
          showClose: true,
          message: "导入模板不能为空",
          type: "error",
        });
      }
    },
    imortDataClick3() {
      if (this.isUpload3) {
        this.$refs.upload3.submit();
      } else {
        Message({
          showClose: true,
          message: "导入模板不能为空",
          type: "error",
        });
      }
    },
    imortDataClick4() {
      if (this.isUpload4) {
        this.$refs.upload4.submit();
      } else {
        Message({
          showClose: true,
          message: "导入模板不能为空",
          type: "error",
        });
      }
    },
    showModalAction() {
      this.file = "";
      (this.file2 = ""), (this.file3 = "");
      this.fileList = [];
      this.dialogVisible = true;
      this.form = {
        name: "",
        position: "",
        title: "",
      };
      if (this.form.name == "") {
        this.institutionData_name = "机构数据（全部省份）";
      }
      if (this.form.position == "") {
        this.institutionData_location = "签到数据（全部省份）";
      }
      if (this.form.title == "") {
        this.institutionData_hcp = "HCP数据（全部省份）";
      }
    },
    async search(queryString, cb) {
      if (queryString) {
        try {
          let data = {
            tenant_id: this.$store.getters.getUser.tenant_id,
            search: queryString.trim(),
          };

          await http
            .post("/wapi/Institution/searchInstitutionList1", data)
            .then((res) => {
              if (res.success) {
                cb(res.data);
              } else {
                Message.error(res.message);
              }
            });
        } catch (err) {
          console.log(`error:${err}`);
        }
      } else {
        cb([]);
      }
    },

    async getInstitutionInfoAction() {
      this.index = "";

      let data = {
        tenant_id: this.$store.getters.getUser.tenant_id,
        institution_id: this.institution_id,
      };

      let self = this;
      await http
        .post("/wapi/Institution/getInstitutionInfo", data)
        .then((res) => {
          if (res.success) {
            self.institutionObj.institution_name = res.data[0].institution_name;
            self.institutionObj.address = res.data[0].address;
            self.institutionObj.city_id = res.data[0].city_id;
            self.institutionObj.city_name = res.data[0].city_name;
            self.institutionObj.institution_type_name =
              res.data[0].institution_type_name;
            self.institutionObj.institution_type = res.data[0].institution_type;
            self.institutionObj.telephone = res.data[0].telephone;
            self.institutionObj.website = res.data[0].website;
            self.institutionObj.institution_grade =
              res.data[0].institution_grade;
            self.institutionObj.institution_grade_name =
              res.data[0].institution_grade_name;
            self.institutionObj.province_id = res.data[0].province_id;
            self.institutionObj.province_name = res.data[0].province_name;
            self.institutionObj.status = res.data[0].status;
            self.institutionObj.postcode = res.data[0].postcode;
            self.institutionObj.lat = res.data[0].lat;
            self.institutionObj.lng = res.data[0].lng;
            self.institutionObj.location_id = res.data[0].location_id;
            self.institutionObj.institution_id = res.data[0].institution_id;
            self.institutionObj.institution_code = res.data[0].institution_code;
            this.hospitalInstitution_id = res.data[0].institution_id;

            self.insList.address = res.data[0].address;
            self.insList.distributor_id = res.data[0].distributor_id;
            self.insList.city_id = res.data[0].city_id;
            self.insList.city_name = res.data[0].city_name;
            self.insList.comments = res.data[0].comments;
            self.insList.institution_grade = res.data[0].institution_grade;
            self.insList.institution_grade_name =
              res.data[0].institution_grade_name;
            self.insList.institution_id = res.data[0].institution_id;
            self.insList.institution_name = res.data[0].institution_name;
            self.insList.institution_type = res.data[0].institution_type;
            self.insList.institution_type_name =
              res.data[0].institution_type_name;
            self.insList.lat = res.data[0].lat;
            self.insList.lng = res.data[0].lng;
            self.insList.location_id = res.data[0].location_id;
            self.insList.postcode = res.data[0].postcode;
            self.insList.province_id = res.data[0].province_id;
            self.insList.province_name = res.data[0].province_name;
            self.insList.telephone = res.data[0].telephone;
            self.insList.website = res.data[0].website;
            self.insList.agreement_stage = res.data[0].agreement_stage;
            self.insList.institution_code = res.data[0].institution_code;

            self.institution_name = res.data[0].institution_name;
            self.address = res.data[0].address;
            self.location_id = res.data[0].location_id;

            // this.center=[res.data[0].lng,res.data[0].lat]

            if (res.data[0].agreement_signed == "T") {
              self.insList.agreement_signed = true;
            } else {
              self.insList.agreement_signed = false;
            }

            if (res.data[0].status == "ACTIVE") {
              self.insList.status = true;
            } else {
              self.insList.status = false;
            }

            if (self.institutionObj.status == "ACTIVE") {
              self.institutionStatus = true;
            } else {
              self.institutionStatus = false;
            }

            //                        self.insList.province_id = res.data[0].province_id
            //                        self.insList.city_id = res.data[0].city_id

            let xiabiaoshenfen = 0;
            let xiabiaochengshi = 0;

            for (var i = 0; i < this.data.length; i++) {
              let obj = this.data[i];
              if (obj.id == res.data[0].province_id) {
                this.province_id = obj.id;
                xiabiaoshenfen = i;
                for (var j = 0; j < obj.children.length; j++) {
                  let obj2 = obj.children[j];
                  if (obj2.id == res.data[0].city_id) {
                    this.city_id = obj2.id;

                    xiabiaochengshi = j;
                  }
                }
              }
            }

            this.$nextTick(() => {
              // treeBox 元素的ref value 绑定的node-key
              this.$refs.tree.setCurrentKey(this.city_id);
              this.getEtmsInstituionListAction();
              //
            });
          } else {
            Message.error(res.message);
          }
        });
    },

    async getEtmsInstituionListAction() {
      this.loading = true;
      this.markerRefs = [];
      // console.log(this.cluster)
      infoWindow && infoWindow.close();
      this.cluster && this.cluster.clearMarkers();
      // this.centers=[]
      let data = {
        tenant_id: this.$store.getters.getUser.tenant_id,
        scope: this.scope,
        province_id: this.province_id,
        city_id: this.city_id,
      };
      this.loadArr = [];
      this.data2 = [];
      let self = this;
      await http
        .post("/wapi/Institution/getCustomerList", data)
        .then(async (res) => {
          this.loading = false;
          if (res.success) {
            // if (data.scope !== "All") {
            //   self.data2 = res.data;
            // } else {
            self.loadArr = res.data;
            self.data2 = res.data.slice(0, 50);
            
            // }

            this.batchesLoad(res.data, 100000, 1000);
          } else {
            Message.error(res.message);
          }
        });
    },
    //分批载入
    batchesLoad(data, limit, frequency) {
      if (!this.page && this.page !== 0) {
        this.page = 0;
      }
      let markerRefs = [];
      data
        .slice(this.page * limit, (this.page + 1) * limit)
        .forEach((v, index) => {
          if (v.lng >= 0 && v.lat >= 0) {
            let marker = new AMap.Marker({
              position: [v.lng, v.lat],
              // icon: imgUrl,
              content: `<i style="display: inline-block;width: 22px;height: 30px;text-align:center;font-size:12px;line-height:22px;color:#fff;background: url(${imgUrl})">${v.count}</i>`,
              extData: {
                id: v.id,
                type: (v.type === "store"
                  ? "retailstore"
                  : v.type
                ).toLocaleUpperCase(),
                self: this,
              },
            });
            marker.on("click", this.getMapInfo);
            data[this.page * limit + index].marker = marker
            markerRefs.push(marker);
          }
        });
      this.cluster && this.cluster.addMarkers(markerRefs);
      markerRefs = null;
      this.page++;
      if (this.page * limit < data.length) {
        setTimeout(() => {
          this.batchesLoad(data, limit);
        }, frequency);
      } else {
        this.page = 0;
      }
    },

    createInfoWindow(title, content, data) {
      let info = document.createElement("div");
      info.className = "custom-info input-card content-window-card";

      //可以通过下面的方式修改自定义窗体的宽高
      info.style.width = "400px";
      // 定义顶部标题
      let top = document.createElement("div");
      let titleD = document.createElement("div");
      // let closeX = document.createElement("img");
      let details = document.createElement("span");
      top.className = "info-top";
      titleD.innerHTML = title;
      titleD.title = title;
      details.innerHTML = "查看详情";
      details.CustomData = data;
      // details.onclick = this.details(data);
      details.addEventListener("click", this.details);

      top.appendChild(titleD);
      top.appendChild(details);
      info.appendChild(top);

      // 定义中部内容
      let middle = document.createElement("div");
      let address = document.createElement("p");
      let targetNum = document.createElement("p");
      middle.className = "info-middle";
      address.className = "address";
      targetNum.className = "target-num";
      middle.style.backgroundColor = "white";
      address.innerHTML = content.address || "无";
      switch (data.category) {
        case "INSTITUTION":
          targetNum.innerHTML = `医务人员总数：<span>${
            content.target_num || 0
          }</span>`;
          break;
        case "RETAILSTORE":
          targetNum.innerHTML = `店员总数：<span>${
            content.target_num || 0
          }</span>`;
          break;
        case "DISTRIBUTOR":
          targetNum.innerHTML = `联系人总数：<span>${
            content.target_num || 0
          }</span>`;
          break;
      }

      middle.appendChild(address);
      middle.appendChild(targetNum);
      info.appendChild(middle);

      // 定义底部内容
      let bottom = document.createElement("div");
      bottom.className = "info-bottom";
      bottom.style.position = "relative";
      bottom.style.top = "0px";
      bottom.style.margin = "0 auto";
      let sharp = document.createElement("div");
      sharp.className = "triangle-down";
      bottom.appendChild(sharp);
      info.appendChild(bottom);
      return info;
    },

    getpois(pois) {
      this.edit_markers.position = pois;
      // Message({
      //     type: 'success',
      //     message: '坐标已更新'
      // })
    },
    onSearchResult(pois) {
      this.formapLocation.address = pois[0].address; //获取到位置
      this.formapLocation.location_name = pois[0].name; //获取到位置
      let latSum = 0;
      let lngSum = 0;
      if (pois.length > 0) {
        this.markers2 = [];
        this.edit_markers.position = [];
        //                    pois.forEach(poi => {
        let { lng, lat } = pois[0];
        lngSum += lng;
        latSum += lat;
        this.markers2.push([pois[0].lng, pois[0].lat]);
        this.edit_markers.position = [pois[0].lng, pois[0].lat];

        //                    });
        let center = {
          lng: lngSum, /// pois.length,
          lat: latSum, /// pois.length
        };
        this.mapCenter = [center.lng, center.lat];
        Message({
          type: "success",
          message: "坐标已选取",
        });
      }
    },

    tianjia() {
      this.dialogVisible6 = true;
      this.$refs["HcpAdd"].resetFields();
      this.HcpAdd = {
        title: "",
        name: "",
        sex: "",
        zhiwu: "",
        zhicheng: "",
        phone: "",
        mali: "",
        value1: "",
        hobby: "",
        status: true,
        department: "",
        standard_dept: "",
      };
    },
    xinzeng() {
      this.pushlist = {
        address: "",
        city_id: "",
        city_name: "",
        comments: "",
        institution_grade: "",
        institution_grade_name: "",
        institution_id: "",
        institution_name: "",
        institution_type: "",
        institution_type_name: "",
        lat: 0,
        lng: 0,
        location_id: "",
        postcode: "",
        province_id: "",
        province_name: "",
        status: true,
        agreement_signed: true,
        telephone: "",
        website: "",
        agreement_stage: "",
      };
      this.dialogVisible5 = true;
      this.$refs["pushlist"].resetFields();
    },

    showAmapDialogAction() {
      this.searchStr = "";
      this.showAmapDialog = true;
      this.markers2 = [];

      this.markers2.push([this.institutionObj.lng, this.institutionObj.lat]);
      if (
        parseInt(this.institutionObj.lng) + parseInt(this.institutionObj.lat) ==
        0
      ) {
        this.searchStr = this.institutionObj.address;
      }

      let center = {
        lng: this.institutionObj.lng,
        lat: this.institutionObj.lat,
      };
      this.mapCenter = [center.lng, center.lat];
    },
    handleSaveClick() {
      this.setInstitutionLocation();
      this.showAmapDialog = false;
    },
    closeModal() {
      this.showAmapDialog = false;
    },

    baocun2() {
      this.$refs["pushlist"].validate((valid) => {
        if (!valid) {
          return false;
        } else {
          this.addInstitution();
        }
      });
    },
    quxiao() {
      this.dialogVisible5 = false;
      this.$refs["pushlist"].resetFields();
    },
    handleClickTabs(tab, event) {
      this.tabIndex = tab.index;
    },

    bianji() {
      this.getAdministrativeList();
      this.getProductList();
      this.isfalse = true;
      this.dialogVisible2 = true;
      this.activeName2 = "first";
      this.getCityList(this.insList.province_id);
      this.getItitutionGardeList(this.insList.institution_type);
      this.getImgInfo();
      this.getFilesInfo();
    },
    InstitutionClient(item, j) {
      this.mydiv = j;
      this.marginValue = -(j * 312);
      this.center = [item.lng, item.lat];
    },
    locationLeftBut() {
      if (this.mydiv > 1) {
        this.mydiv = this.mydiv - 1;
        this.marginValue = this.marginValue + 312;
      } else if (this.mydiv == 1 && this.marginValue == 0) {
        this.mydiv = this.mydiv - 1;
        this.marginValue = 0;
      } else if (this.mydiv == 1 && this.marginValue < 0) {
        this.mydiv = this.mydiv - 1;
        this.marginValue = 0;
      }
      this.center = [
        this.locationInfo[this.mydiv].lng,
        this.locationInfo[this.mydiv].lat,
      ];
    },
    locationRightBut() {
      if (this.mydiv < this.locationInfo.length - 1) {
        this.mydiv = this.mydiv + 1;
        this.marginValue = this.marginValue - 312;
      } else {
        this.marginValue = this.marginValue;
      }
      this.center = [
        this.locationInfo[this.mydiv].lng,
        this.locationInfo[this.mydiv].lat,
      ];
    },
    async getLocation() {
      let data = {
        tenant_id: this.$store.getters.getUser.tenant_id,
        reference_id: this.hospitalInstitution_id,
        reference_obj: "INSTITUTION",
      };
      await http.post("/wapi/Institution/getLocation", data).then((res) => {
        if ((res.success = true)) {
          this.locationInfo = res.data;
          this.widthLocation = (this.locationInfo.length + 1) * 350 + "px";
          this.centers = [];
          if (this.locationInfo.length > 0) {
            for (var i = 0; i < this.locationInfo.length; i++) {
              this.center = [res.data[0].lng, res.data[0].lat];
              this.centers.push({
                position: [res.data[i].lng, res.data[i].lat],
                template: `<div style="width: 22px;color:#fff;height: 30px;text-align: center; line-height: 20px; background:url(${imgUrl})">${
                  i + 1
                }</div>`,
              });
            }
          } else {
            this.center = [116.46, 39.92];
            this.centers.length = 0;
            this.edit_markers.position.length = 0;
          }
        }
      });
    },
    async baocunLocation() {
      if (this.formapLocation.location_id) {
        //编辑
        let data = {
          user_id: this.$store.getters.getUser.user_id,
          tenant_id: this.$store.getters.getUser.tenant_id,
          location_name: this.formapLocation.location_name,
          location_id: this.formapLocation.location_id,
          address: this.formapLocation.address,
          status: this.formapLocation.status,
          reference_id: this.hospitalInstitution_id,
          reference_obj: "INSTITUTION",
          lng: this.edit_markers.position[0],
          lat: this.edit_markers.position[1],
        };
        await http.post("/wapi/Institution/setLocation", data).then((res) => {
          if ((res.success = true)) {
            Message({
              type: "success",
              message: "更新成功",
            });
            this.getLocation();
          }
        });
      } else {
        //新增
        let data = {
          user_id: this.$store.getters.getUser.user_id,
          tenant_id: this.$store.getters.getUser.tenant_id,
          location_name: this.formapLocation.location_name,
          address: this.formapLocation.address,
          status: this.formapLocation.status,
          reference_obj: "INSTITUTION",
          reference_id: this.hospitalInstitution_id,
          lng: this.edit_markers.position[0],
          lat: this.edit_markers.position[1],
        };
        await http.post("/wapi/Institution/setLocation", data).then((res) => {
          if ((res.success = true)) {
            Message({
              type: "success",
              message: "保存成功",
            });
            this.mydiv = 0;
            this.getLocation();
          }
        });
      }
    },
    addLocation() {
      this.formapLocation = {
        location_name: "",
        address: "",
        location_id: "",
        status: "INACTIVE",
      };
      this.searchStr = "";
      this.markers2.length = 0;
      this.edit_markers.position.length = 0;
    },
    editorLocation(item) {
      this.markers2.length = 0;
      this.formapLocation = {
        location_name: item.location_name,
        address: item.address,
        location_id: item.location_id,
        status: item.primary == "T" ? "ACTIVE" : "INACTIVE",
      };
      this.mapCenter = [item.lng, item.lat];
      this.markers2.push([item.lng, item.lat]);
      this.edit_markers.position = [item.lng, item.lat];
    },
    updatalist2() {
      this.$refs["insList"].validate((valid) => {
        if (!valid) {
          return false;
        } else {
          this.updateInstitutionDept();
          this.closelist2();
        }
      });
    },
    addinsList() {
      this.$refs["addDeptList"].validate((valid) => {
        if (!valid) {
          return false;
        } else {
          this.addInstitutionDept();
        }
      });
    },
    preserve() {
      this.$refs["HcpAdd"].validate((valid) => {
        if (!valid) {
          return false;
        } else {
          this.addHcp();
        }
      });
    },
    escAction() {
      this.dialogVisible6 = false;
      this.HcpAdd = {};
    },

    baocun1_2() {
      if (this.activeName1 == "first") {
        this.updateHcp();
      } else {
        let off = true;
        if (this.extendedInfo1[this.tabIndex - 1].fieldArray.length > 0) {
          for (
            var i = 0;
            i < this.extendedInfo1[this.tabIndex - 1].fieldArray.length;
            i++
          ) {
            if (
              this.extendedInfo1[this.tabIndex - 1].fieldArray[i].mandatory ==
              "T"
            ) {
              this.$refs["hcplist" + i][0].validate((valid) => {
                if (!valid) {
                  off = false;
                }
              });
            }
          }
          if (off) {
            this.updateExtendedInfo2();
          }
        }
      }
    },

    setInstitutionStatusBySwitch(status) {
      this.setInstitutionStatus(status);
    },
    handleNodeClick(data, node) {
      this.detailsOff = false;
      this.detailsBox = false;
      this.$refs._treeBox.scrollTop = 0;
      this.scope = "single";
      this.loadCount = 0;
      if (node.level === 1) {
        if (data.id === "All") {
          this.scope = data.id;
          amapManager.getMap().setZoomAndCenter(3, [116.46, 39.92]);
        } else {
          this.city_id = "";
          this.province_id = data.id;
          if (data.children.length > 0) {
            this.city_lng = data.children[0].lng;
            this.city_lat = data.children[0].lat;
          }
          if (!data.lng || !data.lat) {
            this.$message.error(
              "该省份暂无坐标信息，请前往行政区划管理进行设置！"
            );
            this.center = [0, 0];
          } else {
            amapManager.getMap().setZoomAndCenter(8, [data.lng, data.lat]);
            // this.zoom = 8
            // this.center = [data.lng, data.lat];
          }
        }
      } else {
        this.province_id = data.province_id;
        this.city_id = data.id;
        this.city_lng = data.lng;
        this.city_lat = data.lat;
        if (!data.lng || !data.lat) {
          this.$message.error(
            "该城市暂无坐标信息，请前往行政区划管理进行设置！"
          );
          this.center = [0, 0];
        } else {
          amapManager.getMap().setZoomAndCenter(10, [data.lng, data.lat]);
          // this.zoom = 10
          // this.center = [data.lng, data.lat];
        }
      }
      // this.city_id = data.id
      this.getEtmsInstituionListAction();

      // if(node.level===1){
      //     this.city_id = ''
      //     this.province_id=data.id
      //     this.getCityList(data.id)
      // }else {
      //     this.city_id=data.id
      //     // this.province_id=data.id
      //     // this.getEtmsInstituionList()
      //
    },
    async handleSelect(item) {
      console.log(item);
      this.detailsBox = false;
      this.detailsOff = false;
      this.filterText = item.name;
      if (this.scope === "All" || this.city_id !== item.city_id) {
        this.scope="single"
        this.province_id = item.province_id;
        this.city_id = item.city_id;
        await this.getEtmsInstituionListAction();
      }
      this.$nextTick(() => {
        this.$refs.tree.setCurrentKey(this.city_id);
        // this.$refs.tree2.setCurrentKey(item.id);
      });

      let marker = this.loadArr.filter((v) => v.id === item.id)[0].marker;

      if (item.type == "INSTITUTION") {
        this.institution_id = item.id;
        this.getMarker(item.id, "INSTITUTION", marker);
      } else if (item.type == "RETAILSTORE") {
        this.store_id = item.id;
        this.getMarker(item.id, "RETAILSTORE", marker);
      } else if (item.type == "DISTRIBUTOR") {
        this.distributor_id = item.id;
        this.getMarker(item.id, "DISTRIBUTOR", marker);
      }
    },
    //节流函数
    throttle(method, delay, duration) {
      var timer = null;
      var begin = new Date();
      return function () {
        var context = this,
          args = arguments;
        var current = new Date();
        clearTimeout(timer);
        if (current - begin >= duration) {
          method.apply(context, args);
          begin = current;
        } else {
          timer = setTimeout(function () {
            method.apply(context, args);
          }, delay);
        }
      };
    },
    loadTreeItem(e) {
      // if (this.scope === "All") {
      let PH = parseInt(getComputedStyle(e.target).height);
      let H = parseInt(getComputedStyle(e.target.firstChild).height) - PH;
      let T = parseInt(e.target.scrollTop);
      if (
        H <= T + 10 &&
        this.loadArr.slice(50 * this.loadCount, 50 * (this.loadCount + 1))
          .length > 0
      ) {
        this.data2 = this.data2.concat(
          this.loadArr.slice(50 * this.loadCount, 50 * (this.loadCount + 1))
        );
        // this.data2.shift()
        // e.target.scrollTop = T - 1
        this.loadCount += 10;
        // }
        // else if ((T - 10 <= 0) && this.loadCount > 0) {
        //     this.data2.pop()
        //     this.data2.unshift(this.loadArr.slice(this.loadCount - 1, this.loadCount)[0])
        //     this.$nextTick(() => {
        //       e.target.scrollTop = T + 1
        //     })
        //     this.loadCount -= 1
        //   }
      }
    },
    handleNodeClick2(data) {
      this.detailsBox = false;
      this.detailsOff = false;
      let marker = data.marker;

      if (!this.city_id) {
        this.$nextTick(() => {
          this.$refs.tree.setCurrentKey(data.city_id);
        });
      }
      if (data.type == "institution") {
        this.institution_id = data.id;
        this.getMarker(data.id, "INSTITUTION", marker);
      } else if (data.type == "store") {
        this.store_id = data.id;
        this.getMarker(data.id, "RETAILSTORE", marker);
      } else if (data.type == "distributor") {
        this.distributor_id = data.id;
        this.getMarker(data.id, "DISTRIBUTOR", marker);
      }
    },
    //监听Marke是否加载
    trackingMarkeL(marker) {
      if (!marker.getMap()) {
        setTimeout(() => {
          this.trackingMarkeL(marker);
        }, 100);
      } else {
        marker.emit("click", { target: marker });
      }
    },
    // 获取坐标
    async getMarker(id, type, marker) {
      this.loading = true;
      infoWindow.close();
      let data = {
        tenant_id: this.$store.getters.getUser.tenant_id,
        reference_obj: type,
        reference_id: id,
      };
      await http.post("/wapi/Institution/getMarker", data).then((res) => {
        if (res.success) {
          this.centers = [];
          if (res.data.length > 0 && !res.data[0].type) {
            // this.center = [res.data[0].lng, res.data[0].lat];
            // this.zoom = 18;

            let map = amapManager.getMap();
            map.setZoomAndCenter(16, [res.data[0].lng, res.data[0].lat]);
            // this.getMapInfo({
            //   extData: {
            //     id: marker.id,
            //     type: (marker.type === "store"
            //       ? "retailstore"
            //       : marker.type
            //     ).toLocaleUpperCase(),
            //     self: this,
            //   },
            //   map: map,
            //   LngLat: [res.data[0].lng, res.data[0].lat],
            // });

            this.trackingMarkeL(marker);

            // this.centers.push({
            //   position: [res.data[0].lng, res.data[0].lat],
            //   template: `<div style="width: 22px;color:#fff;height: 30px;text-align: center;font-size: 12px; line-height: 20px; background:url(${imgUrl})"></div>`,
            //   events: {
            //     click: () => {
            //       this.getMapInfo(id, type)
            //
            //     }
            //   },
            //   visible: true,
            // });
          } else {
            // this.center = [this.city_lng, this.city_lat];
            // this.zoom = 10;

            let map = amapManager.getMap();
            if (res.data[0].type === "city") {
              map.setZoomAndCenter(10, [res.data[0].lng, res.data[0].lat]);
              // this.getMapInfo({
              //   extData: {
              //     id: marker.id,
              //     type: (marker.type === "store"
              //       ? "retailstore"
              //       : marker.type
              //     ).toLocaleUpperCase(),
              //     self: this,
              //   },
              //   map: map,
              //   LngLat: [res.data[0].lng, res.data[0].lat],
              // });
              this.trackingMarkeL(marker);

            } else {
              map.setZoomAndCenter(10, [this.city_lng, this.city_lat]);
              // this.getMapInfo({
              //   extData: {
              //     id: marker.id,
              //     type: (marker.type === "store"
              //       ? "retailstore"
              //       : marker.type
              //     ).toLocaleUpperCase(),
              //     self: this,
              //   },
              //   map: map,
              //   LngLat: [this.city_lng, this.city_lat],
              // });
              this.trackingMarkeL(marker);

            }

            // this.trackingMarkeL(marker);

            // Message({
            //   type: 'error',
            //   message: '暂无坐标'
            // })
          }

          this.loading = false;
        } else {
          this.loading = false;
          Message.error(res.message);
        }
      });
    },
    // getMapInfo(id, type) {
    //   let data = {
    //     tenant_id: this.$store.getters.getUser.tenant_id,
    //     reference_obj: type,
    //     reference_id: id
    //   }
    //   http.post('/wapi/InstitutionClient/getStaffMapList', data).then(res => {
    //     if (res.success) {
    //       this.InstituionList = res.data
    //       this.detailsBox = !this.detailsBox
    //
    //     }
    //
    //   })
    //
    // },
    getMapInfo(e) {
      let ExtData, map, self;
      if (e.target) {
        ExtData = e.target.getExtData();
        map = e.target.getMap();
        self = ExtData.self;
        self.LngLat = e.target.getPosition();
      } else {
        ExtData = e.extData;
        map = e.map;
        self = ExtData.self;
        self.LngLat = e.LngLat;
      }
      let data = {
        tenant_id: this.$store.getters.getUser.tenant_id,
        reference_obj: ExtData.type,
        reference_id: ExtData.id,
      };
      http.post("/wapi/InstitutionClient/getStaffMapList", data).then((res) => {
        if (res.success) {
          let item = res.data[0];
          //实例化信息窗体
          let name =
            item.institution_name ||
            item.store_name ||
            item.distributor_name ||
            "无";

          let content = {
            address: item.address || "无",
            target_num:
              item.target_num || item.clerk_num || item.contact_count || 0,
          };

          infoWindow.setContent(
            self.createInfoWindow.call(self, name, content, item)
          );
          infoWindow.open(map, self.LngLat);
        }
      });
    },
    handleClick(tab, event) {
      this.index = tab.index;
      this.hcpArray = this.deptList[tab.index].hcpArray;
    },
    // addlist() {
    //
    //     var oDiv = document.getElementById("div1");
    //     if (oDiv.style.display == "block") {
    //         oDiv.style.display = "none";
    //     } else {
    //         oDiv.style.display = "block";
    //         this.isDisabled=true
    //     }
    //     var oDiv2 = document.getElementById("div2");
    //     oDiv2.style.display = "none";
    //     this.insList.title=''
    //     this.insList.keshi=''
    // },
    // closelist(){
    //     var oDiv = document.getElementById("div1");
    //     if (oDiv.style.display == "block") {
    //         oDiv.style.display = "none";
    //         this.isDisabled=false
    //     } else {
    //         oDiv.style.display = "block";
    //
    //     }
    // },

    addlist2(item) {
      var oDiv = document.getElementById("div2");
      if (oDiv.style.display == "block") {
        oDiv.style.display = "none";
      } else {
        oDiv.style.display = "block";
        this.isDisabled = true;
      }
      // var oDiv1 = document.getElementById("div1");
      // oDiv1.style.display = "none";

      this.insList.title2 = item.dept_name;
      this.insList.dept_code = item.dept_code;
      this.insList.keshi2 = item.standard_dept;
      this.insList.dept_id = item.dept_id;
      this.old_department = item.dept_name;
    },
    closelist2() {
      var oDiv = document.getElementById("div2");
      if (oDiv.style.display == "block") {
        oDiv.style.display = "none";
        this.isDisabled = false;
      } else {
        oDiv.style.display = "block";
      }
    },
    addlist() {
      (this.dialogVisible4 = true),
        (this.addDeptList = {
          dept_name: "",
          dept_code: "",
          standard_dept: "",
        });
    },
    dianji() {
      this.cluster && this.cluster.clearMarkers();
      this.data2 = null;
      this.loadArr = null;
      Object.assign(this.$data, this.$options.data());
      amapManager.getMap().clearMap();
      amapManager.getMap().destroy();
      this.$router.push({ path: "/clients/index" });
      // window.location.reload()
    },
    dianji1() {
      this.cluster && this.cluster.clearMarkers();
      this.data2 = null;
      this.loadArr = null;
      Object.assign(this.$data, this.$options.data());
      amapManager.getMap().clearMap();
      amapManager.getMap().destroy();
      this.$router.push({ path: "/clients/retail" });
      // window.location.reload()
    },
    dianji2() {
      this.cluster && this.cluster.clearMarkers();
      this.data2 = null;
      this.loadArr = null;
      Object.assign(this.$data, this.$options.data());
      amapManager.getMap().clearMap();
      amapManager.getMap().destroy();
      // this.$router.push({path: '/clients/channel', query: {province_id: this.province_id, city_id: this.city_id,city_lng:this.city_lng,city_lat:this.city_lat}})
      this.$router.push({ path: "/clients/channel" });
      // window.location.reload()
    },
    async getProvinceAndCityList() {
      this.loading = true;
      let data = {
        tenant_id: this.$store.getters.getUser.tenant_id,
      };
      let self = this;
      await http
        .post("/wapi/Province/getProvinceAndCityList", data)
        .then((res) => {
          this.loading = false;
          if (res.success) {
            self.data = res.data;
            self.data.unshift({
              id: "All",
              label: "全国数据",
              lat: "39.904179",
              lng: "116.407387",
              children: [],
            });
            if (!parseFloat(this.city_lng)) {
              this.city_lng = res.data[0].children[0].lng;
              this.city_lat = res.data[0].children[0].lat;
            }

            if (!this.city_id) {
              let province = res.data.filter(
                (v) => v.id === this.province_id
              )[0];
              this.$nextTick(() => {
                this.$refs.tree.setCurrentKey(province.id);
              });

              if (!province.lng || !province.lat) {
                this.$message.error(
                  "该省份暂无坐标信息，请前往行政区划管理进行设置！"
                );
                this.center = [0, 0];
              } else {
                this.center = [province.lng, province.lat];
                this.zoom = 8;
              }
            } else {
              let city = res.data
                .filter((v) => v.id === this.province_id)[0]
                .children.filter((v) => v.id === this.city_id)[0];
              if (!city.lng || !city.lat) {
                this.$message.error(
                  "该城市暂无坐标信息，请前往行政区划管理进行设置！"
                );
                this.center = [0, 0];
              } else {
                this.center = [city.lng, city.lat];
                this.zoom = 10;
              }
            }
            // this.getEtmsInstituionList()
          } else {
            Message.error(res.message);
          }
        });
    },

    async getCityList(a) {
      let data = {
        province_id: a,
        tenant_id: this.$store.getters.getUser.tenant_id,
      };
      let self = this;
      await http.post("/wapi/City/getCityList", data).then((res) => {
        if (res.success) {
          self.CityList = res.data;
        } else {
          Message.error(res.message);
        }
      });
    },
    fangfa(a) {
      this.pushlist.city_id = "";
      this.insList.city_id = "";
      this.getCityList(a);
    },

    filterNode(value, data) {
      //                if (!value) return true;
      //                return data.label.indexOf(value) !== -1;
    },

    async getInstitutionInfo2(institution_id) {
      this.index = "";

      let data = {
        tenant_id: this.$store.getters.getUser.tenant_id,
        institution_id: institution_id,
      };

      let self = this;
      await http
        .post("/wapi/Institution/getInstitutionInfo", data)
        .then((res) => {
          if (res.success) {
            var oDiv = document.getElementById("div3");
            var oDiv4 = document.getElementById("div4Action");
            if (oDiv.style.display == "block") {
              oDiv.style.display = "block";
            } else {
              oDiv.style.display = "block";
              oDiv4.style.display = "none";
            }
            self.institution_id = res.data[0].institution_id;
            self.institutionObj.institution_name = res.data[0].institution_name;
            self.institutionObj.address = res.data[0].address;
            self.institutionObj.city_id = res.data[0].city_id;
            self.institutionObj.city_name = res.data[0].city_name;
            self.institutionObj.institution_type_name =
              res.data[0].institution_type_name;
            self.institutionObj.institution_type = res.data[0].institution_type;
            self.institutionObj.telephone = res.data[0].telephone;
            self.institutionObj.website = res.data[0].website;
            self.institutionObj.institution_grade =
              res.data[0].institution_grade;
            self.institutionObj.institution_grade_name =
              res.data[0].institution_grade_name;
            self.institutionObj.province_id = res.data[0].province_id;
            self.institutionObj.province_name = res.data[0].province_name;
            self.institutionObj.status = res.data[0].status;
            self.institutionObj.postcode = res.data[0].postcode;
            self.institutionObj.lat = res.data[0].lat;
            self.institutionObj.lng = res.data[0].lng;
            self.institutionObj.location_id = res.data[0].location_id;
            self.institutionObj.institution_id = res.data[0].institution_id;
            self.institutionObj.institution_code = res.data[0].institution_code;
            this.hospitalInstitution_id = res.data[0].institution_id;

            self.insList.address = res.data[0].address;
            self.insList.distributor_id = res.data[0].distributor_id;
            self.insList.city_id = res.data[0].city_id;
            self.insList.city_name = res.data[0].city_name;
            self.insList.comments = res.data[0].comments;
            self.insList.institution_grade = res.data[0].institution_grade;
            self.insList.institution_grade_name =
              res.data[0].institution_grade_name;
            self.insList.institution_id = res.data[0].institution_id;
            self.insList.institution_name = res.data[0].institution_name;
            self.insList.institution_type = res.data[0].institution_type;
            self.insList.institution_type_name =
              res.data[0].institution_type_name;
            self.insList.lat = res.data[0].lat;
            self.insList.lng = res.data[0].lng;
            self.insList.location_id = res.data[0].location_id;
            self.insList.postcode = res.data[0].postcode;
            self.insList.province_id = res.data[0].province_id;
            self.insList.province_name = res.data[0].province_name;
            self.insList.telephone = res.data[0].telephone;
            self.insList.website = res.data[0].website;
            self.insList.institution_code = res.data[0].institution_code;
            self.insList.agreement_stage = res.data[0].agreement_stage;

            self.institution_name = res.data[0].institution_name;
            self.address = res.data[0].address;
            self.location_id = res.data[0].location_id;

            this.center = [res.data[0].lng, res.data[0].lat];

            if (res.data[0].agreement_signed == "T") {
              self.insList.agreement_signed = true;
            } else {
              self.insList.agreement_signed = false;
            }

            if (res.data[0].status == "ACTIVE") {
              self.insList.status = true;
            } else {
              self.insList.status = false;
            }

            if (self.institutionObj.status == "ACTIVE") {
              self.institutionStatus = true;
            } else {
              self.institutionStatus = false;
            }
            this.$nextTick(() => {
              // treeBox 元素的ref   value 绑定的node-key
              this.$refs.tree2.setCurrentKey(this.institution_id);
              let num = 0;
              for (let i = 0; i < this.data2.length; i++) {
                if (this.data2[i].id === this.institution_id) {
                  num = i;
                  break;
                }
              }

              let top = 40 * num;
              let constrution_tree = document.querySelectorAll(
                ".constrution-tree2"
              );
              constrution_tree[0].scrollTop = top;
            });
            this.getLocation();
            this.getInstitutionDeptList();
            this.getProList();
            this.getJobtList();
            this.getDeptList();
            this.getStandardDeptList();
            this.getExtendedInfo();
          } else {
            Message.error(res.message);
          }
        });
    },

    async setInstitutionStatus(status) {
      let data = {
        tenant_id: this.$store.getters.getUser.tenant_id,
        institution_id: this.institution_id,
        status: status,
        user_id: this.$store.getters.getUser.user_id,
      };

      let self = this;
      await http
        .post("/wapi/Institution/setInstitutionStatus", data)
        .then((res) => {
          if (res.success) {
          } else {
            Message.error(res.message);
          }
        });
    },

    async getProList() {
      let data = {
        tenant_id: this.$store.getters.getUser.tenant_id,
      };

      let self = this;
      await http.post("/wapi/Institution/getProList", data).then((res) => {
        if (res.success) {
          self.prolist = res.data;
        } else {
          Message.error(res.message);
        }
      });
    },

    async getJobtList() {
      let data = {
        tenant_id: this.$store.getters.getUser.tenant_id,
      };

      let self = this;
      await http.post("/wapi/Institution/getJobtList", data).then((res) => {
        if (res.success) {
          self.jobtList = res.data;
        } else {
          Message.error(res.message);
        }
      });
    },

    async getDeptList() {
      let data = {
        tenant_id: this.$store.getters.getUser.tenant_id,
        institution_id: this.institution_id,
      };

      let self = this;
      await http.post("/wapi/Institution/getDeptList", data).then((res) => {
        if (res.success) {
          self.departments = res.data;
        } else {
          Message.error(res.message);
        }
      });
    },

    async updateHcp() {
      let status = "";
      if (this.Hcplist.institutionStatus == true) {
        status = "ACTIVE";
      } else {
        status = "INACTIVE";
      }

      let gender = "";
      if (this.Hcplist.gender == "男") {
        gender = "M";
      } else {
        gender = "F";
      }
      let speaker = "";
      if (this.Hcplist.speaker == true) {
        speaker = "T";
      } else {
        speaker = "F";
      }

      let kol = "";
      if (this.Hcplist.kol == true) {
        kol = "T";
      } else {
        kol = "F";
      }

      let data = {
        tenant_id: this.$store.getters.getUser.tenant_id,
        institution_id: this.institution_id,
        user_id: this.$store.getters.getUser.user_id,
        hcp_id: this.Hcplist.hcp_id,
        hcp_code: this.Hcplist.hcp_code,
        hcp_name: this.Hcplist.name,
        gender: this.Hcplist.sex,
        job_title_id: this.Hcplist.zhiwu,
        pro_title_id: this.Hcplist.zhicheng,
        mobile: this.Hcplist.phone,
        email: this.Hcplist.mali,
        birthday: this.Hcplist.value1,
        hobby: this.Hcplist.hobby,
        status: status,
        specialties:
          this.Hcplist.specialties == null ? "" : this.Hcplist.specialties,
        consulting_hours:
          this.Hcplist.consulting_hours == null
            ? ""
            : this.Hcplist.consulting_hours,
        education: this.Hcplist.education == null ? "" : this.Hcplist.education,
        fellowships:
          this.Hcplist.fellowships == null ? "" : this.Hcplist.fellowships,
        speaker: speaker,
        speaker_level:
          this.Hcplist.speaker_level == null ? "" : this.Hcplist.speaker_level,
        kol: kol,
        kol_level: this.Hcplist.kol_level == null ? "" : this.Hcplist.kol_level,
        department: this.Hcplist.department,
        standard_dept: this.Hcplist.standard_dept,
      };
      for (let i = 0; i < this.administrative.length; i++) {
        let obj = this.administrative[i];
        if (this.Hcplist.standard_dept == obj.key) {
          this.selectDeptId = obj.dept_id;
        }
      }
      data.dept_id = this.selectDeptId;
      //                let self = this
      await http.post("/wapi/Institution/updateHcp", data).then((res) => {
        if (res.success) {
          this.insdialogVisible2 = false;
        } else {
          Message.error(res.message);
        }
      });
    },

    async addHcp() {
      let status = "";
      if (this.HcpAdd.status == true) {
        status = "ACTIVE";
      } else {
        status = "INACTIVE";
      }
      let speaker = "";
      if (this.HcpAdd.speaker == true) {
        speaker = "T";
      } else {
        speaker = "F";
      }

      let kol = "";
      if (this.HcpAdd.kol == true) {
        kol = "T";
      } else {
        kol = "F";
      }

      let data = {
        tenant_id: this.$store.getters.getUser.tenant_id,
        institution_id: this.institution_id,
        hcp_code: this.HcpAdd.hcp_code,
        hcp_name: this.HcpAdd.name,
        gender: this.HcpAdd.sex == null ? "" : this.HcpAdd.sex,
        birthday: this.HcpAdd.value1 == null ? "" : this.HcpAdd.value1,
        hobby: this.HcpAdd.hobby == null ? "" : this.HcpAdd.hobby,
        email: this.HcpAdd.mali == null ? "" : this.HcpAdd.mali,
        mobile: this.HcpAdd.phone == null ? "" : this.HcpAdd.phone,
        status: status,
        user_id: this.$store.getters.getUser.user_id,
        job_title_id: this.HcpAdd.zhiwu == null ? "" : this.HcpAdd.zhiwu,
        pro_title_id: this.HcpAdd.zhicheng == null ? "" : this.HcpAdd.zhicheng,

        specialties:
          this.HcpAdd.specialties == null ? "" : this.HcpAdd.specialties,
        consulting_hours:
          this.HcpAdd.consulting_hours == null
            ? ""
            : this.HcpAdd.consulting_hours,
        education: this.HcpAdd.education == null ? "" : this.HcpAdd.education,
        fellowships:
          this.HcpAdd.fellowships == null ? "" : this.HcpAdd.fellowships,
        speaker: speaker,
        speaker_level:
          this.HcpAdd.speaker_level == null ? "" : this.HcpAdd.speaker_level,
        kol: kol,
        kol_level: this.HcpAdd.kol_level == null ? "" : this.HcpAdd.kol_level,
        department: this.HcpAdd.department,
        standard_dept: this.HcpAdd.standard_dept,
        dept_id: this.selectDeptId,
      };

      let self = this;
      await http.post("/wapi/Institution/addHcp", data).then((res) => {
        if (res.success) {
          //                        self.departments=res.data
          self.getInstitutionDeptList();
          this.dialogVisible6 = false;
        } else {
          Message.error(res.message);
          this.dialogVisible6 = true;
        }
      });
    },
    async getStandardDeptList() {
      let data = {
        tenant_id: this.$store.getters.getUser.tenant_id,
      };

      let self = this;
      await http
        .post("/wapi/Institution/getStandardDeptList", data)
        .then((res) => {
          if (res.success) {
            self.administrative = res.data;
          } else {
            Message.error(res.message);
          }
        });
    },

    async addInstitutionDept() {
      let data = {
        tenant_id: this.$store.getters.getUser.tenant_id,
        institution_id: this.institution_id,
        user_id: this.$store.getters.getUser.user_id,
        dept_name: this.addDeptList.dept_name,
        dept_code: this.addDeptList.dept_code,
        standard_dept: this.addDeptList.standard_dept,
      };

      //                let self = this
      await http
        .post("/wapi/Institution/addInstitutionDept", data)
        .then((res) => {
          if (res.success) {
            //                        self.administrative=res.data
            this.getInstitutionDeptList();
            this.getDeptList();
            this.dialogVisible4 = false;
          } else {
            Message.error(res.message);
            this.dialogVisible4 = true;
          }
        });
    },

    async updateInstitutionDept() {
      // let data={
      //     tenant_id:this.$store.getters.getUser.tenant_id,
      //     institution_id:this.institution_id,
      //     user_id:this.$store.getters.getUser.user_id,
      //     dept_name:this.insList.title2,
      //     dept_code:this.insList.dept_code,
      //     standard_dept:this.insList.keshi2,
      //     dept_id:this.insList.dept_id
      //
      // }
      let data = {
        tenant_id: this.$store.getters.getUser.tenant_id,
        institution_id: this.institution_id,
        user_id: this.$store.getters.getUser.user_id,
        old_department: this.old_department,
        department: this.insList.title2,
      };

      //                let self = this
      await http
        .post("/wapi/Institution/updateInstitutionDept", data)
        .then((res) => {
          if (res.success) {
            //                        self.administrative=res.data
            this.getInstitutionDeptList();
          } else {
            Message.error(res.message);
          }
        });
    },

    async getItitutionGardeList(b) {
      let data = {
        tenant_id: this.$store.getters.getUser.tenant_id,
        key: b,
      };

      let self = this;
      await http
        .post("/wapi/Institution/getItitutionGardeList", data)
        .then((res) => {
          if (res.success) {
            self.GardeList = res.data;
          } else {
            Message.error(res.message);
          }
        });
    },

    async updateInstitution() {
      const loading = this.$loading({
        lock: true,
        text: "拼命加载中",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      });
      let status = "";
      if (this.insList.status == true) {
        status = "ACTIVE";
      } else {
        status = "INACTIVE";
      }

      let status2 = "";
      if (this.insList.agreement_signed == true) {
        status2 = "T";
      } else {
        status2 = "F";
      }
      let data = {
        tenant_id: this.$store.getters.getUser.tenant_id,
        institution_code: this.insList.institution_code,
        institution_id: this.institution_id,
        institution_name: this.insList.institution_name,
        institution_type: this.insList.institution_type,
        institution_grade: this.insList.institution_grade_name,
        province_id: this.insList.province_id,
        city_id: this.insList.city_id,
        address: this.insList.address,
        telephone: this.insList.telephone,
        postcode: this.insList.postcode,
        website: this.insList.website,
        distributor_id: this.insList.distributor_id,
        comments: this.insList.comments,
        user_id: this.$store.getters.getUser.user_id,
        // agreement_signed:status2,
        // agreement_stage:this.insList.agreement_stage,
        status: status,
      };
      //                let self = this
      await http
        .post("/wapi/Institution/updateInstitution", data)
        .then((res) => {
          if (res.success) {
            //                        self.CityList=res.data

            this.getInstitutionInfo();
            Message({
              type: "success",
              message: "保存成功",
            });
            this.insdialogVisible = false;
            loading.close();
          } else {
            Message.error(res.message);
            this.insdialogVisible = true;
            loading.close();
          }
        });
    },

    async addInstitution() {
      let status = "";
      if (this.pushlist.status == true) {
        status = "ACTIVE";
      } else {
        status = "INACTIVE";
      }
      let status2 = "";
      if (this.pushlist.agreement_signed == true) {
        status2 = "T";
      } else {
        status2 = "F";
      }

      let data = {
        tenant_id: this.$store.getters.getUser.tenant_id,
        institution_name: this.pushlist.institution_name,
        institution_type: this.pushlist.institution_type,
        institution_grade: this.pushlist.institution_grade,
        institution_code: this.pushlist.institution_code,
        province_id: this.pushlist.province_id,
        city_id: this.pushlist.city_id,
        address: this.pushlist.address,
        telephone: this.pushlist.telephone,
        postcode: this.pushlist.postcode,
        website: this.pushlist.website,
        distributor_id: this.insList.distributor_id,
        comments: this.pushlist.comments,
        // agreement_stage:this.pushlist.agreement_stage,
        // agreement_signed:status2,
        user_id: this.$store.getters.getUser.user_id,
        status: status,
      };
      //                let self = this
      await http.post("/wapi/Institution/addInstitution", data).then((res) => {
        if (res.success) {
          this.institution_id = res.data[0].institution_id;
          this.province_id = res.data[0].province_id;
          this.city_id = res.data[0].city_id;

          // treeBox 元素的ref   value 绑定的node-key
          this.$refs.tree.setCurrentKey(this.city_id);
          this.getEtmsInstituionListAction();
          this.getInstitutionInfo(this.institution_id);

          var oDiv = document.getElementById("div3");
          var oDiv4 = document.getElementById("div4Action");
          if (oDiv.style.display == "block") {
            oDiv.style.display = "block";
          } else {
            oDiv.style.display = "block";
            oDiv4.style.display = "none";
          }

          this.dialogVisible5 = false;
        } else {
          Message.error(res.message);
          this.dialogVisible5 = true;
        }
      });
    },

    async setInstitutionLocation() {
      //                Message(this.edit_markers.position.length)
      //
      //                Message(this.edit_markers.position[0])
      //                Message(this.edit_markers.position[1])

      let data = {
        tenant_id: this.$store.getters.getUser.tenant_id,
        institution_id: this.institution_id,
        institution_name: this.institution_name,
        address: this.address,
        location_id: this.location_id,
        lat: this.edit_markers.position[1],
        lng: this.edit_markers.position[0],
        user_id: this.$store.getters.getUser.user_id,
      };

      await http
        .post("/wapi/Institution/setInstitutionLocation", data)
        .then((res) => {
          if (res.success) {
            this.getInstitutionInfo();
          } else {
            Message.error(res.message);
          }
        });
    },
    //专家级别
    async getDictionaryListBySPEAKER_LEVEL() {
      let data = {
        tenant_id: this.$store.getters.getUser.tenant_id,
        category: "SPEAKER_LEVEL",
      };
      let self = this;
      await http
        .post("/wapi/v1/getDictionaryListByCategory", data)
        .then((res) => {
          if (res.success) {
            self.ByCategory = res.data;
          } else {
            Message.error(res.message);
          }
          this.dialogVisible4 = false;
        });
    },
    //KOL级别
    async getDictionaryListByKOL_LEVEL() {
      let data = {
        tenant_id: this.$store.getters.getUser.tenant_id,
        category: "KOL_LEVEL",
      };
      let self = this;
      await http
        .post("/wapi/v1/getDictionaryListByCategory", data)
        .then((res) => {
          if (res.success) {
            self.KOL_LEVELByCategory = res.data;
          } else {
            Message.error(res.message);
          }
          this.dialogVisible4 = false;
        });
    },

    // 获取扩展信息选项表
    // async getExtendedList(item){
    //     let data={
    //         tenant_id:this.$store.getters.getUser.tenant_id,
    //         dictionary:item.dictionary
    //     }
    //     await http.post('/wapi/Institution/getExtendedList',data).then(res =>{
    //
    //         if (res.success) {
    //             console.log(res.data,666)
    //
    //
    //         }else {
    //             Message.error(res.message);
    //
    //         }
    //     })
    // },
    async getExtendedInfo() {
      this.loading = true;
      let data = {
        tenant_id: this.$store.getters.getUser.tenant_id,
        institution_id: this.institution_id,
      };
      await http.post("/wapi/Institution/getExtendedInfo", data).then((res) => {
        if (res.success) {
          this.extendedInfo = res.data;
          if (this.extendedInfo.length > 0) {
            for (let i = 0; i < this.extendedInfo.length; i++) {
              this.extendedInfo[i].fieldArray.forEach((item) => {
                if (
                  item.input_type === "LIST" &&
                  item.multiple === "T" &&
                  item.field_value.indexOf("|") == -1 &&
                  item.field_value !== ""
                ) {
                  item.field_value = [item.field_value];
                }
                if (
                  item.input_type === "LIST" &&
                  item.field_value.indexOf("|") !== -1
                ) {
                  item.field_value = item.field_value.split("|");
                }
                if (
                  item.input_type === "LIST" &&
                  item.multiple === "T" &&
                  item.field_value === ""
                ) {
                  item.field_value = [];
                }
                if (item.input_type === "TABLE" && item.field_value !== "") {
                  item.field_value = JSON.parse(item.field_value);
                }
                if (item.input_type === "TABLE" && item.field_value === "") {
                  item.field_value = [];
                }
                if (
                  item.input_type === "TRUE-FALSE" &&
                  item.field_value === ""
                ) {
                  item.field_value = "F";
                }
              });
            }
          }

          this.loading = false;
          this.insdialogVisible = true;
        } else {
          Message.error(res.message);
          this.loading = false;
        }
      });
    },
    async updateExtendedInfo() {
      let data = {
        tenant_id: this.$store.getters.getUser.tenant_id,
        user_id: this.$store.getters.getUser.user_id,
        institution_id: this.institution_id,
        ExtensionArray: this.extendedInfo[this.tabIndex - 1].fieldArray,
      };
      await http.post("/wapi/Institution/setExtendedList", data).then((res) => {
        if (res.success) {
          Message({
            type: "success",
            message: "保存成功",
          });

          this.insdialogVisible = false;
          this.isfalse = false;
          this.extendedInfo[this.tabIndex - 1].fieldArray = [];
        } else {
          Message.error(res.message);
          this.insdialogVisible = false;
        }
      });
    },

    async getExtendedInfo2() {
      this.loading = true;
      let data = {
        tenant_id: this.$store.getters.getUser.tenant_id,
        hcp_id: this.hcp_id,
      };
      await http
        .post("/wapi/Institution/getExtendedHcpInfo", data)
        .then((res) => {
          if (res.success) {
            this.extendedInfo1 = res.data;
            console.log(res.data);
            if (this.extendedInfo1.length > 0) {
              for (let i = 0; i < this.extendedInfo1.length; i++) {
                this.extendedInfo1[i].fieldArray.forEach((item) => {
                  if (
                    item.input_type === "LIST" &&
                    item.multiple === "T" &&
                    item.field_value.indexOf("|") == -1 &&
                    item.field_value !== ""
                  ) {
                    item.field_value = [item.field_value];
                  }
                  if (
                    item.input_type === "LIST" &&
                    item.field_value.indexOf("|") !== -1
                  ) {
                    item.field_value = item.field_value.split("|");
                  }
                  if (
                    item.input_type === "LIST" &&
                    item.multiple === "T" &&
                    item.field_value === ""
                  ) {
                    item.field_value = [];
                  }
                  if (item.input_type === "TABLE" && item.field_value !== "") {
                    item.field_value = JSON.parse(item.field_value);
                  }
                  if (item.input_type === "TABLE" && item.field_value === "") {
                    item.field_value = [];
                  }
                  if (
                    item.input_type === "TRUE-FALSE" &&
                    item.field_value === ""
                  ) {
                    item.field_value = "F";
                  }
                });
              }
            }

            this.loading = false;
            this.insdialogVisible2 = true;
          } else {
            Message.error(res.message);
            this.loading = false;
          }
        });
    },
    handleClose() {},
    async updateExtendedInfo2() {
      let data = {
        tenant_id: this.$store.getters.getUser.tenant_id,
        user_id: this.$store.getters.getUser.user_id,
        hcp_id: this.hcp_id,
        institution_id: this.institution_id,
        ExtensionArray: this.extendedInfo1[this.tabIndex - 1].fieldArray,
      };
      await http
        .post("/wapi/Institution/setExtendedHcpList", data)
        .then((res) => {
          if (res.success) {
            Message({
              type: "success",
              message: "保存成功",
            });
            this.insdialogVisible2 = false;
            this.isfalse = false;
            this.extendedInfo1[this.tabIndex - 1].fieldArray = [];
          } else {
            Message.error(res.message);
          }
        });
    },
    changeInstitution() {
      for (var i = 0; i < this.dataList.length; i++) {
        if (this.form.name == this.dataList[i].id) {
          this.institutionData_name =
            "机构数据（" + this.dataList[i].label + "）";
        }
      }
    },
    changeInstitution1() {
      for (var i = 0; i < this.dataList.length; i++) {
        if (this.form.position == this.dataList[i].id) {
          this.institutionData_location =
            "签到数据（" + this.dataList[i].label + "）";
        }
      }
    },
    changeInstitution2() {
      for (var i = 0; i < this.dataList.length; i++) {
        if (this.form.title == this.dataList[i].id) {
          this.institutionData_hcp =
            "HCP数据（" + this.dataList[i].label + "）";
        }
      }
    },
    clickExtension() {
      this.isAddTable = false;
      this.dialogVisible2 = false;
      this.isDetail = false;
      this.photoIdArray = [];
      this.imgArray = [];
      setTimeout(() => {
        this.isfalse = false;
      }, 100);
    },
    guanbi1_2() {
      this.isAddTable = false;
      this.insdialogVisible2 = false;
      this.isDetail1 = false;
      this.photoIdArray1 = [];
      this.imgArray1 = [];
    },
    openDetail() {
      this.isDetail = true;
      this.type = "add";
      this.categoryAgenda = {
        reference_obj: "CLIENT",
        reference_id: "com.saasyun.android",
        credential: "0a4da4e6-e36a-4e78-b4fc-78bb62aa9ff4",
        tenant_id: this.$store.getters.getUser.tenant_id,
        username: this.$store.getters.getUser.username,
        user_id: this.$store.getters.getUser.user_id,
        event_obj: "INSTITUTION",
        event_id: this.insList.institution_id,
        category: "PICTURE",
        data: this.uuidAgenda,
      };
      this.tags = [];
    },
    openDetail2_1() {
      this.isDetail = true;
      this.type = "add";
      this.categoryAgenda = {
        reference_obj: "CLIENT",
        reference_id: "com.saasyun.android",
        credential: "0a4da4e6-e36a-4e78-b4fc-78bb62aa9ff4",
        tenant_id: this.$store.getters.getUser.tenant_id,
        username: this.$store.getters.getUser.username,
        user_id: this.$store.getters.getUser.user_id,
        event_obj: "RETAILSTORE",
        event_id: this.storelist.store_id,
        category: "PICTURE",
        data: this.uuidAgenda,
      };
      this.tags = [];
    },
    tagClose(tag) {
      this.tags.splice(this.tags.indexOf(tag), 1);
      this.editTags.push(tag);
    },
    getUuidAgenda() {
      var s = [];
      var hexDigits = "0123456789abcdef";

      for (var i = 0; i < 36; i++) {
        s[i] = hexDigits.substr(Math.floor(Math.random() * 0x10), 1);
      }
      s[14] = "4"; // bits 12-15 of the time_hi_and_version field to 0010
      s[19] = hexDigits.substr((s[19] & 0x3) | 0x8, 1); // bits 6-7 of the clock_seq_hi_and_reserved to 01
      s[8] = s[13] = s[18] = s[23] = "-";

      var uuid = s.join("");
      this.uuidAgenda = uuid;
    },
    beforeUpload(file) {
      if (/\.(jpg|png|jpeg)$/.test(file.name)) {
        this.$refs["photoUpload"].submit();
      } else {
        this.$message({
          type: "error",
          message: "图片格式只能为jpg/png/jpeg",
        });
      }
    },
    getPhotoIdAgenda(res, file, fileList) {
      // console.log(res,111)
      let num = this.imgArray.length;
      if (num == 0) {
        this.photoIdObj.sort = 1;
      } else {
        this.photoIdObj.sort = num + 1;
      }
      this.photoIdObj.photo_id = res.data.s3filename;
      this.photoIdArray.push({
        photo_id: this.photoIdObj.photo_id,
        sort: this.photoIdObj.sort,
      });
    },
    async submitPhoto() {
      const loading = this.$loading({
        lock: true,
        text: "拼命加载中",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      });
      try {
        let data = {
          institution_id: this.insList.institution_id,
          tenant_id: this.$store.getters.getUser.tenant_id,
          user_id: this.$store.getters.getUser.user_id,
          photoIdArray: this.photoIdArray,
          type: this.type,
          tags: this.tags,
          deleteTags: this.editTags,
          selectPhotoId: this.selectPhotoId,
        };
        await http.post("/wapi/Institution/addPhoto", data).then((res) => {
          if (res.data.success) {
            this.imgArray = [];
            this.getImgInfo();
            loading.close();
          }
        });
        this.$refs.photoUpload.clearFiles();
        this.tags = [];
        this.editTags = [];
        this.photoIdArray = [];
      } catch (e) {}
    },
    addTag() {
      if (this.tagText) {
        var s = [];
        var hexDigits = "0123456789abcdef";

        for (var i = 0; i < 36; i++) {
          s[i] = hexDigits.substr(Math.floor(Math.random() * 0x10), 1);
        }
        s[14] = "4"; // bits 12-15 of the time_hi_and_version field to 0010
        s[19] = hexDigits.substr((s[19] & 0x3) | 0x8, 1); // bits 6-7 of the clock_seq_hi_and_reserved to 01
        s[8] = s[13] = s[18] = s[23] = "-";

        var uuid = s.join("");
        let tagObj = {};
        tagObj.text = this.tagText;
        tagObj.id = uuid;
        if (this.type == "add") {
          tagObj.type = "add";
        } else if (this.type == "edit") {
          tagObj.type = "addEdit";
        }
        this.tags.push(tagObj);
        this.tagText = "";
      }
    },
    async getImgInfo() {
      try {
        let data = {
          tenant_id: this.$store.getters.getUser.tenant_id,
          institution_id: this.insList.institution_id,
          user_id: this.$store.getters.getUser.user_id,
        };
        await http.post("/wapi/Institution/getImgInfo", data).then((res) => {
          if (res.data) {
            this.photo_id_arr = res.data;
            this.getImgUrl();
          }
        });
      } catch (e) {
        return e;
      }
    },
    async getImgUrl() {
      try {
        this.imgArray = [];
        for (let i = 0; i < this.photo_id_arr.length; i++) {
          let obj = this.photo_id_arr[i];
          let data = {
            reference_obj: "INSTITUTION",
            reference_id: "com.saasyun.android",
            credential: "0a4da4e6-e36a-4e78-b4fc-78bb62aa9ff4",
            photo_ids: obj.photo_id,
            tenant_id: this.$store.getters.getUser.tenant_id,
          };
          let res = await http.post("/photos/downloadphotos", data);

          this.imgArray.push({
            url: res.data[0].url,
            photo_id: res.data[0].photoid,
            tag: obj.tag,
          });
        }
      } catch (err) {
        console.log(`error:${err}`);
      }
    },
    closeDetail() {
      this.isDetail = false;
      this.editTags = [];
    },
    editPhoto(item) {
      this.isDetail = true;
      this.tags = JSON.parse(JSON.stringify(item.tag));
      for (let i = 0; i < item.tag.length; i++) {
        let obj = item.tag[i];
        obj.type = "update";
      }
      this.type = "edit";
      this.selectPhotoId = item.photo_id;
    },
    openDetail3_1() {
      this.isDetail = true;
      this.type = "add";
      this.categoryAgenda = {
        reference_obj: "CLIENT",
        reference_id: "com.saasyun.android",
        credential: "0a4da4e6-e36a-4e78-b4fc-78bb62aa9ff4",
        tenant_id: this.$store.getters.getUser.tenant_id,
        username: this.$store.getters.getUser.username,
        user_id: this.$store.getters.getUser.user_id,
        event_obj: "DISTRIBUTOR",
        event_id: this.distributorlist.distributor_id,
        category: "PICTURE",
        data: this.uuidAgenda,
      };
      this.tags = [];
    },
    async submitPhoto3_1() {
      const loading = this.$loading({
        lock: true,
        text: "拼命加载中",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      });
      try {
        let data = {
          distributor_id: this.distributorlist.distributor_id,
          tenant_id: this.$store.getters.getUser.tenant_id,
          user_id: this.$store.getters.getUser.user_id,
          photoIdArray: this.photoIdArray,
          type: this.type,
          tags: this.tags,
          deleteTags: this.editTags,
          selectPhotoId: this.selectPhotoId,
        };
        await http.post("/wapi/Distributor/addPhoto", data).then((res) => {
          if (res.data.success) {
            this.imgArray = [];
            this.getDisImgInfo();
            loading.close();
          }
        });
        this.$refs.photoUpload.clearFiles();
        this.tags = [];
        this.editTags = [];
        this.photoIdArray = [];
      } catch (e) {}
    },
    async submitPhoto2_1() {
      const loading = this.$loading({
        lock: true,
        text: "拼命加载中",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      });
      try {
        let data = {
          store_id: this.storelist.store_id,
          tenant_id: this.$store.getters.getUser.tenant_id,
          user_id: this.$store.getters.getUser.user_id,
          photoIdArray: this.photoIdArray,
          type: this.type,
          tags: this.tags,
          deleteTags: this.editTags,
          selectPhotoId: this.selectPhotoId,
        };
        await http.post("/wapi/Retailstore/addPhoto", data).then((res) => {
          if (res.data.success) {
            this.imgArray = [];
            this.getStoreImgInfo();
            loading.close();
          }
        });
        this.$refs.photoUpload.clearFiles();
        this.tags = [];
        this.editTags = [];
        this.photoIdArray = [];
      } catch (e) {}
    },
    async deletePhoto() {
      const loading = this.$loading({
        lock: true,
        text: "拼命加载中",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      });
      try {
        let data = {
          photo_id: this.selectPhotoId,
          institution_id: this.insList.institution_id,
          tenant_id: this.$store.getters.getUser.tenant_id,
          user_id: this.$store.getters.getUser.user_id,
        };
        await http.post("/wapi/Institution/deletePhoto", data).then((res) => {
          if (res.data.success) {
            this.getImgInfo();
            this.tags = [];
            loading.close();
          }
        });
      } catch (e) {
        return e;
      }
    },
    change(e) {
      this.$forceUpdate();
    },

    openDetail1() {
      this.isDetail1 = true;
      this.type = "add";
      this.categoryAgenda1 = {
        reference_obj: "CLIENT",
        reference_id: "com.saasyun.android",
        credential: "0a4da4e6-e36a-4e78-b4fc-78bb62aa9ff4",
        tenant_id: this.$store.getters.getUser.tenant_id,
        username: this.$store.getters.getUser.username,
        user_id: this.$store.getters.getUser.user_id,
        event_obj: "HCP",
        event_id: this.Hcplist.hcp_id,
        category: "PICTURE",
        data: this.uuidAgenda1,
      };
      this.tags1 = [];
    },
    tagClose1(tag) {
      this.tags1.splice(this.tags1.indexOf(tag), 1);
      this.editTags1.push(tag);
    },
    getUuidAgenda1() {
      var s = [];
      var hexDigits = "0123456789abcdef";

      for (var i = 0; i < 36; i++) {
        s[i] = hexDigits.substr(Math.floor(Math.random() * 0x10), 1);
      }
      s[14] = "4"; // bits 12-15 of the time_hi_and_version field to 0010
      s[19] = hexDigits.substr((s[19] & 0x3) | 0x8, 1); // bits 6-7 of the clock_seq_hi_and_reserved to 01
      s[8] = s[13] = s[18] = s[23] = "-";

      var uuid = s.join("");
      this.uuidAgenda1 = uuid;
    },
    beforeUpload1(file) {
      if (/\.(jpg|png|jpeg)$/.test(file.name)) {
        this.$refs["photoUpload1"].submit();
      } else {
        this.$message({
          type: "error",
          message: "图片格式只能为jpg/png/jpeg",
        });
      }
    },
    getPhotoIdAgenda1(res, file, fileList) {
      // console.log(res,111)
      let num = this.imgArray1.length;
      if (num == 0) {
        this.photoIdObj1.sort = 1;
      } else {
        this.photoIdObj1.sort = num + 1;
      }
      this.photoIdObj1.photo_id = res.data.s3filename;
      this.photoIdArray1.push({
        photo_id: this.photoIdObj1.photo_id,
        sort: this.photoIdObj1.sort,
      });
    },
    async submitPhoto1() {
      const loading = this.$loading({
        lock: true,
        text: "拼命加载中",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      });
      try {
        let data = {
          hcp_id: this.Hcplist.hcp_id,
          institution_id: this.insList.institution_id,
          tenant_id: this.$store.getters.getUser.tenant_id,
          user_id: this.$store.getters.getUser.user_id,
          photoIdArray: this.photoIdArray1,
          type: this.type,
          tags: this.tags1,
          deleteTags: this.editTags1,
          selectPhotoId: this.selectPhotoId1,
        };
        await http.post("/wapi/Institution/AddHcpPhoto", data).then((res) => {
          if (res.data.success) {
            this.imgArray1 = [];
            this.getImgInfo1();
            loading.close();
          }
        });
        this.$refs.photoUpload1.clearFiles();
        this.tags1 = [];
        this.editTags1 = [];
        this.photoIdArray1 = [];
      } catch (e) {}
    },
    addTag1() {
      if (this.tagText1) {
        var s = [];
        var hexDigits = "0123456789abcdef";

        for (var i = 0; i < 36; i++) {
          s[i] = hexDigits.substr(Math.floor(Math.random() * 0x10), 1);
        }
        s[14] = "4"; // bits 12-15 of the time_hi_and_version field to 0010
        s[19] = hexDigits.substr((s[19] & 0x3) | 0x8, 1); // bits 6-7 of the clock_seq_hi_and_reserved to 01
        s[8] = s[13] = s[18] = s[23] = "-";

        var uuid = s.join("");
        let tagObj = {};
        tagObj.text = this.tagText1;
        tagObj.id = uuid;
        if (this.type == "add") {
          tagObj.type = "add";
        } else if (this.type == "edit") {
          tagObj.type = "addEdit";
        }
        this.tags1.push(tagObj);
        this.tagText1 = "";
      }
    },
    async getImgInfo1() {
      try {
        let data = {
          tenant_id: this.$store.getters.getUser.tenant_id,
          institution_id: this.insList.institution_id,
          hcp_id: this.Hcplist.hcp_id,
          user_id: this.$store.getters.getUser.user_id,
        };
        await http.post("/wapi/Institution/getHcpImgInfo", data).then((res) => {
          if (res.data) {
            this.photo_id_arr1 = res.data;
            this.getImgUrl1();
          }
        });
      } catch (e) {
        return e;
      }
    },
    async getImgUrl1() {
      try {
        this.imgArray1 = [];
        for (let i = 0; i < this.photo_id_arr1.length; i++) {
          let obj = this.photo_id_arr1[i];
          let data = {
            reference_obj: "HCP",
            reference_id: "com.saasyun.android",
            credential: "0a4da4e6-e36a-4e78-b4fc-78bb62aa9ff4",
            photo_ids: obj.photo_id,
            tenant_id: this.$store.getters.getUser.tenant_id,
          };
          let res = await http.post("/photos/downloadphotos", data);

          this.imgArray1.push({
            url: res.data[0].url,
            photo_id: res.data[0].photoid,
            tag: obj.tag,
          });
        }
      } catch (err) {
        console.log(`error:${err}`);
      }
    },
    closeDetail1() {
      this.isDetail1 = false;
      this.editTags1 = [];
    },
    editPhoto1(item) {
      this.isDetail1 = true;
      this.tags1 = JSON.parse(JSON.stringify(item.tag));
      for (let i = 0; i < item.tag.length; i++) {
        let obj = item.tag[i];
        obj.type = "update";
      }
      this.type = "edit";
      this.selectPhotoId1 = item.photo_id;
    },
    async deletePhoto1() {
      const loading = this.$loading({
        lock: true,
        text: "拼命加载中",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      });
      try {
        let data = {
          photo_id: this.selectPhotoId1,
          institution_id: this.insList.institution_id,
          hcp_id: this.Hcplist.hcp_id,
          tenant_id: this.$store.getters.getUser.tenant_id,
          user_id: this.$store.getters.getUser.user_id,
        };
        await http.post("/wapi/Institution/deleteHcpPhoto", data).then((res) => {
          if (res.data.success) {
            this.getImgInfo1();
            this.tags1 = [];
            loading.close();
          }
        });
      } catch (e) {
        return e;
      }
    },
    getUrl() {
      // return "/files/uploadfile?tenant_id=" + this.$store.getters.getUser.tenant_id;
      return (
        "/files/uploadfile?tenant_id=" +
        this.$store.getters.getUser.tenant_id +
        "&reference_id=com.saasyun.android&user_id=" +
        this.$store.getters.getUser.user_id
      );
      // return "http://192.168.10.26:15028/uploadfile?tenant_id="
      //     + this.$store.getters.getUser.tenant_id+"&reference_id=com.saasyun.android&user_id="+this.$store.getters.getUser.user_id;
    },
    openFileDetail() {
      this.fileDetail = true;
      this.type = "add";
      this.fileTags = [];
    },
    beforeFileUpload(file) {
      //console.log(file,111)
      let fileName = file.name;
      let pos = fileName.lastIndexOf(".");
      let lastName = fileName.substring(pos, fileName.length);
      let size = file.size / 1024 / 1024;
      this.fileInfo.file_name = file.name;
      this.fileInfo.extension = file.name.split(".")[1];
      this.fileInfo.file_type = file.type;
      this.fileInfo.file_size = file.size;
      let num = this.fileTable.length;
      if (num == 0) {
        this.fileInfo.sort = 1;
      } else {
        this.fileInfo.sort = num + 1;
      }
      if (lastName === ".png" || lastName === ".jpg" || lastName === ".jpeg") {
        this.fileInfo.type = "PICTURE";
        if (size > 20) {
          this.error("上传图片大小不能超过 20MB!");
          return false;
        }
      } else if (lastName === ".mp4") {
        this.fileInfo.type = "VIDEO";
        if (size > 300) {
          this.error("上传视频大小不能超过 300MB!");
          return false;
        }
      } else if (lastName === ".mp3") {
        this.fileInfo.type = "AUDIO";
        if (size > 50) {
          this.error("上传音频大小不能超过 50MB!");
          return false;
        }
      } else if (lastName === ".pptx" || lastName === ".ppt") {
        this.fileInfo.type = "SLIDE";
        if (size > 50) {
          this.error("上传PPT大小不能超过 50MB!");
          return false;
        }
      } else if (
        lastName === ".pdf" ||
        lastName === ".doc" ||
        lastName === ".docx" ||
        lastName === ".txt" ||
        lastName === ".html"
      ) {
        this.fileInfo.type = "DOCUMENT";
        if (size > 50) {
          this.error("上传文档大小不能超过 50MB!");
          return false;
        }
      } else {
        this.error("暂不支持当前格式的文件!");
        return false;
      }
    },
    async fileSuccess(res, file, fileList) {
      const loading = this.$loading({
        lock: true,
        text: "拼命加载中",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      });
      this.fileInfo.fileId = res.data.s3filename;
      if (res.success) {
        this.$refs.uploadFile.clearFiles();
        //console.log(this.fileInfo,123)
        try {
          let data = {
            institution_id: this.insList.institution_id,
            tenant_id: this.$store.getters.getUser.tenant_id,
            user_id: this.$store.getters.getUser.user_id,
            fileInfo: this.fileInfo,
            category: "INSTITUTION",
            type: this.type,
            tags: this.fileTags,
            deleteTags: this.editTags,
            selectFileId: this.selectFileId,
          };
          await http.post("/wapi/Institution/addFile", data).then((res) => {
            if (res.data.success) {
              this.getFilesInfo();
              this.fileTags = [];
              this.editTags = [];
              this.fileInfo = {};
              loading.close();
            }
          });
        } catch (e) {
          return e;
        }
      }
    },
    async getFilesInfo() {
      try {
        let data = {
          tenant_id: this.$store.getters.getUser.tenant_id,
          institution_id: this.insList.institution_id,
          user_id: this.$store.getters.getUser.user_id,
        };
        await http.post("/wapi/Institution/getFilesInfo", data).then((res) => {
          if (res.success) {
            this.fileTable = res.data;
            let numObj = {
              imgNum: 0,
              slideNum: 0,
              mp4Num: 0,
              docNum: 0,
              restsNum: 0,
            };
            for (let i = 0; i < this.fileTable.length; i++) {
              let obj = this.fileTable[i];
              obj.file_name = obj.file_name.split(".")[0];
              if (obj.category == "PICTURE") {
                numObj.imgNum++;
              } else if (obj.category == "VIDEO") {
                numObj.mp4Num++;
              } else if (obj.category == "SLIDE") {
                numObj.slideNum++;
              } else if (obj.category == "DOCUMENT") {
                numObj.docNum++;
              } else {
                numObj.restsNum++;
              }
            }
            this.statistics = numObj;
          }
        });
      } catch (e) {
        return e;
      }
    },
    async submitFiles() {
      this.$refs.uploadFile.submit();
      if (this.type == "edit") {
        const loading = this.$loading({
          lock: true,
          text: "拼命加载中",
          spinner: "el-icon-loading",
          background: "rgba(0, 0, 0, 0.7)",
        });
        try {
          let data = {
            institution_id: this.insList.institution_id,
            tenant_id: this.$store.getters.getUser.tenant_id,
            user_id: this.$store.getters.getUser.user_id,
            fileInfo: this.fileInfo,
            category: "INSTITUTION",
            type: this.type,
            tags: this.fileTags,
            deleteTags: this.editTags,
            selectFileId: this.selectFileId,
          };
          await http.post("/wapi/Institution/addFile", data).then((res) => {
            if (res.data.success) {
              this.getFilesInfo();
              this.fileTags = [];
              this.editTags = [];
              this.fileInfo = {};
              loading.close();
            }
          });
        } catch (e) {
          return e;
        }
      }
    },
    editFile(index, row) {
      this.fileDetail = true;
      this.fileTags = JSON.parse(JSON.stringify(row.tag));
      for (let i = 0; i < row.tag.length; i++) {
        let obj = row.tag[i];
        obj.type = "update";
      }
      this.type = "edit";
      this.selectFileId = row.file_id;
    },
    async deleteFile() {
      const loading = this.$loading({
        lock: true,
        text: "拼命加载中",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      });
      try {
        let data = {
          file_id: this.selectFileId,
          institution_id: this.insList.institution_id,
          tenant_id: this.$store.getters.getUser.tenant_id,
          user_id: this.$store.getters.getUser.user_id,
        };
        await http.post("/wapi/Institution/deleteFile", data).then((res) => {
          if (res.data.success) {
            this.getFilesInfo();
            this.fileTags = [];
            loading.close();
          }
        });
      } catch (e) {
        return e;
      }
    },
    addFileTag() {
      if (this.fileTag) {
        var s = [];
        var hexDigits = "0123456789abcdef";

        for (var i = 0; i < 36; i++) {
          s[i] = hexDigits.substr(Math.floor(Math.random() * 0x10), 1);
        }
        s[14] = "4"; // bits 12-15 of the time_hi_and_version field to 0010
        s[19] = hexDigits.substr((s[19] & 0x3) | 0x8, 1); // bits 6-7 of the clock_seq_hi_and_reserved to 01
        s[8] = s[13] = s[18] = s[23] = "-";
        var uuid = s.join("");
        let tagObj = {};
        tagObj.text = this.fileTag;
        tagObj.id = uuid;
        if (this.type == "add") {
          tagObj.type = "add";
        } else if (this.type == "edit") {
          tagObj.type = "addEdit";
        }
        this.fileTags.push(tagObj);
        console.log(this.fileTags, 666);
        this.fileTag = "";
      }
    },
    fileTagClose(tag) {
      this.fileTags.splice(this.fileTags.indexOf(tag), 1);
      this.editTags.push(tag);
    },
    closeFileDetail() {
      this.fileDetail = !this.fileDetail;
      this.editTags = [];
      this.fileTags = [];
    },
    async submitFiles2() {
      this.$refs.uploadFile.submit();
      if (this.type == "edit") {
        const loading = this.$loading({
          lock: true,
          text: "拼命加载中",
          spinner: "el-icon-loading",
          background: "rgba(0, 0, 0, 0.7)",
        });
        try {
          let data = {
            store_id: this.storelist.store_id,
            tenant_id: this.$store.getters.getUser.tenant_id,
            user_id: this.$store.getters.getUser.user_id,
            fileInfo: this.fileInfo,
            category: "RETAILSTORE",
            type: this.type,
            tags: this.fileTags,
            deleteTags: this.editTags,
            selectFileId: this.selectFileId,
          };
          await http.post("/wapi/Retailstore/addFile", data).then((res) => {
            if (res.data.success) {
              this.getFilesInfo2();
              this.fileTags = [];
              this.editTags = [];
              this.fileInfo = {};
              loading.close();
            }
          });
        } catch (e) {
          return e;
        }
      }
    },
    async submitFiles3() {
      this.$refs.uploadFile.submit();
      if (this.type == "edit") {
        const loading = this.$loading({
          lock: true,
          text: "拼命加载中",
          spinner: "el-icon-loading",
          background: "rgba(0, 0, 0, 0.7)",
        });
        try {
          let data = {
            distributor_id: this.distributorlist.distributor_id,
            tenant_id: this.$store.getters.getUser.tenant_id,
            user_id: this.$store.getters.getUser.user_id,
            fileInfo: this.fileInfo,
            category: "DISTRIBUTOR",
            type: this.type,
            tags: this.fileTags,
            deleteTags: this.editTags,
            selectFileId: this.selectFileId,
          };
          await http.post("/wapi/Distributor/addFile", data).then((res) => {
            if (res.data.success) {
              this.getFilesInfo3();
              this.fileTags = [];
              this.editTags = [];
              this.fileInfo = {};
              loading.close();
            }
          });
        } catch (e) {
          return e;
        }
      }
    },
    async getFilesInfo2() {
      try {
        let data = {
          tenant_id: this.$store.getters.getUser.tenant_id,
          store_id: this.storelist.store_id,
          user_id: this.$store.getters.getUser.user_id,
        };
        await http.post("/wapi/Retailstore/getFilesInfo", data).then((res) => {
          if (res.success) {
            this.fileTable = res.data;
            let numObj = {
              imgNum: 0,
              slideNum: 0,
              mp4Num: 0,
              docNum: 0,
              restsNum: 0,
            };
            for (let i = 0; i < this.fileTable.length; i++) {
              let obj = this.fileTable[i];
              obj.file_name = obj.file_name.split(".")[0];
              if (obj.category == "PICTURE") {
                numObj.imgNum++;
              } else if (obj.category == "VIDEO") {
                numObj.mp4Num++;
              } else if (obj.category == "SLIDE") {
                numObj.slideNum++;
              } else if (obj.category == "DOCUMENT") {
                numObj.docNum++;
              } else {
                numObj.restsNum++;
              }
            }
            this.statistics = numObj;
          }
        });
      } catch (e) {
        return e;
      }
    },
    async getFilesInfo3() {
      try {
        let data = {
          tenant_id: this.$store.getters.getUser.tenant_id,
          distributor_id: this.distributorlist.distributor_id,
          user_id: this.$store.getters.getUser.user_id,
        };
        await http.post("/wapi/Distributor/getFilesInfo", data).then((res) => {
          if (res.success) {
            this.fileTable = res.data;
            let numObj = {
              imgNum: 0,
              slideNum: 0,
              mp4Num: 0,
              docNum: 0,
              restsNum: 0,
            };
            for (let i = 0; i < this.fileTable.length; i++) {
              let obj = this.fileTable[i];
              obj.file_name = obj.file_name.split(".")[0];
              if (obj.category == "PICTURE") {
                numObj.imgNum++;
              } else if (obj.category == "VIDEO") {
                numObj.mp4Num++;
              } else if (obj.category == "SLIDE") {
                numObj.slideNum++;
              } else if (obj.category == "DOCUMENT") {
                numObj.docNum++;
              } else {
                numObj.restsNum++;
              }
            }
            this.statistics = numObj;
          }
        });
      } catch (e) {
        return e;
      }
    },
    getFileSize(num) {
      let size_text;
      size_text = (parseInt(num) / 1024).toFixed(0); //kb
      if (size_text >= 1024) {
        size_text = (size_text / 1024).toFixed(0); //mb

        size_text = size_text + "MB";
      } else {
        size_text = size_text + "KB";
      }

      return size_text;
    },
    isFileType(type) {
      switch (type) {
        case "PICTURE":
          return "图片";
          break;
        case "AUDIO":
          return "音频";
          break;
        case "VIDEO":
          return "视频";
          break;
        case "SLIDE":
          return "幻灯片";
          break;
        case "DOCUMENT":
          return "文档";
          break;
      }
    },
    async downloadFile(row) {
      try {
        this.loading = true;
        let Body = new FormData();
        Body.append("credential", "58f09f86-694c-472d-bb63-64f9be093fd2");
        Body.append("file_ids", row.file_id);
        Body.append("tenant_id", this.$store.getters.getUser.tenant_id);
        Body.append("reference_obj", "CLIENT");
        Body.append("reference_id", "com.saasyun.android");
        var config = {
          headers: {
            "Content-Type": "multipart/form-data; boundary====0xKhTmLbOuNdArY",
          },
        }; //添加请求头
        await http
          .post("/files/downloadfiles", Body, config) //
          .then((response) => {
            if (response.success) {
              downloadFile(response.data[0].url);
              this.loading = false;
            }
          });
      } catch (err) {
        this.loading = false;
      }
    },
    async fileSuccess1(res, file, fileList) {
      this.fileInfo.fileId = res.data.s3filename;
      if (res.success) {
        this.$refs.uploadFile1.clearFiles();
        //console.log(this.fileInfo,123)
        try {
          let data = {
            institution_id: this.insList.institution_id,
            hcp_id: this.Hcplist.hcp_id,
            tenant_id: this.$store.getters.getUser.tenant_id,
            user_id: this.$store.getters.getUser.user_id,
            fileInfo: this.fileInfo,
            category: "HCP",
            type: this.type,
            tags: this.fileTags,
            deleteTags: this.editTags,
            selectFileId: this.selectFileId,
          };
          await http.post("/wapi/Institution/addHcpFile", data).then((res) => {
            if (res.data.success) {
              this.getFilesInfo1();
              this.fileTags = [];
              this.editTags = [];
              this.fileInfo = {};
            }
          });
        } catch (e) {
          return e;
        }
      }
    },
    async getFilesInfo1() {
      try {
        let data = {
          tenant_id: this.$store.getters.getUser.tenant_id,
          institution_id: this.insList.institution_id,
          hcp_id: this.Hcplist.hcp_id,
          user_id: this.$store.getters.getUser.user_id,
        };
        await http
          .post("/wapi/Institution/getHcpFilesInfo", data)
          .then((res) => {
            if (res.success) {
              this.fileTable1 = res.data;
              let numObj = {
                imgNum: 0,
                slideNum: 0,
                mp4Num: 0,
                docNum: 0,
                restsNum: 0,
              };
              for (let i = 0; i < this.fileTable1.length; i++) {
                let obj = this.fileTable1[i];
                obj.file_name = obj.file_name.split(".")[0];
                if (obj.category == "PICTURE") {
                  numObj.imgNum++;
                } else if (obj.category == "VIDEO") {
                  numObj.mp4Num++;
                } else if (obj.category == "SLIDE") {
                  numObj.slideNum++;
                } else if (obj.category == "DOCUMENT") {
                  numObj.docNum++;
                } else {
                  numObj.restsNum++;
                }
              }
              this.statistics1 = numObj;
            }
          });
      } catch (e) {
        return e;
      }
    },
    async submitFiles1() {
      this.$refs.uploadFile1.submit();
      if (this.type == "edit") {
        const loading = this.$loading({
          lock: true,
          text: "拼命加载中",
          spinner: "el-icon-loading",
          background: "rgba(0, 0, 0, 0.7)",
        });
        try {
          let data = {
            institution_id: this.insList.institution_id,
            hcp_id: this.Hcplist.hcp_id,
            tenant_id: this.$store.getters.getUser.tenant_id,
            user_id: this.$store.getters.getUser.user_id,
            fileInfo: this.fileInfo,
            category: "HCP",
            type: this.type,
            tags: this.fileTags,
            deleteTags: this.editTags,
            selectFileId: this.selectFileId,
          };
          await http.post("/wapi/Institution/addHcpFile", data).then((res) => {
            if (res.data.success) {
              this.getFilesInfo1();
              this.fileTags = [];
              this.editTags = [];
              this.fileInfo = {};
              loading.close();
            }
          });
        } catch (e) {
          return e;
        }
      }
    },
    async deleteFile1() {
      const loading = this.$loading({
        lock: true,
        text: "拼命加载中",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      });
      try {
        let data = {
          file_id: this.selectFileId,
          institution_id: this.insList.institution_id,
          hcp_id: this.Hcplist.hcp_id,
          tenant_id: this.$store.getters.getUser.tenant_id,
          user_id: this.$store.getters.getUser.user_id,
        };
        await http.post("/wapi/Institution/deleteHcpFile", data).then((res) => {
          if (res.data.success) {
            this.getFilesInfo1();
            this.fileTags = [];
            loading.close();
          }
        });
      } catch (e) {
        return e;
      }
    },
  },
  updated() {},
};
const downloadFile = (url) => {
  const iframe = document.createElement("iframe");
  iframe.style.display = "none"; // 防止影响页面
  iframe.style.height = 0; // 防止影响页面
  iframe.src = url;
  document.body.appendChild(iframe); // 这一行必须，iframe挂在到dom树上才会发请求
  // 5分钟之后删除（onload方法对于下载链接不起作用，就先抠脚一下吧）
  setTimeout(() => {
    iframe.remove();
  }, 1 * 60 * 1000);
};
</script>
<style lang="scss" module>
.container {
  padding-top: 20px;
  padding-right: 20px;
  padding-left: 20px;
  padding-bottom: 20px;
  background: #fff;
  height: 100%;
  box-sizing: border-box;

  .left {
    font-size: 18px;
    margin-top: -40px;
    color: #000000;

    .search {
      width: 97%;
    }

    .type {
      em {
        color: #d98f2f;
        font-size: 14px;
      }
    }

    .first {
      color: #555555;
      font-size: 14px;
    }

    .font {
      margin-left: 10px;
      line-height: 20px;
      font-size: 14px;
      color: #555555;
      position: relative;
    }
  }

  .right {
    margin-top: -20px;
    width: 100%;

    .header {
      width: 100%;
      padding-bottom: 21px;

      margin-top: 20px;
    }

    .body {
      margin-top: 10px;
    }
  }
}
</style>
<style scoped>
.shrinkage {
  z-index: 9;
  top: 50%;
  position: absolute;
  right: -20px;
  margin-top: -40px;
  height: 80px;
  width: 20px;
  background-color: #ababab;
  border-radius: 0 4px 4px 0;
  color: #fff;
  font-size: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 1px 1px 3px #3e3d3d;
  cursor: pointer;
}

.search-box >>> .search-box-wrapper .search-btn {
  display: none;
}

.search-box >>> .search-box-wrapper input {
  width: 20px;
  background: url("../../assets/images/Search_Icon@.png") no-repeat;
  background-size: 20px 20px;
  background-position: right;
  margin-right: 10px;
}

.amap >>> .el-vue-search-box-container {
  width: 100%;
  box-shadow: none;
  border: 1px solid #ededed;
}

.tableClass >>> .el-tabs__header {
  margin: 0;
}

.tableClass >>> .el-tabs__content {
  height: calc(100% - 37px);
}

.amap >>> .el-form-item__label {
  font-size: 14px;
  color: #000;
  text-align: left;
  font-weight: bold;
}

/*.treeClass >>> .el-tree-node__expand-icon{*/
/*display: none;*/
/*}*/
.Myinput >>> .el-input__inner {
  text-align: center;
  width: 96%;
  height: 30px;
  background-color: #ededed;
  border: #ededed 1px solid;
  margin: 5px;
}

.Myinput {
  border-bottom: 1px solid #ededed;
  height: 41px;
}

.subjectList >>> .el-form-item__label {
  font-size: 14px;
  color: #000000;
  text-align: left;
  padding-left: 20px;
  font-weight: bolder;
}

.HcpClass >>> .el-form-item__label {
  font-size: 14px;
  color: #000000;
  text-align: left;
  padding-left: 20px;
  font-weight: bold;
}

.DianClass >>> .el-form-item__label {
  font-size: 14px;
  color: #000000;
  text-align: left;
  padding-left: 20px;
  font-weight: bold;
}

.HcpClass1 >>> .el-form-item__label {
  font-size: 14px;
  color: #000000;
  text-align: left;
  padding-left: 20px;
  font-weight: bold;
}

.SizeClass >>> .el-scrollbar__wrap {
  overflow-x: hidden;
}

.SizeClass >>> .el-tree-node:focus > .el-tree-node__content {
  background-color: #d8f6ee;
}

.SizeClass >>> .el-tree-node__content {
  height: 40px;
  line-height: 40px;
}

.SizeClass2 >>> .el-tree-node__content {
  height: 40px;
  line-height: 40px;
  border: none;
}

.arraylist >>> .el-tabs__item {
  font-size: 14px;
}

.arraylist >>> .el-table .cell {
  font-size: 14px;
}

.MapLable >>> .el-form-item__label {
  font-size: 14px;
  text-align: left;
  color: #000;
}

.upload {
  width: 120px;
  height: 120px;
  border: 1px dashed #ccc;
  border-radius: 5px;
  position: relative;
  display: inline-block;
  /*top:-15px;*/
}

.d1 {
  width: 30px;
  height: 1px;
  background-color: #000;
  position: absolute;
  left: 38%;
  top: 50%;
}

.d2 {
  width: 1px;
  height: 30px;
  background-color: #000;
  position: absolute;
  left: 50%;
  top: 38%;
}

.imgInfo {
  display: inline-block;
  margin-left: 10px;
  /*margin-top: 25px;*/
}

.imgInfo >>> .el-tag {
  height: 25px;
  line-height: 25px;
  border-radius: 5px;
}

.photoDetail {
  width: 100%;
  height: 300px;
  background-color: #eaf1fb;
  margin-top: 20px;
  border-radius: 5px;
}

.photoDetail >>> .button {
  width: 50px;
  height: 25px;
  padding: 3px;
  font-size: 8px;
}

.photoDetail >>> .el-upload-dragger {
  width: 300px;
  height: 160px;
}

.photoDetail >>> .el-input__inner {
  width: 300px;
}

.photoDetail >>> .el-tag {
  margin-left: 10px;
  margin-top: 10px;
}

.photoDetail >>> .el-tag .el-tag__close {
  color: white;
}

.photoDetail >>> .el-tag .el-tag__close:hover {
  background-color: #da9ee6;
}

.file >>> .el-input__inner {
  width: 250px;
}
</style>
<style>
#div1 {
}

#div2 {
  display: none;
}

#div3 {
  display: none;
  margin-left: 15px;
}

#div4Action {
  margin: 0 auto;
  margin-top: 250px;
  text-align: center;
}

.headerStyle1 > div {
  font-size: 14px;
  color: #585757;
  font-weight: bold;
}

.headerStyle1:nth-last-of-type(2) > div {
  color: #4a90e2;
}

/*#div4{*/
/*height:calc(100% - 100px);*/
/*overflow-y: auto;*/
/*}*/
.clearfix:after {
  /*伪元素是行内元素 正常浏览器清除浮动方法*/
  content: "";
  display: block;
  height: 0;
  clear: both;
  visibility: hidden;
}

.clearfix {
  *zoom: 1; /*ie6清除浮动的方式 *号只有IE6-IE7执行，其他浏览器不执行*/
}

.headerStyle > div {
  font-size: 14px;
  color: #585757;
  font-weight: bold;
}

#staff_home .el-table .cell {
  white-space: pre-line;
}

#staff_home .el-table_2_column_15 {
  color: #3b99f7;
}

#staff_home .el-table th > .cell {
  font-weight: bold;
}

/*---------坐标框样式-------------------*/

#staffAmap .content-window-card {
  position: relative;
  box-shadow: none;
  bottom: 0;
  left: 0;
  width: auto;
  padding: 0;
}

#staffAmap .content-window-card p {
  margin: 0;
}

#staffAmap .custom-info {
  /*border: solid 1px silver;*/
  border-radius: 5px;
  box-sizing: border-box;
  padding: 10px 20px;
  background-color: #fff;
  box-shadow: 0 1px 2px #b9b9b9;
}

#staffAmap div.info-top {
  position: relative;
  background: none repeat scroll 0 0 #fff;
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 22px;
  /*border-bottom: 1px solid #CCC;*/
  /*border-radius: 5px 5px 0 0;*/
}

#staffAmap div.info-top div {
  display: inline-block;
  color: #4d586d;
  font-size: 14px;
  font-weight: bold;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  /*line-height: 30px;*/
}

#staffAmap div.info-top img {
  position: absolute;
  top: 10px;
  right: 10px;
  transition-duration: 0.25s;
}

#staffAmap div.info-top span {
  font-size: 12px;
  color: #ff9901;
  cursor: pointer;
  flex-shrink: 0;
  transition-duration: 0.25s;
}

#staffAmap div.info-top img:hover {
  box-shadow: 0 0 5px #000;
}

#staffAmap div.info-top span:hover {
  opacity: 0.8;
}

#staffAmap div.info-middle {
  font-size: 12px;
}

#staffAmap div.info-middle p.address {
  color: #b0b5b9;
  height: 24px;
}

#staffAmap div.info-middle p.target-num {
  color: #7ed321;
  height: 12px;
}

#staffAmap div.info-bottom {
  height: 0;
  width: 100%;
  clear: both;
  text-align: center;
}

#staffAmap div.info-bottom img {
  position: relative;
  z-index: 104;
}

#staffAmap div.info-bottom .triangle-down {
  position: absolute;
  bottom: -18px;
  left: 50%;
  margin-left: -8px;
  border-left: 8px solid transparent;
  border-right: 8px solid transparent;
  border-top: 8px solid #fff;
}

#staffAmap div.info-bottom .triangle-down::after {
  position: absolute;
  content: "";
  margin-left: -8px;
  margin-top: -7px;
  border-left: 8px solid transparent;
  border-right: 8px solid transparent;
  border-top: 8px solid #8c8c8c;
  filter: blur(2px);
  z-index: -1;
}

#staffAmap span {
  margin-left: 5px;
  font-size: 11px;
}

#staffAmap .info-middle img {
  float: left;
  margin-right: 6px;
}

/*----------------------------*/
.el-table__fixed-header-wrapper .el-table thead {
  color: #909399;
  font-weight: 500;
}

#addTable .el-form-item__error {
  margin-left: 112px;
}

#addTable >>> .el-form-item__label {
  font-size: 14px;
  color: #000000;
  text-align: left;
  padding-left: 20px;
  font-weight: bold;
}

#addTableHcp .el-form-item__error {
  margin-left: 112px;
}

#addTableHcp >>> .el-form-item__label {
  font-size: 14px;
  color: #000000;
  text-align: left;
  padding-left: 20px;
  font-weight: bold;
}
</style>
<style scoped>
.amap-demo {
  height: 500px;
  /*margin-top: 20px;*/
}

#institutionCustomer >>> .institution_star label:after {
  content: "*";
  color: #f56c6c;
  margin-left: 4px;
}
</style>





// WEBPACK FOOTER //
// src/pages/staff/staffMap.vue